/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A date string with format `Y-m-d`, e.g. `2011-05-23`. */
  Date: { input: any; output: any };
  /** A datetime string with format `Y-m-d H:i:s`, e.g. `2018-05-23 13:43:32`. */
  DateTime: { input: any; output: any };
  /** A datetime and timezone string in ISO 8601 format `Y-m-dTH:i:sO`, e.g. `2020-04-20T13:53:12+02:00`. */
  DateTimeTz: { input: any; output: any };
  /** Can be used as an argument to upload files using https://github.com/jaydenseric/graphql-multipart-request-spec */
  Upload: { input: any; output: any };
};

export type AccountResponse = {
  __typename?: "AccountResponse";
  account_year: Maybe<Scalars["String"]["output"]>;
  currency: Maybe<Scalars["String"]["output"]>;
  layer_limit: Maybe<Scalars["String"]["output"]>;
  quarter: Maybe<Scalars["String"]["output"]>;
  quarters: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  surpluses: Maybe<Array<Maybe<AccountResponseDepth>>>;
  treaty_id: Maybe<Scalars["ID"]["output"]>;
};

export type AccountResponseDepth = {
  __typename?: "AccountResponseDepth";
  cash_loss: Maybe<Scalars["Float"]["output"]>;
  claim_settled: Maybe<Scalars["Float"]["output"]>;
  gross_premium: Maybe<Scalars["Float"]["output"]>;
};

export type ActivityFilter = {
  city: InputMaybe<Scalars["String"]["input"]>;
  country: InputMaybe<Scalars["String"]["input"]>;
  date_from: InputMaybe<Scalars["DateTime"]["input"]>;
  date_to: InputMaybe<Scalars["DateTime"]["input"]>;
  device_type: InputMaybe<Scalars["String"]["input"]>;
  region: InputMaybe<Scalars["String"]["input"]>;
};

export type ApproveOfferParticipantInput = {
  offer_published_participant_id: Scalars["ID"]["input"];
};

export type AssignCedant = {
  __typename?: "AssignCedant";
  assignedBy: Maybe<Employee>;
  cedants: Maybe<Scalars["String"]["output"]>;
};

export type Attachment = {
  files: Array<Scalars["String"]["input"]>;
  offer_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type AttachmentUrls = {
  __typename?: "AttachmentURLS";
  file_name: Maybe<Scalars["String"]["output"]>;
  file_path: Maybe<Scalars["String"]["output"]>;
};

export type AuthPayload = {
  __typename?: "AuthPayload";
  access_token: Maybe<Scalars["String"]["output"]>;
  expires_in: Maybe<Scalars["Int"]["output"]>;
  refresh_token: Maybe<Scalars["String"]["output"]>;
  token_type: Maybe<Scalars["String"]["output"]>;
  user: Maybe<User>;
};

export type AutoFacConfig = {
  __typename?: "AutoFacConfig";
  auto_fac_config_id: Maybe<Scalars["Int"]["output"]>;
  auto_fac_participants: Maybe<Array<Maybe<AutoFacParticipant>>>;
  employee: Maybe<Employee>;
  name: Maybe<Scalars["String"]["output"]>;
};

export type AutoFacConfigurationInput = {
  employee_id: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
};

export type AutoFacParticipant = {
  __typename?: "AutoFacParticipant";
  auto_fac_config: Maybe<AutoFacConfig>;
  auto_fac_deduction: Maybe<AutoFacParticipantDeductions>;
  auto_fac_participant_id: Maybe<Scalars["Int"]["output"]>;
  employee: Maybe<Employee>;
  reinsurer: Maybe<Reinsurer>;
  share_percentage: Maybe<Scalars["Float"]["output"]>;
};

export type AutoFacParticipantDeductionInput = {
  auto_fac_participant_id: Scalars["ID"]["input"];
  brokerage: Scalars["Float"]["input"];
  commission: Scalars["Float"]["input"];
  employee_id: Scalars["ID"]["input"];
  nic: Scalars["Float"]["input"];
  overrider: InputMaybe<Scalars["Float"]["input"]>;
  wht: Scalars["Float"]["input"];
};

export type AutoFacParticipantDeductions = {
  __typename?: "AutoFacParticipantDeductions";
  auto_fac_participant: Maybe<AutoFacParticipant>;
  brokerage: Maybe<Scalars["Float"]["output"]>;
  commission: Maybe<Scalars["Float"]["output"]>;
  employee: Maybe<Employee>;
  nic: Maybe<Scalars["Float"]["output"]>;
  overrider: Maybe<Scalars["Float"]["output"]>;
  wht: Maybe<Scalars["Float"]["output"]>;
};

export type AutoFacParticipantInput = {
  auto_fac_config_id: Scalars["ID"]["input"];
  employee_id: Scalars["ID"]["input"];
  reinsurer_id: Scalars["ID"]["input"];
  share_percentage: Scalars["Float"]["input"];
};

export type AvailableCedants = {
  __typename?: "AvailableCedants";
  data: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export type Badge = {
  __typename?: "Badge";
  count: Scalars["Int"]["output"];
  insurers: Array<InsuranceStatistic>;
  name: Scalars["String"]["output"];
};

export type BatchReportFilter = {
  date_from: InputMaybe<Scalars["String"]["input"]>;
  date_to: InputMaybe<Scalars["String"]["input"]>;
  status: InputMaybe<Scalars["String"]["input"]>;
};

export type BrokerDistributionList = {
  broke_distribution: InputMaybe<Array<InputMaybe<BrokerList>>>;
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type BrokerList = {
  re_associate_ids: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  re_broker_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type Broker_Payment_Data = {
  auto_payment_receipt: InputMaybe<Scalars["Boolean"]["input"]>;
  payment_amount: Scalars["Float"]["input"];
  payment_comment: Scalars["String"]["input"];
  payment_details: Scalars["String"]["input"];
  payment_status: InputMaybe<Scalars["String"]["input"]>;
  re_broker_treaties_surplus_participation_id: InputMaybe<
    Scalars["ID"]["input"]
  >;
  re_broker_treaties_xl_participation_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type BusinessCategory = {
  __typename?: "BusinessCategory";
  name: Maybe<Scalars["String"]["output"]>;
};

export enum Cheque_Status {
  Cleared = "CLEARED",
  Pending = "PENDING",
  Uncleared = "UNCLEARED",
}

export type ClaimPayment = {
  __typename?: "ClaimPayment";
  created_at: Scalars["String"]["output"];
  currency: Scalars["String"]["output"];
  participant: ParticipantInfo;
  participant_id: Scalars["ID"]["output"];
  payment_amount: Scalars["Float"]["output"];
  payment_detail: Maybe<Scalars["String"]["output"]>;
  payment_id: Scalars["ID"]["output"];
  payment_uuid: Scalars["String"]["output"];
  reinsurer: Scalars["String"]["output"];
  treaty_claim_id: Scalars["ID"]["output"];
};

export type ClaimShare = {
  __typename?: "ClaimShare";
  claim_paid: Maybe<Scalars["Float"]["output"]>;
  claim_payment_share: Maybe<Scalars["Float"]["output"]>;
  currency: Maybe<Scalars["String"]["output"]>;
  layer_number: Maybe<Scalars["Int"]["output"]>;
  participant_id: Maybe<Scalars["ID"]["output"]>;
  percentage: Maybe<Scalars["Float"]["output"]>;
  reinsurer: Maybe<Scalars["String"]["output"]>;
  treaty_claim_id: Maybe<Scalars["ID"]["output"]>;
};

export type Claim_Data = {
  claim_amount: Scalars["ID"]["input"];
  claim_comment: InputMaybe<Scalars["String"]["input"]>;
  claim_date: Scalars["ID"]["input"];
  currency: InputMaybe<Scalars["String"]["input"]>;
  offer_id: Scalars["ID"]["input"];
  rate: InputMaybe<Scalars["Float"]["input"]>;
};

export enum Claim_Status {
  Claimed = "CLAIMED",
  Unclaimed = "UNCLAIMED",
}

export type ClaimsFilter = {
  offer_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type Class_Of_Business = {
  __typename?: "Class_of_business";
  business_category: Maybe<Scalars["String"]["output"]>;
  business_details: Scalars["String"]["output"];
  business_name: Scalars["String"]["output"];
  class_of_business_id: Scalars["ID"]["output"];
  created_at: Scalars["DateTime"]["output"];
  single_total_offers: Maybe<Scalars["Int"]["output"]>;
  single_total_overview: Maybe<Scalars["String"]["output"]>;
};

export type Client_Overview = {
  __typename?: "Client_overview";
  brokerage_chart: Maybe<Scalars["String"]["output"]>;
  total_brokerage_amt: Maybe<Scalars["String"]["output"]>;
  total_closed: Maybe<Scalars["Int"]["output"]>;
  total_fac_nic_levy: Maybe<Scalars["String"]["output"]>;
  total_fac_premium: Maybe<Scalars["String"]["output"]>;
  total_fac_recoveries_due: Maybe<Scalars["String"]["output"]>;
  total_nic_tax: Maybe<Scalars["String"]["output"]>;
  total_outstanding_fac_premium: Maybe<Scalars["String"]["output"]>;
  total_paid: Maybe<Scalars["Int"]["output"]>;
  total_pending: Maybe<Scalars["Int"]["output"]>;
  total_unpaid: Maybe<Scalars["Int"]["output"]>;
  total_withholding_tax: Maybe<Scalars["String"]["output"]>;
  treaties_overview: Maybe<Treaty_Overview>;
};

export enum Client_Type {
  Insurer = "INSURER",
  Reinsurer = "REINSURER",
}

export type Convert_Type = {
  currency: InputMaybe<Scalars["String"]["input"]>;
  rate: InputMaybe<Scalars["Float"]["input"]>;
};

export type CurrencyDisaggregation = {
  __typename?: "CurrencyDisaggregation";
  total_cedis: Maybe<Scalars["String"]["output"]>;
  total_dollar: Maybe<Scalars["String"]["output"]>;
  total_euros: Maybe<Scalars["String"]["output"]>;
  total_pounds: Maybe<Scalars["String"]["output"]>;
};

export type DashboardOverview = {
  __typename?: "DashboardOverview";
  brokerage_earnings: Maybe<CurrencyDisaggregation>;
  total_brokers: Maybe<Scalars["Int"]["output"]>;
  total_claim_offers: Maybe<Scalars["Int"]["output"]>;
  total_closed_offers: Maybe<Scalars["Int"]["output"]>;
  total_fac_premium: Maybe<CurrencyDisaggregation>;
  total_fac_sum_insured: Maybe<CurrencyDisaggregation>;
  total_insurers: Maybe<Scalars["Int"]["output"]>;
  total_offers: Maybe<Scalars["Int"]["output"]>;
  total_open_offers: Maybe<Scalars["Int"]["output"]>;
  total_pending_offers: Maybe<Scalars["Int"]["output"]>;
  total_premium: Maybe<CurrencyDisaggregation>;
  total_reinsurers: Maybe<Scalars["Int"]["output"]>;
  total_sum_insured: Maybe<CurrencyDisaggregation>;
  total_unclaim_offers: Maybe<Scalars["Int"]["output"]>;
};

export type DashboardOverviewInput = {
  filter_by: Array<InputMaybe<Scalars["String"]["input"]>>;
  for: InputMaybe<Scalars["ID"]["input"]>;
  from: InputMaybe<Scalars["Date"]["input"]>;
  to: InputMaybe<Scalars["Date"]["input"]>;
};

export type DashboardPieChart = {
  __typename?: "DashboardPieChart";
  insurer_company_name: Maybe<Scalars["String"]["output"]>;
  total_cedants: Maybe<Scalars["Int"]["output"]>;
};

export type Deductions = {
  brokerage: InputMaybe<Scalars["Float"]["input"]>;
  commission: InputMaybe<Scalars["Float"]["input"]>;
  nic_levy: InputMaybe<Scalars["Float"]["input"]>;
  participating_percentage: InputMaybe<Scalars["Float"]["input"]>;
  withholding_tax: InputMaybe<Scalars["Float"]["input"]>;
};

export type DeleteDocumentResponse = {
  __typename?: "DeleteDocumentResponse";
  message: Scalars["String"]["output"];
  success: Scalars["Boolean"]["output"];
};

export enum DeleteStatusEnum {
  Deleted = "DELETED",
  Notdeleted = "NOTDELETED",
}

export type Distribution_Data = {
  message: InputMaybe<Scalars["String"]["input"]>;
  message_attachment: InputMaybe<Scalars["String"]["input"]>;
  offer_id: Scalars["ID"]["input"];
  reinsurer_reps: Array<Reinsurer_Representative_Data>;
};

export type DocumentUploadResponse = {
  __typename?: "DocumentUploadResponse";
  message: Maybe<Scalars["String"]["output"]>;
  paths: Array<Scalars["String"]["output"]>;
  success: Maybe<Scalars["Boolean"]["output"]>;
};

export type EmailComponent = {
  attachments: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  copied_email: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  email_content: InputMaybe<Scalars["String"]["input"]>;
  subject: InputMaybe<Scalars["String"]["input"]>;
};

export type Email_Data = {
  attachment: InputMaybe<Array<Scalars["String"]["input"]>>;
  copied_emails: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  message_content: InputMaybe<Scalars["String"]["input"]>;
  offer_id: Scalars["ID"]["input"];
  reinsurer_id: InputMaybe<Scalars["ID"]["input"]>;
  subject: InputMaybe<Scalars["String"]["input"]>;
};

export type Employee = {
  __typename?: "Employee";
  accept_waiver_aggreement: Maybe<Scalars["Boolean"]["output"]>;
  emp_abbrv: Maybe<Scalars["String"]["output"]>;
  employee_email: Scalars["String"]["output"];
  employee_first_name: Scalars["String"]["output"];
  employee_id: Scalars["ID"]["output"];
  employee_last_name: Scalars["String"]["output"];
  employee_notification: Maybe<Array<Maybe<EmployeeNotification>>>;
  employee_phonenumber: Scalars["String"]["output"];
  log_activities: Maybe<Array<Maybe<Log_Activity>>>;
  total_offers: Maybe<Array<Maybe<Offer>>>;
  user: User;
  waiver_accepted_at: Maybe<Scalars["String"]["output"]>;
};

export type EmployeeNotification = {
  __typename?: "EmployeeNotification";
  created_at: Maybe<Scalars["DateTime"]["output"]>;
  employee_notification_id: Maybe<Scalars["ID"]["output"]>;
  system_notification: Maybe<SystemNotification>;
};

export type Employee_Data = {
  employee_email: Scalars["String"]["input"];
  employee_first_name: Scalars["String"]["input"];
  employee_last_name: Scalars["String"]["input"];
  employee_phonenumber: Scalars["String"]["input"];
  employee_position: Scalars["String"]["input"];
};

export type EndorsementEmail = {
  copied_email: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  doc_number: InputMaybe<Scalars["Int"]["input"]>;
  documents: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  email_content: InputMaybe<Scalars["String"]["input"]>;
  offer_endorsement_id: InputMaybe<Scalars["Int"]["input"]>;
  offer_participant_id: InputMaybe<Scalars["Int"]["input"]>;
  subject: InputMaybe<Scalars["String"]["input"]>;
};

export type EndorsementFilters = {
  insurer_id: InputMaybe<Scalars["ID"]["input"]>;
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
  search: InputMaybe<Scalars["String"]["input"]>;
};

export type EndorsementParticipationAndDeductions = {
  brokerage: InputMaybe<Scalars["Float"]["input"]>;
  commission: InputMaybe<Scalars["Float"]["input"]>;
  nic: InputMaybe<Scalars["Float"]["input"]>;
  participating_percentage: InputMaybe<Scalars["Float"]["input"]>;
  wht: InputMaybe<Scalars["Float"]["input"]>;
};

export enum Expiry_Status {
  Active = "ACTIVE",
  Expired = "EXPIRED",
}

export type ExtendedTreatyDetails = {
  np_detail: InputMaybe<TreatyNpDetailInput>;
  proportional_detail: InputMaybe<TreatyProportionalDetailInput>;
  type: InputMaybe<TreatyType>;
};

export enum Filterbydeduction {
  Nic = "NIC",
  Wht = "WHT",
}

export type ForgotPasswordInput = {
  email: Scalars["String"]["input"];
};

export type ForgotPasswordResponse = {
  __typename?: "ForgotPasswordResponse";
  message: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
};

export type GiftBasketItem = {
  __typename?: "GiftBasketItem";
  gift_description: Maybe<Scalars["String"]["output"]>;
  gift_image: Maybe<Scalars["String"]["output"]>;
  gift_name: Scalars["String"]["output"];
  gift_type: Scalars["String"]["output"];
};

export type GiftBasketItemInput = {
  gift_description: InputMaybe<Scalars["String"]["input"]>;
  gift_image: InputMaybe<Scalars["String"]["input"]>;
  gift_name: Scalars["String"]["input"];
  gift_type: Scalars["String"]["input"];
};

export type GiftStatus = {
  id: InputMaybe<Scalars["ID"]["input"]>;
  status: InputMaybe<Scalars["String"]["input"]>;
};

export type InsuranceStatistic = {
  __typename?: "InsuranceStatistic";
  id: Scalars["ID"]["output"];
  insurer_id: Scalars["ID"]["output"];
  insurer_name: Scalars["String"]["output"];
  total_points: Maybe<Scalars["Int"]["output"]>;
  total_redeemable_cash_equivalent: Maybe<Scalars["Float"]["output"]>;
  total_redeemable_points: Maybe<Scalars["Int"]["output"]>;
};

export type Insurer = {
  __typename?: "Insurer";
  insurer_abbrv: Maybe<Scalars["String"]["output"]>;
  insurer_address: Maybe<Insurer_Address>;
  insurer_associates: Maybe<Array<Maybe<Insurer_Associate>>>;
  insurer_company_email: Scalars["String"]["output"];
  insurer_company_name: Scalars["String"]["output"];
  insurer_company_website: Maybe<Scalars["String"]["output"]>;
  insurer_id: Scalars["ID"]["output"];
  insurer_overview: Maybe<Client_Overview>;
  offers: Maybe<Array<Maybe<Offer>>>;
  remainders: Maybe<Array<Maybe<Remainder>>>;
  treaties: Maybe<Array<Maybe<Treaty>>>;
};

export type Insurer_Address = {
  __typename?: "Insurer_address";
  country: Scalars["String"]["output"];
  insurer_address_id: Scalars["ID"]["output"];
  region: Scalars["String"]["output"];
  street: Scalars["String"]["output"];
  suburb: Scalars["String"]["output"];
};

export type Insurer_Associate = {
  __typename?: "Insurer_associate";
  assoc_email: Maybe<Scalars["String"]["output"]>;
  assoc_first_name: Scalars["String"]["output"];
  assoc_last_name: Scalars["String"]["output"];
  assoc_primary_phonenumber: Scalars["String"]["output"];
  assoc_secondary_phonenumber: Maybe<Scalars["String"]["output"]>;
  insurer_associate_id: Scalars["ID"]["output"];
  position: Maybe<Scalars["String"]["output"]>;
};

export type Insurer_Associate_Data = {
  insurersinsurer_id: InputMaybe<Scalars["ID"]["input"]>;
  position: Scalars["String"]["input"];
  rep_email: Scalars["String"]["input"];
  rep_first_name: Scalars["String"]["input"];
  rep_last_name: Scalars["String"]["input"];
  rep_primary_phonenumber: Scalars["String"]["input"];
  rep_secondary_phonenumber: InputMaybe<Scalars["String"]["input"]>;
};

export type Insurer_Data = {
  country: Scalars["String"]["input"];
  insurer_company_email: Scalars["String"]["input"];
  insurer_company_name: Scalars["String"]["input"];
  insurer_company_website: InputMaybe<Scalars["String"]["input"]>;
  region: Scalars["String"]["input"];
  street: Scalars["String"]["input"];
  suburb: Scalars["String"]["input"];
};

export type KnownLossesData = {
  date: InputMaybe<Scalars["Date"]["input"]>;
  loss: InputMaybe<Scalars["Float"]["input"]>;
};

export type LayerInput = {
  m_and_d_premium: InputMaybe<Scalars["Float"]["input"]>;
};

export type LeaderboardResponse = {
  __typename?: "LeaderboardResponse";
  badges: Array<Badge>;
  target: Maybe<Target>;
};

export type LimitData = {
  limit: InputMaybe<Scalars["String"]["input"]>;
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type Log_Activity = {
  __typename?: "Log_activity";
  city: Maybe<Scalars["String"]["output"]>;
  country: Maybe<Scalars["String"]["output"]>;
  created_at: Maybe<Scalars["DateTime"]["output"]>;
  device_ip: Maybe<Scalars["String"]["output"]>;
  device_type: Maybe<Scalars["String"]["output"]>;
  region: Maybe<Scalars["String"]["output"]>;
};

export type LoginInput = {
  password: Scalars["String"]["input"];
  username: Scalars["String"]["input"];
};

export type LogoutResponse = {
  __typename?: "LogoutResponse";
  message: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
};

export type MetaData = {
  note_type: Array<InputMaybe<Scalars["String"]["input"]>>;
  participant_ids: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  treaty_account_ids: Array<InputMaybe<Scalars["ID"]["input"]>>;
};

export type MotorFleet = {
  __typename?: "MotorFleet";
  offer_id: Maybe<Scalars["ID"]["output"]>;
  vehile_reg_no: Maybe<Scalars["String"]["output"]>;
};

export type Mutation = {
  __typename?: "Mutation";
  acceptWaiverAgreement: Scalars["Boolean"]["output"];
  addPrecentageToParticipant: Maybe<Offer_Participant>;
  addQuarterForTreaty: Maybe<Scalars["Boolean"]["output"]>;
  addReBrokerParticipationPercentage: Maybe<Scalars["Boolean"]["output"]>;
  addReinsurerPercentageAndDeductions: Maybe<Scalars["Boolean"]["output"]>;
  addReinsurerToEndorsement: Maybe<Scalars["Boolean"]["output"]>;
  addReinsurersParticipationPercentage: Maybe<Scalars["Boolean"]["output"]>;
  adminDeleteEmployeeAccount: Maybe<Scalars["Boolean"]["output"]>;
  adminResetEmployeePassword: Maybe<Scalars["Boolean"]["output"]>;
  approveOfferParticipant: Scalars["Boolean"]["output"];
  assignCedantToStaff: Maybe<ResponseData>;
  automateCreateClaims: Maybe<Scalars["Boolean"]["output"]>;
  batchReporting: Maybe<QueueReportPayload>;
  brokerReadTransactionThread: Maybe<Scalars["Boolean"]["output"]>;
  changePasswordByEmployee: Maybe<Scalars["Boolean"]["output"]>;
  createAndUpdatePortfolioStatmentAndProfitCommission: Maybe<
    Scalars["Boolean"]["output"]
  >;
  createAutoFacConfiguration: Scalars["Boolean"]["output"];
  createAutoFacParticipantDeduction: Scalars["Boolean"]["output"];
  createAutoFacParticipants: Scalars["Boolean"]["output"];
  createClassOfBusiness: Class_Of_Business;
  createClosingForOffer: Array<Offer_Extra_Charges>;
  createDistributionList: Maybe<Scalars["Boolean"]["output"]>;
  createEmployeeAccount: Maybe<Scalars["Boolean"]["output"]>;
  createEndorsementOffer: Maybe<Scalars["Boolean"]["output"]>;
  createFleetOffer: Maybe<Scalars["Boolean"]["output"]>;
  createInputOffer: Offer;
  createInsurer: Insurer;
  createInsurerRep: Insurer_Associate;
  createOfferClaimPayment: Scalars["String"]["output"];
  createOrUpdateAdjustmentStatment: Maybe<Scalars["Boolean"]["output"]>;
  createReBroker: Maybe<Scalars["Boolean"]["output"]>;
  createReBrokerAssociates: Maybe<Scalars["Boolean"]["output"]>;
  createReBrokerListForTreaty: Maybe<Scalars["Boolean"]["output"]>;
  createReinsurer: Reinsurer;
  createReinsurerRep: Maybe<Reinsurer_Representative>;
  createReinsurersDistribution: Maybe<Scalars["Boolean"]["output"]>;
  createTarget: Maybe<Scalars["Boolean"]["output"]>;
  createTargetBadges: Maybe<Scalars["Boolean"]["output"]>;
  createTargetRates: Maybe<Scalars["Boolean"]["output"]>;
  createTreaty: Maybe<Scalars["Boolean"]["output"]>;
  createTreatyEndorsement: Maybe<Scalars["Boolean"]["output"]>;
  createTreatyProgram: Maybe<Scalars["Boolean"]["output"]>;
  createTreatyProgramAssociateDeductions: Maybe<Scalars["String"]["output"]>;
  deleteAdjustmentStatment: Maybe<Scalars["Boolean"]["output"]>;
  deleteAutoFacConfiguration: Scalars["Boolean"]["output"];
  deleteAutoFacParticipant: Scalars["Boolean"]["output"];
  deleteClaimAmount: Maybe<Scalars["String"]["output"]>;
  deleteClaimCreated: Maybe<Scalars["Boolean"]["output"]>;
  deleteDocument: DeleteDocumentResponse;
  deleteEndorsementOffer: Maybe<Scalars["Boolean"]["output"]>;
  deleteOfferEndorsementParticipant: Maybe<Scalars["Boolean"]["output"]>;
  deleteOfferFromSystem: Maybe<Scalars["Boolean"]["output"]>;
  deleteOfferPaymentFromInsurer: Maybe<Scalars["Boolean"]["output"]>;
  deleteReBroker: Maybe<Scalars["Boolean"]["output"]>;
  deleteReBrokerAssociates: Maybe<Scalars["Boolean"]["output"]>;
  deleteReceivablePayment: Maybe<Scalars["Boolean"]["output"]>;
  deleteSupportingDoc: Maybe<Scalars["Boolean"]["output"]>;
  deleteTarget: Maybe<Scalars["Boolean"]["output"]>;
  deleteTargetBadge: Maybe<Scalars["Boolean"]["output"]>;
  deleteTargetRate: Maybe<Scalars["Boolean"]["output"]>;
  deleteTreaty: Maybe<Scalars["Boolean"]["output"]>;
  deleteTreatyEndorsement: Maybe<Scalars["Boolean"]["output"]>;
  deleteTreatyProgram: Maybe<Scalars["Boolean"]["output"]>;
  deleteTreatyProgramAssociateDeductions: Maybe<Scalars["Boolean"]["output"]>;
  distributePaymentForTreaty: Maybe<Scalars["Boolean"]["output"]>;
  duplicateTreaty: Maybe<Scalars["Boolean"]["output"]>;
  generateAndSendPNOC: Maybe<Scalars["Boolean"]["output"]>;
  login: AuthPayload;
  logout: LogoutResponse;
  makeBrokerNonProportionalPayment: Maybe<Scalars["Boolean"]["output"]>;
  makeBrokerProportionalPayment: Maybe<Scalars["Boolean"]["output"]>;
  makeClaimOnOffer: Maybe<Scalars["Boolean"]["output"]>;
  makeNonProportionalPayment: Maybe<Scalars["Boolean"]["output"]>;
  makePaymentOnOffer: Maybe<Scalars["String"]["output"]>;
  makeProportionalPayment: Maybe<Scalars["Boolean"]["output"]>;
  makeReceivablePayment: Maybe<Scalars["Boolean"]["output"]>;
  manuallyCreateClaims: Maybe<Scalars["Boolean"]["output"]>;
  modifyOfferClaimPayment: Scalars["String"]["output"];
  postponeRemainderTill: Maybe<Scalars["Boolean"]["output"]>;
  publishOffer: Scalars["Boolean"]["output"];
  recordReceivablePayment: Maybe<Scalars["Boolean"]["output"]>;
  rejectOfferParticipant: Scalars["Boolean"]["output"];
  removeAllNotificationForEmployee: Maybe<Scalars["Boolean"]["output"]>;
  removeAssociateFromTreaty: Maybe<Scalars["Boolean"]["output"]>;
  removeBrokerNonProportionalPayment: Maybe<Scalars["Boolean"]["output"]>;
  removeBrokerProportionalPayment: Maybe<Scalars["Boolean"]["output"]>;
  removeInsurer: Maybe<Scalars["Boolean"]["output"]>;
  removeInsurerRep: Maybe<Scalars["Boolean"]["output"]>;
  removeNonProportionalPayment: Maybe<Scalars["Boolean"]["output"]>;
  removeNotificationForEmployee: Maybe<Scalars["Boolean"]["output"]>;
  removeOfferClaimPayment: Maybe<Scalars["Boolean"]["output"]>;
  removeOfferParticipantClaimPayment: Maybe<Scalars["Boolean"]["output"]>;
  removeParticipantByParticipant: Maybe<Scalars["Boolean"]["output"]>;
  removeParticipantByReinsurer: Maybe<Scalars["Boolean"]["output"]>;
  removeParticipantFromTreaty: Maybe<Scalars["Boolean"]["output"]>;
  removeProportionalPayment: Maybe<Scalars["Boolean"]["output"]>;
  removeQuarterForTreaty: Maybe<Scalars["Boolean"]["output"]>;
  removeReBokerAssocFromTreatyList: Maybe<Scalars["Boolean"]["output"]>;
  removeReBokerFromTreatyList: Maybe<Scalars["Boolean"]["output"]>;
  removeReinsuereRep: Maybe<Reinsurer_Representative>;
  removeReinsurer: Maybe<Reinsurer>;
  removeReinsurersParticipationPercentage: Maybe<Scalars["Boolean"]["output"]>;
  removeSingleClassOfBusiness: Maybe<Scalars["Boolean"]["output"]>;
  reopenOffer: Maybe<Offer>;
  reportOnQuery: Maybe<Scalars["String"]["output"]>;
  sendClaimDebitNote: Maybe<Scalars["String"]["output"]>;
  sendClaimNotification: Maybe<Scalars["Boolean"]["output"]>;
  sendClosingslip: Maybe<Scalars["Boolean"]["output"]>;
  sendContractChanges: Maybe<Scalars["Boolean"]["output"]>;
  sendContractChangesAndClosingNote: Maybe<Scalars["Boolean"]["output"]>;
  sendContractChangesAndDebitNote: Maybe<Scalars["Boolean"]["output"]>;
  sendDebitAndCoverNotes: Maybe<Scalars["Boolean"]["output"]>;
  sendNPTreatyCreditNote: Maybe<Scalars["Boolean"]["output"]>;
  sendNPTreatyDebitNote: Maybe<Scalars["Boolean"]["output"]>;
  sendOfferAsBroadCast: Maybe<Scalars["String"]["output"]>;
  sendOfferParticipationMessage: Maybe<Scalars["Boolean"]["output"]>;
  sendPTreatyCreditAndStatementNote: Maybe<Scalars["Boolean"]["output"]>;
  sendPTreatyDebitNote: Maybe<Scalars["Boolean"]["output"]>;
  sendTreatyBrokerNotes: Maybe<Scalars["Boolean"]["output"]>;
  sendTreatyClaimDebitNote: Maybe<Scalars["Boolean"]["output"]>;
  sendTreatyClaimNotification: Maybe<Scalars["Boolean"]["output"]>;
  sendTreatyPlacingOrCovertNote: Maybe<Scalars["Boolean"]["output"]>;
  unpublishOffer: Scalars["Boolean"]["output"];
  updateAutoFacConfiguration: Scalars["Boolean"]["output"];
  updateAutoFacParticipantDeduction: Scalars["Boolean"]["output"];
  updateAutoFacParticipantShare: Scalars["Boolean"]["output"];
  updateBrokerNonProportionalPayment: Maybe<Scalars["Boolean"]["output"]>;
  updateBrokerProportionalPayment: Maybe<Scalars["Boolean"]["output"]>;
  updateClaimAmount: Maybe<Scalars["Boolean"]["output"]>;
  updateClaimCreated: Maybe<Scalars["Boolean"]["output"]>;
  updateEachReinsurerPaymentDetails: Maybe<Scalars["Boolean"]["output"]>;
  updateEmployeeAccountDetails: Maybe<Scalars["Boolean"]["output"]>;
  updateEndorsementOffer: Maybe<Scalars["Boolean"]["output"]>;
  updateGiftStatus: Maybe<Scalars["Boolean"]["output"]>;
  updateInputOffer: Maybe<Scalars["String"]["output"]>;
  updateInsurer: Maybe<Scalars["Boolean"]["output"]>;
  updateInsurerRep: Maybe<Scalars["Boolean"]["output"]>;
  updateLimitLayer: Maybe<Scalars["Boolean"]["output"]>;
  updateNonProportionalPayment: Maybe<Scalars["Boolean"]["output"]>;
  updateOfferParticipantClaimPayment: Maybe<Scalars["Boolean"]["output"]>;
  updateOfferParticipantPayment: Maybe<Scalars["Boolean"]["output"]>;
  updatePaymentOnofferFromInsurer: Maybe<Scalars["String"]["output"]>;
  updateProportionalPayment: Maybe<Scalars["Boolean"]["output"]>;
  updateQuarterForTreaty: Maybe<Scalars["Boolean"]["output"]>;
  updateReBroker: Maybe<Scalars["Boolean"]["output"]>;
  updateReBrokerAssociates: Maybe<Scalars["Boolean"]["output"]>;
  updateReceivablePayment: Maybe<Scalars["Boolean"]["output"]>;
  updateReinsurer: Maybe<Scalars["Boolean"]["output"]>;
  updateReinsurerDeductions: Maybe<Scalars["Boolean"]["output"]>;
  updateReinsurerExtraCharges: Maybe<Scalars["Boolean"]["output"]>;
  updateReinsurerPaymentDetails: Maybe<Scalars["Boolean"]["output"]>;
  updateReinsurerRep: Maybe<Scalars["Boolean"]["output"]>;
  updateSingleClassOfBusiness: Class_Of_Business;
  updateTarget: Maybe<Scalars["Boolean"]["output"]>;
  updateTargetBadge: Maybe<Scalars["Boolean"]["output"]>;
  updateTargetRate: Maybe<Scalars["Boolean"]["output"]>;
  updateTreaty: Maybe<Scalars["Boolean"]["output"]>;
  updateTreatyEndorsement: Maybe<Scalars["Boolean"]["output"]>;
  updateTreatyForPlaingAndCover: Maybe<Scalars["Boolean"]["output"]>;
  updateTreatyProgram: Maybe<Scalars["Boolean"]["output"]>;
  updateTreatyProgramAssociateDeductions: Maybe<Scalars["Boolean"]["output"]>;
  uploadOfferDocument: Maybe<Scalars["Boolean"]["output"]>;
  validateTreatyProgramDelete: Maybe<Scalars["String"]["output"]>;
};

export type MutationAcceptWaiverAgreementArgs = {
  status: Scalars["Boolean"]["input"];
};

export type MutationAddPrecentageToParticipantArgs = {
  offer_id: Scalars["ID"]["input"];
  offer_participant_id: Scalars["ID"]["input"];
  participating_percentage: Scalars["Float"]["input"];
};

export type MutationAddQuarterForTreatyArgs = {
  treaty_account: InputMaybe<TreatyAccountData>;
};

export type MutationAddReBrokerParticipationPercentageArgs = {
  broker_participation: InputMaybe<ReBrokerParticipationPercentageInput>;
};

export type MutationAddReinsurerPercentageAndDeductionsArgs = {
  deductions: InputMaybe<EndorsementParticipationAndDeductions>;
  offer_end_participant_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationAddReinsurerToEndorsementArgs = {
  offer_endorsement_id: InputMaybe<Scalars["ID"]["input"]>;
  offer_id: InputMaybe<Scalars["ID"]["input"]>;
  reinsurer_ids: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type MutationAddReinsurersParticipationPercentageArgs = {
  associate_deduction_id: Scalars["ID"]["input"];
  layer_number?: Scalars["Int"]["input"];
  participation_percentage: Scalars["Float"]["input"];
  treaty_id: Scalars["ID"]["input"];
  treaty_participation_id: Scalars["ID"]["input"];
};

export type MutationAdminDeleteEmployeeAccountArgs = {
  employee_id: Scalars["ID"]["input"];
};

export type MutationAdminResetEmployeePasswordArgs = {
  employee_id: Scalars["ID"]["input"];
};

export type MutationApproveOfferParticipantArgs = {
  input: ApproveOfferParticipantInput;
};

export type MutationAssignCedantToStaffArgs = {
  cedants: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  staff_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationAutomateCreateClaimsArgs = {
  custom_headers: InputMaybe<Scalars["String"]["input"]>;
  file: InputMaybe<Scalars["Upload"]["input"]>;
  layer_number: InputMaybe<Scalars["Int"]["input"]>;
  start_at?: InputMaybe<Scalars["Int"]["input"]>;
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationBatchReportingArgs = {
  query_data: InputMaybe<Query_Data>;
};

export type MutationBrokerReadTransactionThreadArgs = {
  input: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type MutationChangePasswordByEmployeeArgs = {
  employee_id: Scalars["ID"]["input"];
  new_password: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreateAndUpdatePortfolioStatmentAndProfitCommissionArgs = {
  known_losses: InputMaybe<KnownLossesData>;
  losses_outstanding: InputMaybe<Scalars["Float"]["input"]>;
  overall_gross_premium: InputMaybe<Scalars["Float"]["input"]>;
  prev_year_configuration: InputMaybe<PrevYearConfigurationData>;
  treaty_proportional_detail_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationCreateAutoFacConfigurationArgs = {
  name: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreateAutoFacParticipantDeductionArgs = {
  auto_fac_participant_id: Scalars["ID"]["input"];
  brokerage: Scalars["Float"]["input"];
  commission: Scalars["Float"]["input"];
  nic: Scalars["Float"]["input"];
  overrider: Scalars["Float"]["input"];
  wht: Scalars["Float"]["input"];
};

export type MutationCreateAutoFacParticipantsArgs = {
  auto_fac_config_id: Scalars["ID"]["input"];
  reinsurer_id: Array<Scalars["ID"]["input"]>;
};

export type MutationCreateClassOfBusinessArgs = {
  business_category: InputMaybe<Scalars["String"]["input"]>;
  business_details: Scalars["String"]["input"];
  business_name: Scalars["String"]["input"];
};

export type MutationCreateClosingForOfferArgs = {
  extra_charges: Offer_Extra_Charge_Data;
};

export type MutationCreateDistributionListArgs = {
  distribution_list: Distribution_Data;
};

export type MutationCreateEmployeeAccountArgs = {
  employee: Employee_Data;
};

export type MutationCreateEndorsementOfferArgs = {
  offer_id: InputMaybe<Scalars["ID"]["input"]>;
  offer_input: Offer_Data;
};

export type MutationCreateFleetOfferArgs = {
  offer_input: InputMaybe<Array<InputMaybe<Offer_Data>>>;
};

export type MutationCreateInputOfferArgs = {
  offer_input: Offer_Data;
};

export type MutationCreateInsurerArgs = {
  insurer: Insurer_Data;
};

export type MutationCreateInsurerRepArgs = {
  insurer_rep: Insurer_Associate_Data;
};

export type MutationCreateOfferClaimPaymentArgs = {
  claim_payments: OfferClaimParticipantPaymentInput;
};

export type MutationCreateOrUpdateAdjustmentStatmentArgs = {
  claims_paid: InputMaybe<Scalars["Float"]["input"]>;
  outstanding_payment: InputMaybe<Scalars["Float"]["input"]>;
  retained_premium_income: InputMaybe<Scalars["Float"]["input"]>;
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
  treaty_np_detail_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationCreateReBrokerArgs = {
  re_broker: InputMaybe<ReBrokerInput>;
};

export type MutationCreateReBrokerAssociatesArgs = {
  re_broker_associate: InputMaybe<ReBrokerAssociateInput>;
};

export type MutationCreateReBrokerListForTreatyArgs = {
  brokers_list: InputMaybe<BrokerDistributionList>;
};

export type MutationCreateReinsurerArgs = {
  reinsurer: Reinsurer_Data;
};

export type MutationCreateReinsurerRepArgs = {
  reinsurer_rep: Reinsurer_Rep_Data;
};

export type MutationCreateReinsurersDistributionArgs = {
  layer_number: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  reinsurer_ids: InputMaybe<Array<InputMaybe<Reinsurer_Representative_Data>>>;
  treaty_associate_deduction_id: InputMaybe<Scalars["ID"]["input"]>;
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationCreateTargetArgs = {
  base_currency: InputMaybe<Scalars["String"]["input"]>;
  broker_id: InputMaybe<Scalars["ID"]["input"]>;
  end_date: InputMaybe<Scalars["String"]["input"]>;
  start_date: InputMaybe<Scalars["String"]["input"]>;
  target_name: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreateTargetBadgesArgs = {
  badges: Array<TargetBadgeInput>;
  target_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationCreateTargetRatesArgs = {
  rates: Array<TargetRateInput>;
  target_id: Scalars["ID"]["input"];
};

export type MutationCreateTreatyArgs = {
  treaty: InputMaybe<TreatyData>;
};

export type MutationCreateTreatyEndorsementArgs = {
  treaty_endorsement_comment: InputMaybe<Scalars["String"]["input"]>;
  treaty_id: Scalars["ID"]["input"];
};

export type MutationCreateTreatyProgramArgs = {
  program: InputMaybe<TreatyProgramData>;
};

export type MutationCreateTreatyProgramAssociateDeductionsArgs = {
  deductions: InputMaybe<TreatyAssociateDeductionData>;
};

export type MutationDeleteAdjustmentStatmentArgs = {
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
  treaty_np_detail_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationDeleteAutoFacConfigurationArgs = {
  auto_fac_config_id: Scalars["ID"]["input"];
};

export type MutationDeleteAutoFacParticipantArgs = {
  auto_fac_participant_id: Scalars["ID"]["input"];
};

export type MutationDeleteClaimAmountArgs = {
  offer_claim_id: Scalars["ID"]["input"];
  offer_id: Scalars["ID"]["input"];
};

export type MutationDeleteClaimCreatedArgs = {
  treaty_claim_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationDeleteDocumentArgs = {
  path: Scalars["String"]["input"];
};

export type MutationDeleteEndorsementOfferArgs = {
  offer_endorsement_detail_id: InputMaybe<Scalars["ID"]["input"]>;
  offer_endorsement_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationDeleteOfferEndorsementParticipantArgs = {
  offer_end_participant_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationDeleteOfferFromSystemArgs = {
  offer_id: Scalars["ID"]["input"];
};

export type MutationDeleteOfferPaymentFromInsurerArgs = {
  offer_payment_id: Scalars["ID"]["input"];
};

export type MutationDeleteReBrokerArgs = {
  re_broker_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationDeleteReBrokerAssociatesArgs = {
  re_broker_assoc_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationDeleteReceivablePaymentArgs = {
  receivable_payment_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationDeleteSupportingDocArgs = {
  filename: InputMaybe<Scalars["String"]["input"]>;
  offer_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationDeleteTargetArgs = {
  id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationDeleteTargetBadgeArgs = {
  target_badge_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationDeleteTargetRateArgs = {
  target_rate_id: Scalars["ID"]["input"];
};

export type MutationDeleteTreatyArgs = {
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
  treaty_type: InputMaybe<TreatyType>;
};

export type MutationDeleteTreatyEndorsementArgs = {
  treaty_endorsement_id: Scalars["ID"]["input"];
};

export type MutationDeleteTreatyProgramArgs = {
  program_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationDeleteTreatyProgramAssociateDeductionsArgs = {
  deduction_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationDistributePaymentForTreatyArgs = {
  payment_information: InputMaybe<Array<InputMaybe<TreatyPaymentDistribution>>>;
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
  treaty_payment_id: InputMaybe<Scalars["ID"]["input"]>;
  type: TreatyType;
};

export type MutationDuplicateTreatyArgs = {
  currencies: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationGenerateAndSendPnocArgs = {
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationLoginArgs = {
  input: InputMaybe<LoginInput>;
};

export type MutationMakeBrokerNonProportionalPaymentArgs = {
  payment_data: InputMaybe<Broker_Payment_Data>;
};

export type MutationMakeBrokerProportionalPaymentArgs = {
  payment_data: InputMaybe<Broker_Payment_Data>;
};

export type MutationMakeClaimOnOfferArgs = {
  claim_data: Claim_Data;
};

export type MutationMakeNonProportionalPaymentArgs = {
  payment: InputMaybe<PaymentDetails>;
};

export type MutationMakePaymentOnOfferArgs = {
  payment_info: Offer_Payment_Data;
};

export type MutationMakeProportionalPaymentArgs = {
  payment: InputMaybe<PaymentDetails>;
};

export type MutationMakeReceivablePaymentArgs = {
  receivable_payments: ReceivablePaymentInput;
  treaty_id: Scalars["ID"]["input"];
};

export type MutationManuallyCreateClaimsArgs = {
  claims: InputMaybe<Array<InputMaybe<TreatyClaimData>>>;
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationModifyOfferClaimPaymentArgs = {
  claim_payments: OfferClaimParticipantPaymentInput;
  offer_claim_participant_payment_id: Scalars["ID"]["input"];
};

export type MutationPostponeRemainderTillArgs = {
  date: InputMaybe<Scalars["Date"]["input"]>;
  reminder_ids: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type MutationPublishOfferArgs = {
  input: SetOfferPublishInput;
};

export type MutationRecordReceivablePaymentArgs = {
  receivable_payments: InputMaybe<Array<InputMaybe<ReceivablePaymentInput>>>;
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationRejectOfferParticipantArgs = {
  input: RejectOfferParticipantInput;
};

export type MutationRemoveAllNotificationForEmployeeArgs = {
  employee_notification_ids: InputMaybe<
    Array<InputMaybe<Scalars["ID"]["input"]>>
  >;
};

export type MutationRemoveAssociateFromTreatyArgs = {
  treaty_to_associate_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationRemoveBrokerNonProportionalPaymentArgs = {
  re_broker_treaties_xl_participation_payment_id: InputMaybe<
    Scalars["ID"]["input"]
  >;
};

export type MutationRemoveBrokerProportionalPaymentArgs = {
  re_broker_treaties_surplus_participation_payment_id: InputMaybe<
    Scalars["ID"]["input"]
  >;
};

export type MutationRemoveInsurerArgs = {
  insurer_id: Scalars["ID"]["input"];
};

export type MutationRemoveInsurerRepArgs = {
  insurer_rep_id: Scalars["ID"]["input"];
};

export type MutationRemoveNonProportionalPaymentArgs = {
  payment_id: InputMaybe<Scalars["ID"]["input"]>;
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
  uuid: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationRemoveNotificationForEmployeeArgs = {
  employee_notification_id: Scalars["ID"]["input"];
};

export type MutationRemoveOfferClaimPaymentArgs = {
  offer_claim_participant_payment_id: Scalars["ID"]["input"];
};

export type MutationRemoveOfferParticipantClaimPaymentArgs = {
  offer_claim_participant_payment_id: Scalars["ID"]["input"];
};

export type MutationRemoveParticipantByParticipantArgs = {
  offer_to_associate_id: Scalars["ID"]["input"];
};

export type MutationRemoveParticipantByReinsurerArgs = {
  offer_id: Scalars["ID"]["input"];
  offer_participating_id: Scalars["ID"]["input"];
  reinsurer_id: Scalars["ID"]["input"];
};

export type MutationRemoveParticipantFromTreatyArgs = {
  treaty_participant_id: InputMaybe<Scalars["ID"]["input"]>;
  treaty_to_associate_ids: InputMaybe<
    Array<InputMaybe<Scalars["ID"]["input"]>>
  >;
};

export type MutationRemoveProportionalPaymentArgs = {
  payment_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationRemoveQuarterForTreatyArgs = {
  treaty_account_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationRemoveReBokerAssocFromTreatyListArgs = {
  participation_to_broker_associate_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationRemoveReBokerFromTreatyListArgs = {
  re_broker_treaties_participation_id: InputMaybe<Scalars["ID"]["input"]>;
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationRemoveReinsuereRepArgs = {
  reinsurer_representative_id: Scalars["ID"]["input"];
};

export type MutationRemoveReinsurerArgs = {
  reinsurer_id: Scalars["ID"]["input"];
};

export type MutationRemoveReinsurersParticipationPercentageArgs = {
  treaty_participation_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationRemoveSingleClassOfBusinessArgs = {
  class_of_business_id: Scalars["ID"]["input"];
};

export type MutationReopenOfferArgs = {
  offer_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationReportOnQueryArgs = {
  query_data: InputMaybe<Query_Data>;
};

export type MutationSendClaimDebitNoteArgs = {
  copied_emails: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  message_content: InputMaybe<Scalars["String"]["input"]>;
  offer_claim_participant_id: Scalars["ID"]["input"];
  offer_id: Scalars["ID"]["input"];
  reinsurer_id: Scalars["ID"]["input"];
  subject: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationSendClaimNotificationArgs = {
  email_data: Email_Data;
};

export type MutationSendClosingslipArgs = {
  email_data: Email_Data;
};

export type MutationSendContractChangesArgs = {
  endorsementInput: InputMaybe<EndorsementEmail>;
};

export type MutationSendContractChangesAndClosingNoteArgs = {
  endorsementInput: InputMaybe<EndorsementEmail>;
};

export type MutationSendContractChangesAndDebitNoteArgs = {
  endorsementInput: InputMaybe<EndorsementEmail>;
};

export type MutationSendDebitAndCoverNotesArgs = {
  email_data: Email_Data;
};

export type MutationSendNpTreatyCreditNoteArgs = {
  nptreatydata: InputMaybe<NpTreatyData>;
};

export type MutationSendNpTreatyDebitNoteArgs = {
  nptreatydata: InputMaybe<NpTreatyData>;
};

export type MutationSendOfferAsBroadCastArgs = {
  email_data: Email_Data;
  include_attachment: InputMaybe<Scalars["Boolean"]["input"]>;
  should_send: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationSendOfferParticipationMessageArgs = {
  input: SendOfferParticipationMessage;
};

export type MutationSendPTreatyCreditAndStatementNoteArgs = {
  email_component: InputMaybe<EmailComponent>;
  participant_id: InputMaybe<Scalars["ID"]["input"]>;
  treaty_account_id: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
  type: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type MutationSendPTreatyDebitNoteArgs = {
  email_component: InputMaybe<EmailComponent>;
  treaty_account_id: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationSendTreatyBrokerNotesArgs = {
  emaildata: InputMaybe<EmailComponent>;
  re_broker_treaties_participation_id: InputMaybe<Scalars["ID"]["input"]>;
  treaty_account_id: InputMaybe<Scalars["ID"]["input"]>;
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationSendTreatyClaimDebitNoteArgs = {
  email_component: InputMaybe<EmailComponent>;
  paged: InputMaybe<Scalars["Int"]["input"]>;
  reinsurer_id: InputMaybe<Scalars["ID"]["input"]>;
  single_document: InputMaybe<Scalars["Int"]["input"]>;
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
  treaty_participant_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationSendTreatyClaimNotificationArgs = {
  email_data: Treaty_Email_Data;
};

export type MutationSendTreatyPlacingOrCovertNoteArgs = {
  doc_type: InputMaybe<Scalars["String"]["input"]>;
  emaildata: InputMaybe<EmailComponent>;
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationUnpublishOfferArgs = {
  input: SetOfferPublishInput;
};

export type MutationUpdateAutoFacConfigurationArgs = {
  auto_fac_config_id: Scalars["ID"]["input"];
  name: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateAutoFacParticipantDeductionArgs = {
  auto_fac_participant_deduction_id: Scalars["ID"]["input"];
  brokerage: Scalars["Float"]["input"];
  commission: Scalars["Float"]["input"];
  nic: Scalars["Float"]["input"];
  overrider: Scalars["Float"]["input"];
  wht: Scalars["Float"]["input"];
};

export type MutationUpdateAutoFacParticipantShareArgs = {
  auto_fac_participant_id: Scalars["ID"]["input"];
  share: InputMaybe<Scalars["Float"]["input"]>;
};

export type MutationUpdateBrokerNonProportionalPaymentArgs = {
  payment_data: InputMaybe<Broker_Payment_Data>;
  re_broker_treaties_xl_participation_payment_id: InputMaybe<
    Scalars["ID"]["input"]
  >;
};

export type MutationUpdateBrokerProportionalPaymentArgs = {
  payment_data: InputMaybe<Broker_Payment_Data>;
  re_broker_treaties_surplus_participation_payment_id: InputMaybe<
    Scalars["ID"]["input"]
  >;
};

export type MutationUpdateClaimAmountArgs = {
  claim_data: Claim_Data;
  offer_claim_id: Scalars["ID"]["input"];
};

export type MutationUpdateClaimCreatedArgs = {
  claims: InputMaybe<TreatyClaimData>;
  treaty_claim_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationUpdateEachReinsurerPaymentDetailsArgs = {
  payment: InputMaybe<PaymentDetails>;
  treaty_participants_payment_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationUpdateEmployeeAccountDetailsArgs = {
  employee: Employee_Data;
  employee_id: Scalars["ID"]["input"];
};

export type MutationUpdateEndorsementOfferArgs = {
  offer_endorsement_detail_id: InputMaybe<Scalars["ID"]["input"]>;
  offer_endorsement_id: InputMaybe<Scalars["ID"]["input"]>;
  offer_id: InputMaybe<Scalars["ID"]["input"]>;
  offer_input: Offer_Data;
};

export type MutationUpdateGiftStatusArgs = {
  status: InputMaybe<GiftStatus>;
};

export type MutationUpdateInputOfferArgs = {
  offer_detail_id: Scalars["ID"]["input"];
  offer_id: Scalars["ID"]["input"];
  offer_input: Offer_Data;
};

export type MutationUpdateInsurerArgs = {
  insurer: Insurer_Data;
  insurer_id: Scalars["ID"]["input"];
};

export type MutationUpdateInsurerRepArgs = {
  insurer_rep: Insurer_Associate_Data;
  insurer_rep_id: Scalars["ID"]["input"];
};

export type MutationUpdateLimitLayerArgs = {
  limit: InputMaybe<LimitData>;
};

export type MutationUpdateNonProportionalPaymentArgs = {
  payment: InputMaybe<PaymentDetails>;
};

export type MutationUpdateOfferParticipantClaimPaymentArgs = {
  claim_payments: OfferClaimParticipantPaymentInput;
  offer_claim_participant_payment_id: Scalars["ID"]["input"];
};

export type MutationUpdateOfferParticipantPaymentArgs = {
  participant_payment_details: Offer_Participant_Payment_Update;
};

export type MutationUpdatePaymentOnofferFromInsurerArgs = {
  payment_info: Offer_Payment_Update_Data;
};

export type MutationUpdateProportionalPaymentArgs = {
  payment: InputMaybe<PaymentDetails>;
};

export type MutationUpdateQuarterForTreatyArgs = {
  treaty_account: InputMaybe<TreatyAccountData>;
  treaty_account_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationUpdateReBrokerArgs = {
  re_broker: InputMaybe<ReBrokerInput>;
  re_broker_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationUpdateReBrokerAssociatesArgs = {
  re_broker_assoc_id: InputMaybe<Scalars["ID"]["input"]>;
  re_broker_associate: InputMaybe<ReBrokerAssociateInput>;
};

export type MutationUpdateReceivablePaymentArgs = {
  receivable_payment_id: InputMaybe<Scalars["ID"]["input"]>;
  receivable_payments: InputMaybe<ReceivablePaymentInput>;
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationUpdateReinsurerArgs = {
  reinsurer: Reinsurer_Data;
  reinsurer_id: Scalars["ID"]["input"];
};

export type MutationUpdateReinsurerDeductionsArgs = {
  account_ids: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  data: InputMaybe<Array<InputMaybe<ReinsurerParticipationUpdate>>>;
  isProp?: InputMaybe<Scalars["Boolean"]["input"]>;
  layer?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateReinsurerExtraChargesArgs = {
  extra_charge: Offer_Edit_Extra_Charge_Data;
  extra_charge_id: Scalars["ID"]["input"];
  participant_id: Scalars["ID"]["input"];
};

export type MutationUpdateReinsurerPaymentDetailsArgs = {
  offer_participant_payment_comment: InputMaybe<Scalars["String"]["input"]>;
  offer_participant_payment_id: Scalars["ID"]["input"];
  paid_details: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateReinsurerRepArgs = {
  reinsurer_rep: Reinsurer_Rep_Data;
  reinsurer_representative_id: Scalars["ID"]["input"];
};

export type MutationUpdateSingleClassOfBusinessArgs = {
  business_category: InputMaybe<Scalars["String"]["input"]>;
  business_details: Scalars["String"]["input"];
  business_name: Scalars["String"]["input"];
  class_of_business_id: Scalars["ID"]["input"];
};

export type MutationUpdateTargetArgs = {
  base_currency: InputMaybe<Scalars["String"]["input"]>;
  end_date: InputMaybe<Scalars["String"]["input"]>;
  id: InputMaybe<Scalars["ID"]["input"]>;
  start_date: InputMaybe<Scalars["String"]["input"]>;
  target_name: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateTargetBadgeArgs = {
  badge: TargetBadgeInput;
  target_badge_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationUpdateTargetRateArgs = {
  rate: TargetRateInput;
  target_rate_id: Scalars["ID"]["input"];
};

export type MutationUpdateTreatyArgs = {
  treaty: InputMaybe<TreatyData>;
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationUpdateTreatyEndorsementArgs = {
  treaty_endorsement_comment: Scalars["String"]["input"];
  treaty_endorsement_id: Scalars["ID"]["input"];
};

export type MutationUpdateTreatyForPlaingAndCoverArgs = {
  treaty_details: InputMaybe<Scalars["String"]["input"]>;
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationUpdateTreatyProgramArgs = {
  program: InputMaybe<TreatyProgramData>;
  program_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationUpdateTreatyProgramAssociateDeductionsArgs = {
  deduction_id: InputMaybe<Scalars["ID"]["input"]>;
  deductions: InputMaybe<TreatyAssociateDeductionData>;
};

export type MutationUploadOfferDocumentArgs = {
  offer_id: Scalars["ID"]["input"];
  path: Array<Scalars["String"]["input"]>;
};

export type MutationValidateTreatyProgramDeleteArgs = {
  program_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type NpTreatyData = {
  email_component: InputMaybe<EmailComponent>;
  installment_type: InputMaybe<Scalars["Int"]["input"]>;
  layer: InputMaybe<Scalars["Int"]["input"]>;
  limit: InputMaybe<Scalars["Float"]["input"]>;
  m_and_d_premium: InputMaybe<Scalars["Float"]["input"]>;
  participant_id: InputMaybe<Scalars["Int"]["input"]>;
  total_participation_percentage: InputMaybe<Scalars["Float"]["input"]>;
  treaty_id: InputMaybe<Scalars["Int"]["input"]>;
  uuid: InputMaybe<Scalars["String"]["input"]>;
};

export type NewPasswordWithCodeInput = {
  email: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
  password_confirmation: Scalars["String"]["input"];
  token: Scalars["String"]["input"];
};

export type NotificationFilter = {
  notificationEndDate: InputMaybe<Scalars["Date"]["input"]>;
  notificationStartDate: InputMaybe<Scalars["Date"]["input"]>;
  notificationType: InputMaybe<NotificationType>;
  search: InputMaybe<Scalars["String"]["input"]>;
};

export enum NotificationType {
  DocumentSms = "DOCUMENT_SMS",
  SystemBusiness = "SYSTEM_BUSINESS",
  SystemClaim = "SYSTEM_CLAIM",
  SystemEmail = "SYSTEM_EMAIL",
  SystemInsurer = "SYSTEM_INSURER",
  SystemOffer = "SYSTEM_OFFER",
  SystemPlaceit = "SYSTEM_PLACEIT",
  SystemReinsurer = "SYSTEM_REINSURER",
}

export type Offer = {
  __typename?: "Offer";
  brokerage: Scalars["Float"]["output"];
  claim_status: Claim_Status;
  classofbusiness: Maybe<Class_Of_Business>;
  commission: Scalars["Float"]["output"];
  commission_amount: Maybe<Scalars["Float"]["output"]>;
  created_at: Scalars["DateTime"]["output"];
  distribute_status: Maybe<Scalars["String"]["output"]>;
  employee: Employee;
  expiry_status: Expiry_Status;
  fac_premium: Scalars["Float"]["output"];
  fac_sum_insured: Scalars["Float"]["output"];
  facultative_offer: Scalars["Float"]["output"];
  insurer: Maybe<Insurer>;
  offerPublishedParticipants: Maybe<Array<Maybe<OfferPublishedParticipant>>>;
  offer_associates: Maybe<Array<Maybe<Offer_To_Associates>>>;
  offer_claims: Maybe<Array<Maybe<Offer_Claim>>>;
  offer_detail: Maybe<Offer_Details>;
  offer_endorsements: Maybe<Array<Maybe<OfferEndorsement>>>;
  offer_from: Maybe<Scalars["String"]["output"]>;
  offer_id: Scalars["ID"]["output"];
  offer_participant: Maybe<Array<Maybe<Offer_Participant>>>;
  offer_participant_payment: Maybe<Array<Maybe<Offer_Participant_Payment>>>;
  offer_payment: Maybe<Array<Maybe<Offer_Payment>>>;
  offer_published: Maybe<OfferPublished>;
  offer_status: Offer_Status;
  participating_number: Maybe<Array<Maybe<Offer_To_Associates>>>;
  payment_status: Payment_Status;
  place_it_id: Maybe<Scalars["String"]["output"]>;
  premium: Scalars["Float"]["output"];
  rate: Scalars["Float"]["output"];
  reinsurer_offer_extra_charge: Maybe<Offer_Extra_Charges>;
  sum_insured: Scalars["Float"]["output"];
  thread_notification: Maybe<Array<Maybe<ThreadNotification>>>;
  updated_at: Scalars["DateTime"]["output"];
};

export type OfferClaim = {
  __typename?: "OfferClaim";
  claim_amount: Maybe<Scalars["Float"]["output"]>;
  claim_comment: Maybe<Scalars["String"]["output"]>;
  claim_date: Maybe<Scalars["Date"]["output"]>;
  currency: Maybe<Scalars["String"]["output"]>;
  offer: Maybe<Offer>;
  offer_claim_id: Scalars["ID"]["output"];
  rate: Maybe<Scalars["String"]["output"]>;
};

export type OfferClaimParticipant = {
  __typename?: "OfferClaimParticipant";
  claim_share: Scalars["Float"]["output"];
  created_at: Scalars["DateTime"]["output"];
  delete_status: Scalars["String"]["output"];
  offer_claim: OfferClaim;
  offer_claim_participant_id: Scalars["ID"]["output"];
  offer_claim_participant_payment: Maybe<
    Array<Maybe<OfferClaimParticipantPayment>>
  >;
  offer_participant: OfferParticipant;
  payment_status: Maybe<Payment_Status>;
  updated_at: Scalars["DateTime"]["output"];
};

export type OfferClaimParticipantPayment = {
  __typename?: "OfferClaimParticipantPayment";
  claim_share_payment_amount: Scalars["Float"]["output"];
  created_at: Scalars["DateTime"]["output"];
  delete_status: DeleteStatusEnum;
  offer_claim_participant: OfferClaimParticipant;
  offer_claim_participant_payment_id: Scalars["ID"]["output"];
  payment_comment: Maybe<Scalars["String"]["output"]>;
  payment_date: Scalars["Date"]["output"];
  payment_details: Scalars["String"]["output"];
  updated_at: Scalars["DateTime"]["output"];
};

export type OfferClaimParticipantPaymentInput = {
  claim_share_payment_amount: Scalars["Float"]["input"];
  offer_claim_participant: Scalars["ID"]["input"];
  payment_comment: InputMaybe<Scalars["String"]["input"]>;
  payment_date: Scalars["Date"]["input"];
  payment_details: Scalars["String"]["input"];
};

export type OfferClaimParticipantPaymentOutput = {
  __typename?: "OfferClaimParticipantPaymentOutput";
  claim_share_payment_amount: Scalars["Float"]["output"];
  created_at: Scalars["DateTime"]["output"];
  delete_status: DeleteStatusEnum;
  offer_claim_participant: Scalars["ID"]["output"];
  offer_claim_participant_payment_id: Scalars["ID"]["output"];
  payment_comment: Maybe<Scalars["String"]["output"]>;
  payment_date: Scalars["Date"]["output"];
  payment_details: Scalars["String"]["output"];
  updated_at: Scalars["DateTime"]["output"];
};

export type OfferDocument = {
  __typename?: "OfferDocument";
  created_at: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  path: Scalars["String"]["output"];
  size: Maybe<Scalars["Int"]["output"]>;
  type: Maybe<Scalars["String"]["output"]>;
  url: Scalars["String"]["output"];
};

export type OfferEndorsement = {
  __typename?: "OfferEndorsement";
  approval_status: Maybe<Scalars["String"]["output"]>;
  brokerage: Maybe<Scalars["Float"]["output"]>;
  classofbusiness: Maybe<Class_Of_Business>;
  co_insurance_share: Maybe<Scalars["Float"]["output"]>;
  commission: Maybe<Scalars["Float"]["output"]>;
  commission_amount: Maybe<Scalars["Float"]["output"]>;
  created_at: Maybe<Scalars["DateTime"]["output"]>;
  endorsement_email: Maybe<Array<Maybe<OfferEndorsementToReinsurer>>>;
  endorsement_status: Maybe<Offer_Status>;
  fac_premium: Maybe<Scalars["Float"]["output"]>;
  fac_sum_insured: Maybe<Scalars["Float"]["output"]>;
  facultative_offer: Maybe<Scalars["Float"]["output"]>;
  insurer: Maybe<Insurer>;
  offer: Maybe<Offer>;
  offer_endorsement_detail: Maybe<OfferEndorsementDetail>;
  offer_endorsement_id: Maybe<Scalars["ID"]["output"]>;
  offer_endorsement_participants: Maybe<
    Array<Maybe<OfferEndorsementParticipants>>
  >;
  premium: Maybe<Scalars["Float"]["output"]>;
  rate: Maybe<Scalars["Float"]["output"]>;
  sum_insured: Maybe<Scalars["Float"]["output"]>;
  updated_at: Maybe<Scalars["Date"]["output"]>;
};

export type OfferEndorsementDetail = {
  __typename?: "OfferEndorsementDetail";
  currency: Maybe<Scalars["String"]["output"]>;
  information_comment: Maybe<Scalars["String"]["output"]>;
  insured_by: Maybe<Scalars["String"]["output"]>;
  offer_comment: Maybe<Scalars["String"]["output"]>;
  offer_detail: Maybe<Scalars["String"]["output"]>;
  offer_endorsement_detail_id: Maybe<Scalars["ID"]["output"]>;
  period_of_insurance_from: Maybe<Scalars["Date"]["output"]>;
  period_of_insurance_to: Maybe<Scalars["Date"]["output"]>;
  policy_number: Maybe<Scalars["String"]["output"]>;
};

export type OfferEndorsementExtraCharge = {
  __typename?: "OfferEndorsementExtraCharge";
  end_agreed_brokerage_percentage: Maybe<Scalars["Float"]["output"]>;
  end_agreed_commission: Maybe<Scalars["Float"]["output"]>;
  end_agreed_commission_amount: Maybe<Scalars["Float"]["output"]>;
  end_brokerage_amount: Maybe<Scalars["Float"]["output"]>;
  end_nic_levy: Maybe<Scalars["Float"]["output"]>;
  end_nic_levy_amount: Maybe<Scalars["Float"]["output"]>;
  end_withholding_tax: Maybe<Scalars["Float"]["output"]>;
  end_withholding_tax_amount: Maybe<Scalars["Float"]["output"]>;
};

export type OfferEndorsementParticipants = {
  __typename?: "OfferEndorsementParticipants";
  offer_end_amount: Maybe<Scalars["Float"]["output"]>;
  offer_end_participant_fac_premium: Maybe<Scalars["Float"]["output"]>;
  offer_end_participant_fac_sum_insured: Maybe<Scalars["Float"]["output"]>;
  offer_end_participant_id: Maybe<Scalars["ID"]["output"]>;
  offer_end_participant_percentage: Maybe<Scalars["Float"]["output"]>;
  offer_endorsement_extra_charges: Maybe<OfferEndorsementExtraCharge>;
  reinsurer: Maybe<Reinsurer>;
};

export type OfferEndorsementToReinsurer = {
  __typename?: "OfferEndorsementToReinsurer";
  email_content: Maybe<Scalars["String"]["output"]>;
  endorsement_to_reinsurer: Maybe<Array<Maybe<OfferEndorsementToReinsurerRep>>>;
  offer_endorsement_to_reinsurer_id: Maybe<Scalars["ID"]["output"]>;
  sent_status: Maybe<Sent_Status>;
};

export type OfferEndorsementToReinsurerRep = {
  __typename?: "OfferEndorsementToReinsurerRep";
  offer_endorsement_to_reinsurers_rep_id: Maybe<Scalars["ID"]["output"]>;
  reinsurer: Maybe<Reinsurer>;
  reinsurer_rep: Maybe<Reinsurer_Representative>;
};

export type OfferFilters = {
  claim_status: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  class_of_business_id: InputMaybe<Scalars["ID"]["input"]>;
  insurer_id: InputMaybe<Scalars["ID"]["input"]>;
  limit: InputMaybe<Scalars["Int"]["input"]>;
  offer_from: InputMaybe<Scalars["String"]["input"]>;
  offset: InputMaybe<Scalars["Int"]["input"]>;
  payment_status: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  search: InputMaybe<Scalars["String"]["input"]>;
  status: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  year: InputMaybe<Scalars["String"]["input"]>;
};

export type OfferFiltersReinsurer = {
  limit: InputMaybe<Scalars["Int"]["input"]>;
  offset: InputMaybe<Scalars["Int"]["input"]>;
  reinsurer_id: InputMaybe<Scalars["ID"]["input"]>;
  search: InputMaybe<Scalars["String"]["input"]>;
  status: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  year: InputMaybe<Scalars["String"]["input"]>;
};

export type OfferParticipant = {
  __typename?: "OfferParticipant";
  offer_participantsoffer_participant_id: Scalars["ID"]["output"];
};

export type OfferParticipantTransactionThreadInput = {
  offer_participant_id: Scalars["ID"]["input"];
};

export type OfferPaymentInput = {
  offer_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type OfferPublished = {
  __typename?: "OfferPublished";
  created_at: Scalars["DateTime"]["output"];
  employee: Maybe<Employee>;
  employeesemployee_id: Maybe<Scalars["Int"]["output"]>;
  offer: Offer;
  offer_published_id: Scalars["ID"]["output"];
  published_status: PublishedStatus;
  status: Scalars["String"]["output"];
  time_of_expiry: Scalars["String"]["output"];
  updated_at: Scalars["DateTime"]["output"];
  updated_by: Maybe<Scalars["Int"]["output"]>;
};

export type OfferPublishedParticipant = {
  __typename?: "OfferPublishedParticipant";
  offer: Offer;
  offer_participant_percentage: Scalars["Float"]["output"];
  offer_published_participant_id: Scalars["ID"]["output"];
  participation_status: Scalars["String"]["output"];
  reinsurer: Reinsurer;
  reinsurer_representative: Maybe<ReinsurerRepresentative>;
  transaction_thread: Scalars["String"]["output"];
  unread_messages: Maybe<Array<Maybe<TransactionThread>>>;
};

export enum OfferStatus {
  Closed = "CLOSED",
  Open = "OPEN",
  Pending = "PENDING",
}

export type OfferTransactionThreadInput = {
  offer_published_participant_id: InputMaybe<Scalars["ID"]["input"]>;
  reinsurer_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type Offer_Claim = {
  __typename?: "Offer_claim";
  claim_amount: Maybe<Scalars["Float"]["output"]>;
  claim_comment: Maybe<Scalars["String"]["output"]>;
  claim_date: Maybe<Scalars["Date"]["output"]>;
  created_at: Maybe<Scalars["DateTime"]["output"]>;
  offer_claim_id: Maybe<Scalars["ID"]["output"]>;
  offer_claim_participants: Maybe<Array<Maybe<Offer_Claim_Participant>>>;
};

export type Offer_Claim_Participant = {
  __typename?: "Offer_claim_participant";
  claim_share: Scalars["Float"]["output"];
  created_at: Scalars["DateTime"]["output"];
  offer_claim: Maybe<Offer_Claim>;
  offer_claim_participant_id: Maybe<Scalars["ID"]["output"]>;
  offer_claim_participant_payments: Maybe<
    Array<Maybe<OfferClaimParticipantPayment>>
  >;
  offer_claimsoffer_claim_id: Maybe<Scalars["ID"]["output"]>;
  offer_participant: Maybe<Offer_Participant>;
  offer_participant_percentage: Maybe<Scalars["Float"]["output"]>;
  offer_participantsoffer_participant_id: Maybe<Scalars["ID"]["output"]>;
  re_company_name: Maybe<Scalars["String"]["output"]>;
  reinsurer_id: Maybe<Scalars["ID"]["output"]>;
};

export type Offer_Data = {
  brokerage: Scalars["Float"]["input"];
  class_of_business_id: Scalars["ID"]["input"];
  commission: Scalars["Float"]["input"];
  currency: Scalars["String"]["input"];
  employee_id: Scalars["ID"]["input"];
  facultative_offer: Scalars["Float"]["input"];
  insured_by: Scalars["String"]["input"];
  insurer_id: Scalars["ID"]["input"];
  offer_comment: InputMaybe<Scalars["String"]["input"]>;
  offer_details: Scalars["String"]["input"];
  period_of_insurance_from: Scalars["Date"]["input"];
  period_of_insurance_to: Scalars["Date"]["input"];
  policy_number: InputMaybe<Scalars["String"]["input"]>;
  premium: Scalars["Float"]["input"];
  rate: Scalars["Float"]["input"];
  sum_insured: Scalars["Float"]["input"];
};

export type Offer_Deduction_Payment = {
  __typename?: "Offer_deduction_payment";
  brokerage_amount_paid: Maybe<Scalars["Float"]["output"]>;
  commission_taken: Maybe<Scalars["Float"]["output"]>;
  nic_levy_paid: Maybe<Scalars["Float"]["output"]>;
  offer_deduction_payment_id: Scalars["ID"]["output"];
  withholding_tax_paid: Maybe<Scalars["Float"]["output"]>;
};

export type Offer_Details = {
  __typename?: "Offer_details";
  currency: Scalars["String"]["output"];
  insured_by: Scalars["String"]["output"];
  offer_comment: Maybe<Scalars["String"]["output"]>;
  offer_detail_id: Scalars["ID"]["output"];
  offer_details: Maybe<Scalars["String"]["output"]>;
  offersoffer_id: Scalars["ID"]["output"];
  period_of_insurance_from: Maybe<Scalars["Date"]["output"]>;
  period_of_insurance_to: Maybe<Scalars["Date"]["output"]>;
  policy_number: Maybe<Scalars["String"]["output"]>;
  updated_at: Scalars["DateTime"]["output"];
};

export type Offer_Edit_Extra_Charge_Data = {
  offer_id: InputMaybe<Scalars["ID"]["input"]>;
  reinsurer_data: Reinsurer_Extra_Charge;
};

export type Offer_Extra_Charge_Data = {
  offer_id: InputMaybe<Scalars["ID"]["input"]>;
  participant_data: Array<ParticipantReasonInput>;
  reinsurer_data: Array<Reinsurer_Extra_Charge>;
};

export type Offer_Extra_Charges = {
  __typename?: "Offer_extra_charges";
  agreed_brokerage_percentage: Scalars["Float"]["output"];
  agreed_commission: Maybe<Scalars["Float"]["output"]>;
  agreed_commission_amount: Maybe<Scalars["Float"]["output"]>;
  brokerage_amount: Scalars["Float"]["output"];
  created_at: Scalars["DateTime"]["output"];
  nic_levy: Scalars["Float"]["output"];
  nic_levy_amount: Scalars["Float"]["output"];
  offer_extra_charge_id: Scalars["ID"]["output"];
  overrider: Maybe<Scalars["Float"]["output"]>;
  overrider_amount: Maybe<Scalars["Float"]["output"]>;
  reinsurer: Reinsurer;
  withholding_tax: Scalars["Float"]["output"];
  withholding_tax_amount: Scalars["Float"]["output"];
};

export type Offer_Participant = {
  __typename?: "Offer_participant";
  created_at: Scalars["DateTime"]["output"];
  offer: Maybe<Offer>;
  offer_amount: Maybe<Scalars["Float"]["output"]>;
  offer_deduction_charge: Maybe<Offer_Deduction_Payment>;
  offer_detail: Maybe<Offer_Details>;
  offer_extra_charges: Maybe<Offer_Extra_Charges>;
  offer_participant_id: Maybe<Scalars["ID"]["output"]>;
  offer_participant_payment: Maybe<Array<Maybe<Offer_Participant_Payment>>>;
  offer_participant_percentage: Maybe<Scalars["Float"]["output"]>;
  offer_published_participant: Maybe<OfferPublishedParticipant>;
  offersoffer_id: Maybe<Scalars["ID"]["output"]>;
  participant_associates: Maybe<Array<Maybe<Offer_To_Associates>>>;
  participant_fac_premium: Maybe<Scalars["Float"]["output"]>;
  participant_fac_sum_insured: Maybe<Scalars["Float"]["output"]>;
  reinsurer: Reinsurer;
  reinsurer_offers_only: Offer;
  thread_notification: Maybe<Array<Maybe<ThreadNotification>>>;
};

export type Offer_Participant_Payment = {
  __typename?: "Offer_participant_payment";
  created_at: Scalars["DateTime"]["output"];
  offer_deduction_charge: Maybe<Offer_Deduction_Payment>;
  offer_participant: Maybe<Offer_Participant>;
  offer_participant_payment_comment: Scalars["String"]["output"];
  offer_participant_payment_id: Scalars["ID"]["output"];
  offer_payment_amount: Scalars["Float"]["output"];
  paid_details: Scalars["String"]["output"];
  payment_status: Payment_Status;
  reinsurer: Reinsurer;
  updated_at: Scalars["DateTime"]["output"];
};

export type Offer_Participant_Payment_Details = {
  offer_participant_payment_id: Scalars["ID"]["input"];
  paid_details: Scalars["String"]["input"];
  payment_comment: Scalars["String"]["input"];
};

export type Offer_Participant_Payment_Update = {
  offer_id: Scalars["ID"]["input"];
  offer_participants: Array<InputMaybe<Offer_Participant_Payment_Details>>;
  offer_payment_id: Scalars["ID"]["input"];
};

export type Offer_Payment = {
  __typename?: "Offer_payment";
  created_at: Scalars["DateTime"]["output"];
  distribute_payment: Maybe<Scalars["String"]["output"]>;
  offer: Maybe<Offer>;
  offer_participant_payment: Maybe<Offer_Participant_Payment>;
  offer_payment_comment: Scalars["String"]["output"];
  offer_payment_id: Scalars["ID"]["output"];
  payment_amount: Scalars["Float"]["output"];
  payment_details: Scalars["String"]["output"];
  updated_at: Scalars["DateTime"]["output"];
};

export type Offer_Payment_Data = {
  Offer_payment_comment: Scalars["String"]["input"];
  offer_id: Scalars["ID"]["input"];
  payment_amount: Scalars["Float"]["input"];
  payment_details: Scalars["String"]["input"];
};

export type Offer_Payment_Update_Data = {
  Offer_payment_comment: Scalars["String"]["input"];
  auto_payment_receipt: InputMaybe<Scalars["Boolean"]["input"]>;
  date_of_receipt: InputMaybe<Scalars["Date"]["input"]>;
  offer_id: Scalars["ID"]["input"];
  offer_payment_id: Scalars["ID"]["input"];
  payment_amount: Scalars["Float"]["input"];
  payment_details: Scalars["String"]["input"];
  payment_status: InputMaybe<Scalars["String"]["input"]>;
};

export enum Offer_Status {
  Closed = "CLOSED",
  Open = "OPEN",
  Pending = "PENDING",
}

export type Offer_To_Associates = {
  __typename?: "Offer_to_associates";
  created_at: Scalars["DateTime"]["output"];
  message_attachment: Maybe<Scalars["String"]["output"]>;
  message_content: Scalars["String"]["output"];
  offer_participants: Maybe<Array<Maybe<Offer_Participant>>>;
  offer_to_associate_id: Scalars["ID"]["output"];
  reinsurer_representative: Maybe<Reinsurer_Representative>;
  sent_status: Sent_Status;
};

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  field: Scalars["String"]["input"];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

export type P_Treaty_Data = {
  attachment: InputMaybe<Array<InputMaybe<Scalars["Upload"]["input"]>>>;
  copied_emails: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  message: Scalars["String"]["input"];
  note_meta_data: InputMaybe<MetaData>;
  subject: Scalars["String"]["input"];
};

/** Pagination information about the corresponding list of items. */
export type PageInfo = {
  __typename?: "PageInfo";
  /** Count of nodes in current request. */
  count: Maybe<Scalars["Int"]["output"]>;
  /** Current page of request. */
  currentPage: Maybe<Scalars["Int"]["output"]>;
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars["String"]["output"]>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars["Boolean"]["output"];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars["Boolean"]["output"];
  /** Last page in connection. */
  lastPage: Maybe<Scalars["Int"]["output"]>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars["String"]["output"]>;
  /** Total number of node in connection. */
  total: Maybe<Scalars["Int"]["output"]>;
};

export type Pagination = {
  limit: InputMaybe<Scalars["Int"]["input"]>;
  offset: InputMaybe<Scalars["Int"]["input"]>;
};

/** Pagination information about the corresponding list of items. */
export type PaginatorInfo = {
  __typename?: "PaginatorInfo";
  /** Total count of available items in the page. */
  count: Scalars["Int"]["output"];
  /** Current pagination page. */
  currentPage: Scalars["Int"]["output"];
  /** Index of first item in the current page. */
  firstItem: Maybe<Scalars["Int"]["output"]>;
  /** If collection has more pages. */
  hasMorePages: Scalars["Boolean"]["output"];
  /** Index of last item in the current page. */
  lastItem: Maybe<Scalars["Int"]["output"]>;
  /** Last page number of the collection. */
  lastPage: Scalars["Int"]["output"];
  /** Number of items per page in the collection. */
  perPage: Scalars["Int"]["output"];
  /** Total items available in the collection. */
  total: Scalars["Int"]["output"];
};

export type PaidChequesForStatement = {
  __typename?: "PaidChequesForStatement";
  cheque_number: Maybe<Scalars["String"]["output"]>;
  offer_ids: Maybe<Array<Maybe<Scalars["ID"]["output"]>>>;
  payment_ids: Maybe<Array<Maybe<Scalars["ID"]["output"]>>>;
  reinsured: Maybe<Scalars["String"]["output"]>;
};

export type ParticipantInfo = {
  __typename?: "ParticipantInfo";
  id: Scalars["ID"]["output"];
  layer_number: Scalars["Int"]["output"];
  percentage: Scalars["Float"]["output"];
};

export type ParticipantReasonInput = {
  participant_id: Scalars["ID"]["input"];
  reason: InputMaybe<Scalars["String"]["input"]>;
};

export type PaymentDetails = {
  auto_payment_receipt: InputMaybe<Scalars["Boolean"]["input"]>;
  cheque_clearance_status: InputMaybe<Cheque_Status>;
  date_of_receipt: InputMaybe<Scalars["Date"]["input"]>;
  installment_type: Scalars["Int"]["input"];
  payment_amount: Scalars["Float"]["input"];
  payment_comment: InputMaybe<Scalars["String"]["input"]>;
  payment_details: Scalars["String"]["input"];
  payment_id: InputMaybe<Scalars["ID"]["input"]>;
  payment_status: Scalars["String"]["input"];
  treaty_account_id: InputMaybe<Scalars["ID"]["input"]>;
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
  uuid: InputMaybe<Scalars["String"]["input"]>;
};

export enum Payment_Status {
  Paid = "PAID",
  Partpayment = "PARTPAYMENT",
  Unpaid = "UNPAID",
}

export type PointsRedemption = {
  __typename?: "PointsRedemption";
  redeemed_by: Maybe<RedeemedUser>;
};

export type PortFolioEntry = {
  assumption_loss_percentage: InputMaybe<Scalars["Float"]["input"]>;
  assumption_percentage: InputMaybe<Scalars["Float"]["input"]>;
  withdrawal_loss_percentage: InputMaybe<Scalars["Float"]["input"]>;
  withdrawal_percentage: InputMaybe<Scalars["Float"]["input"]>;
};

export type PrevYearConfigurationData = {
  outgoing_loss_portfolio: InputMaybe<Scalars["Float"]["input"]>;
  outgoing_premium_portfolio: InputMaybe<Scalars["Float"]["input"]>;
};

export type ProjectedRevenue = {
  __typename?: "ProjectedRevenue";
  amount: Maybe<Scalars["Float"]["output"]>;
  currencyCode: Maybe<Scalars["String"]["output"]>;
};

export enum PublishedStatus {
  Published = "PUBLISHED",
  Unpublished = "UNPUBLISHED",
}

export type Query = {
  __typename?: "Query";
  allEndorsements: Maybe<Array<Maybe<Offer>>>;
  allUnapprovedEndorsements: Maybe<Array<Maybe<OfferEndorsement>>>;
  all_treaties: Maybe<Array<Maybe<Treaty>>>;
  assignedOffers: Array<Offer>;
  assignedToMe: Maybe<Array<Maybe<Insurer>>>;
  broker: Maybe<ReBroker>;
  broker_treaties: Maybe<Array<Maybe<ReBrokerTreatiesParticipation>>>;
  brokers: Maybe<Array<Maybe<ReBroker>>>;
  claimOverview: Maybe<Scalars["String"]["output"]>;
  classOfBusinesses: Array<Class_Of_Business>;
  dashboardByPieChartData: Maybe<Array<Maybe<DashboardPieChart>>>;
  employee: Maybe<Employee>;
  employees: Array<Employee>;
  fetchLeaderboardStatistics: Maybe<LeaderboardResponse>;
  fetchTarget: Maybe<Target>;
  fetchTargetBadge: Maybe<TargetBadge>;
  fetchTargetRate: Maybe<Rate>;
  fetchTargetRates: Maybe<Array<Maybe<TargetRate>>>;
  fetchTargets: Maybe<Array<Maybe<Target>>>;
  fetchTotalCashAccumulated: Maybe<TotalCashAccumulated>;
  fetchTreatyAccounts: Maybe<Array<Maybe<AccountResponse>>>;
  fetchUnreadTransactionThreadMessagesForBroker: Maybe<
    Array<Maybe<TransactionThread>>
  >;
  findSingleOffer: Offer;
  generateHistoricDataOnOffers: Maybe<Scalars["String"]["output"]>;
  getAllPointRedemptionUsages: Array<Usage>;
  getAutoFacConfig: Array<AutoFacConfig>;
  getAutoFacConfigCount: Scalars["Int"]["output"];
  getAutoFacConfiguration: Maybe<AutoFacConfig>;
  getAutoFacParticipant: Maybe<AutoFacParticipant>;
  getAutoFacParticipantCount: Scalars["Int"]["output"];
  getAutoFacParticipantDeduction: Maybe<AutoFacParticipantDeductions>;
  getAutoFacParticipantDeductionCount: Scalars["Int"]["output"];
  getAutoFacParticipantDeductions: Array<AutoFacParticipantDeductions>;
  getAutoFacParticipants: Array<AutoFacParticipant>;
  getBatchReports: Array<Report>;
  getBatchReportsCount: Scalars["Int"]["output"];
  getBrokerAssociate: Maybe<ReBrokerAssociate>;
  getBrokerAssociates: Maybe<Array<Maybe<ReBrokerAssociate>>>;
  getBusinessCategories: Maybe<Array<Maybe<BusinessCategory>>>;
  getClaimShare: Maybe<Offer_Claim_Participant>;
  getClaimShares: Maybe<Array<Maybe<Offer_Claim_Participant>>>;
  getClassOfBusinessCount: Maybe<Scalars["Int"]["output"]>;
  getDashboardOverview: Maybe<DashboardOverview>;
  getEmployeesCount: Maybe<Scalars["Int"]["output"]>;
  getEndorsementParticipant: Maybe<OfferEndorsementParticipants>;
  getEndorsementParticipants: Maybe<Array<Maybe<OfferEndorsement>>>;
  getEndorsements: Maybe<Array<Maybe<OfferEndorsement>>>;
  getEndorsementsCount: Maybe<Scalars["Int"]["output"]>;
  getInsurerAssociate: Maybe<Insurer_Associate>;
  getInsurerAssociates: Maybe<Array<Maybe<Insurer_Associate>>>;
  getInsurerOffersCount: Maybe<Scalars["Int"]["output"]>;
  getInsurerRep: Maybe<Insurer_Associate>;
  getInsurersCount: Maybe<Scalars["Int"]["output"]>;
  getNonProportionalReceivablePayment: ReceivablePayment;
  getNonProportionalReceivablePayments: Array<ReceivablePayment>;
  getNonProportionalReceivablePaymentsLength: Scalars["Int"]["output"];
  getNonProportionalTreatyPayment: Maybe<TreatyNpPayment>;
  getNonProportionalTreatyPayments: Maybe<Array<TreatyNpPayment>>;
  getNonProportionalTreatyPaymentsCount: Scalars["Int"]["output"];
  getNotAcceptedParticipants: Array<OfferPublishedParticipant>;
  getNotifications: Maybe<Array<Maybe<EmployeeNotification>>>;
  getNotificationsCount: Maybe<Scalars["Int"]["output"]>;
  getOfferAssociates: Maybe<Array<Maybe<Offer_To_Associates>>>;
  getOfferClaimParticipantPayments: Maybe<
    Array<Maybe<OfferClaimParticipantPayment>>
  >;
  getOfferClaims: Maybe<Array<Maybe<OfferClaim>>>;
  getOfferFleet: Maybe<Array<Maybe<MotorFleet>>>;
  getOfferParticipant: Maybe<Offer_Participant>;
  getOfferParticipants: Maybe<Array<Maybe<OfferParticipant>>>;
  getOfferPayment: Maybe<Offer_Payment>;
  getOfferPayments: Maybe<Array<Maybe<Offer_Payment>>>;
  getOfferPublishedParticipants: Array<OfferPublishedParticipant>;
  getOfferparticipantDeductions: Maybe<Scalars["String"]["output"]>;
  getOffers: Maybe<Array<Maybe<Offer>>>;
  getOffersCount: Maybe<Scalars["Int"]["output"]>;
  getPaidChequesForStatement: Maybe<Array<Maybe<PaidChequesForStatement>>>;
  getPointRedemptionUsage: Usage;
  getProportionalTreatyPayment: Maybe<TreatyPPayment>;
  getProportionalTreatyPayments: Maybe<Array<TreatyPPayment>>;
  getProportionalTreatyPaymentsCount: Scalars["Int"]["output"];
  getProportionalTreatyRelatedCurrencies: Maybe<
    Array<Maybe<TreatyRelatedCurrencies>>
  >;
  getReceivablePayments: Maybe<Array<Maybe<ReceivablePayment>>>;
  getReinsurerAssociates: Maybe<Array<Maybe<Reinsurer_Representative>>>;
  getReinsurerAssociatesCount: Maybe<Scalars["Int"]["output"]>;
  getReinsurerDeductions: Maybe<Array<Maybe<ReinsurerDeduction>>>;
  getReinsurerOffer: Maybe<Offer_Participant>;
  getReinsurerOffers: Maybe<Array<Maybe<Offer_Participant>>>;
  getReinsurerOffersCount: Maybe<Scalars["Int"]["output"]>;
  getReinsurerParticipantPayment: Maybe<Offer_Participant_Payment>;
  getReinsurerParticipantPayments: Maybe<
    Array<Maybe<Offer_Participant_Payment>>
  >;
  getReinsurerRep: Maybe<Reinsurer_Representative>;
  getReinsurerReps: Maybe<Array<Maybe<Reinsurer_Representative>>>;
  getReinsurersCount: Maybe<Scalars["Int"]["output"]>;
  getSupportingDocsList: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  getTreaties: Maybe<Array<Maybe<Treaty>>>;
  getTreatiesCount: Maybe<Scalars["Int"]["output"]>;
  getTreatyBrokerAssociates: Maybe<
    Array<Maybe<TreatyParticipationToBrokerAssociates>>
  >;
  getTreatyBrokerParticipation: Maybe<ReBrokerTreatiesParticipation>;
  getTreatyBrokersParticipants: Maybe<
    Array<Maybe<ReBrokerTreatiesParticipation>>
  >;
  getTreatyClaim: Maybe<TreatyClaim>;
  getTreatyClaimPayment: Maybe<ClaimPayment>;
  getTreatyClaimPayments: Maybe<Array<Maybe<ClaimPayment>>>;
  getTreatyClaimShare: Maybe<ClaimShare>;
  getTreatyClaimShares: Maybe<Array<Maybe<ClaimShare>>>;
  getTreatyClaims: Maybe<Array<Maybe<TreatyClaim>>>;
  getTreatyClaimsCount: Maybe<Scalars["Int"]["output"]>;
  getTreatyEndorsement: Maybe<TreatyEndorsement>;
  getTreatyEndorsements: Maybe<Array<Maybe<TreatyEndorsement>>>;
  getTreatyEndorsementsCount: Maybe<Scalars["Int"]["output"]>;
  getTreatyProgramDeduction: Maybe<TreatyAssociateDeduction>;
  getTreatyProgramDeductions: Maybe<Array<Maybe<TreatyAssociateDeduction>>>;
  getTreatyPrograms: Maybe<Array<Maybe<TreatyProgram>>>;
  getTreatyProgramsCount: Maybe<Scalars["Int"]["output"]>;
  getTreatyReinsurerAssociates: Maybe<Array<Maybe<TreatyToAssociate>>>;
  getTreatyReinsurerParticipants: Maybe<Array<Maybe<TreatyParticipation>>>;
  getTreatyReinsurerParticipation: Maybe<TreatyParticipation>;
  getUnReadNotificationMessages: Maybe<Array<Maybe<Offer>>>;
  getUserActivities: Array<Log_Activity>;
  getUserActivitiesCount: Scalars["Int"]["output"];
  insurer: Maybe<Insurer>;
  insurerTreatyProgram: Maybe<Array<Maybe<TreatyProgram>>>;
  insurers: Array<Insurer>;
  offerDocuments: Array<OfferDocument>;
  offerOverview: Scalars["String"]["output"];
  offerParticipantTransactionThread: Array<ThreadMessage>;
  offerTransactionThread: Array<ThreadMessage>;
  offers: Array<Offer>;
  publishedOffers: Array<OfferPublished>;
  publishedOffersCount: Scalars["Int"]["output"];
  readParticipationsForEndorsement: Maybe<Scalars["String"]["output"]>;
  readSystemNotifications: Maybe<Employee>;
  reinsurer: Reinsurer;
  reinsurers: Array<Reinsurer>;
  reportPieChartData: Maybe<Scalars["String"]["output"]>;
  singleClassOfBusiness: Class_Of_Business;
  singleEndorsement: Maybe<OfferEndorsement>;
  treaties: Maybe<Array<Maybe<Treaty>>>;
  treaty: Maybe<Treaty>;
  treatyAssociateDeduction: Maybe<TreatyAssociateDeduction>;
  treatyAssociateDeductions: Maybe<Array<Maybe<TreatyAssociateDeduction>>>;
  treatyProgram: Maybe<TreatyProgram>;
  treatyPrograms: Maybe<Array<Maybe<TreatyProgram>>>;
  treatyProgramsCount: Maybe<Scalars["Int"]["output"]>;
  treatyReinsurerAccountsPayment: Maybe<Array<Maybe<TreatyAccount>>>;
  treatyYears: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export type QueryAssignedOffersArgs = {
  for?: InputMaybe<Scalars["ID"]["input"]>;
  offer_status: Array<InputMaybe<Scalars["String"]["input"]>>;
  year?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAssignedToMeArgs = {
  staff_id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryBrokerArgs = {
  broker_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryBroker_TreatiesArgs = {
  re_broker_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryClaimOverviewArgs = {
  offer_status: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type QueryClassOfBusinessesArgs = {
  category?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryDashboardByPieChartDataArgs = {
  for?: InputMaybe<Scalars["ID"]["input"]>;
  month: InputMaybe<Scalars["String"]["input"]>;
  year: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryEmployeeArgs = {
  employee_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryFetchLeaderboardStatisticsArgs = {
  badge: InputMaybe<Scalars["String"]["input"]>;
  broker_id: Scalars["ID"]["input"];
  end_date: InputMaybe<Scalars["String"]["input"]>;
  start_date: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryFetchTargetArgs = {
  target_id: Scalars["ID"]["input"];
};

export type QueryFetchTargetBadgeArgs = {
  target_badge_id: Scalars["ID"]["input"];
};

export type QueryFetchTargetRateArgs = {
  target_rate_id: Scalars["ID"]["input"];
};

export type QueryFetchTargetRatesArgs = {
  target_id: Scalars["ID"]["input"];
};

export type QueryFetchTargetsArgs = {
  broker_id: Scalars["ID"]["input"];
};

export type QueryFetchTotalCashAccumulatedArgs = {
  year: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryFetchTreatyAccountsArgs = {
  insurer_id: InputMaybe<Scalars["ID"]["input"]>;
  quarter: InputMaybe<Scalars["String"]["input"]>;
  treaty_period_from: InputMaybe<Scalars["Date"]["input"]>;
  treaty_period_to: InputMaybe<Scalars["Date"]["input"]>;
  treaty_program_name: InputMaybe<Scalars["String"]["input"]>;
  type: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryFindSingleOfferArgs = {
  offer_id: Scalars["ID"]["input"];
};

export type QueryGenerateHistoricDataOnOffersArgs = {
  offer_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetAllPointRedemptionUsagesArgs = {
  broker_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetAutoFacConfigArgs = {
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
};

export type QueryGetAutoFacConfigurationArgs = {
  auto_fac_configuration_id: Scalars["ID"]["input"];
};

export type QueryGetAutoFacParticipantArgs = {
  auto_fac_participant_id: Scalars["ID"]["input"];
};

export type QueryGetAutoFacParticipantCountArgs = {
  auto_fac_config_id: Scalars["Int"]["input"];
};

export type QueryGetAutoFacParticipantDeductionArgs = {
  auto_fac_participant_deduction_id: Scalars["ID"]["input"];
};

export type QueryGetAutoFacParticipantDeductionCountArgs = {
  auto_fac_participant_id: Scalars["Int"]["input"];
};

export type QueryGetAutoFacParticipantDeductionsArgs = {
  auto_fac_participant_id: Scalars["Int"]["input"];
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
};

export type QueryGetAutoFacParticipantsArgs = {
  auto_fac_config_id: Scalars["Int"]["input"];
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
};

export type QueryGetBatchReportsArgs = {
  filter: InputMaybe<BatchReportFilter>;
  pagination: InputMaybe<Pagination>;
};

export type QueryGetBatchReportsCountArgs = {
  filter: InputMaybe<BatchReportFilter>;
};

export type QueryGetBrokerAssociateArgs = {
  broker_associate_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetBrokerAssociatesArgs = {
  broker_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetClaimShareArgs = {
  offer_claim_participant_id: Scalars["ID"]["input"];
};

export type QueryGetClaimSharesArgs = {
  offer_claim_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetDashboardOverviewArgs = {
  dashboardInput: InputMaybe<DashboardOverviewInput>;
};

export type QueryGetEndorsementParticipantArgs = {
  offer_end_participant_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetEndorsementParticipantsArgs = {
  endorsement_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetEndorsementsArgs = {
  args: InputMaybe<EndorsementFilters>;
};

export type QueryGetEndorsementsCountArgs = {
  args: InputMaybe<EndorsementFilters>;
};

export type QueryGetInsurerAssociateArgs = {
  insurer_associate_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetInsurerAssociatesArgs = {
  insurer_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetInsurerOffersCountArgs = {
  insurer_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetInsurerRepArgs = {
  rep_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetNonProportionalReceivablePaymentArgs = {
  receivable_payment_id: Scalars["ID"]["input"];
};

export type QueryGetNonProportionalReceivablePaymentsArgs = {
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
  treaty_id: Scalars["ID"]["input"];
};

export type QueryGetNonProportionalReceivablePaymentsLengthArgs = {
  treaty_id: Scalars["ID"]["input"];
};

export type QueryGetNonProportionalTreatyPaymentArgs = {
  treaty_np_payment_id: Scalars["ID"]["input"];
};

export type QueryGetNonProportionalTreatyPaymentsArgs = {
  filter: TreatyPaymentFilter;
};

export type QueryGetNonProportionalTreatyPaymentsCountArgs = {
  filter: InputMaybe<TreatyPaymentFilter>;
};

export type QueryGetNotAcceptedParticipantsArgs = {
  offer_id: Scalars["ID"]["input"];
};

export type QueryGetNotificationsArgs = {
  filter: InputMaybe<NotificationFilter>;
  pagination: InputMaybe<Pagination>;
};

export type QueryGetNotificationsCountArgs = {
  filter: InputMaybe<NotificationFilter>;
};

export type QueryGetOfferAssociatesArgs = {
  offer_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetOfferClaimParticipantPaymentsArgs = {
  offer_claim_participant_id: Scalars["ID"]["input"];
};

export type QueryGetOfferClaimsArgs = {
  args: InputMaybe<ClaimsFilter>;
};

export type QueryGetOfferFleetArgs = {
  policy_number: InputMaybe<Scalars["String"]["input"]>;
  skip: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGetOfferParticipantArgs = {
  participant_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetOfferParticipantsArgs = {
  offer_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetOfferPaymentArgs = {
  payment_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetOfferPaymentsArgs = {
  args: InputMaybe<OfferPaymentInput>;
};

export type QueryGetOfferPublishedParticipantsArgs = {
  offer_id: Scalars["ID"]["input"];
};

export type QueryGetOfferparticipantDeductionsArgs = {
  insurer_id: Scalars["ID"]["input"];
  offer_id: InputMaybe<Scalars["ID"]["input"]>;
  payment_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetOffersArgs = {
  args: InputMaybe<OfferFilters>;
};

export type QueryGetOffersCountArgs = {
  args: InputMaybe<OfferFilters>;
};

export type QueryGetPointRedemptionUsageArgs = {
  redemption_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetProportionalTreatyPaymentArgs = {
  treaty_payment_id: Scalars["ID"]["input"];
};

export type QueryGetProportionalTreatyPaymentsArgs = {
  filter: TreatyPaymentFilter;
};

export type QueryGetProportionalTreatyPaymentsCountArgs = {
  filter: TreatyPaymentFilter;
};

export type QueryGetProportionalTreatyRelatedCurrenciesArgs = {
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetReceivablePaymentsArgs = {
  treaty_id: Scalars["ID"]["input"];
};

export type QueryGetReinsurerAssociatesArgs = {
  pagination: InputMaybe<Pagination>;
  reinsurer_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetReinsurerAssociatesCountArgs = {
  reinsurer_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetReinsurerDeductionsArgs = {
  filter: InputMaybe<ReinsurerDeductionsFilter>;
};

export type QueryGetReinsurerOfferArgs = {
  offer_participant_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetReinsurerOffersArgs = {
  args: InputMaybe<OfferFiltersReinsurer>;
};

export type QueryGetReinsurerOffersCountArgs = {
  reinsurer_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetReinsurerParticipantPaymentArgs = {
  participant_payment_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetReinsurerParticipantPaymentsArgs = {
  offer_participant_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetReinsurerRepArgs = {
  rep_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetSupportingDocsListArgs = {
  offer_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetTreatiesArgs = {
  args: InputMaybe<TreatyFilters>;
};

export type QueryGetTreatiesCountArgs = {
  args: InputMaybe<TreatyFilters>;
};

export type QueryGetTreatyBrokerAssociatesArgs = {
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetTreatyBrokerParticipationArgs = {
  re_broker_treaties_participation_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetTreatyBrokersParticipantsArgs = {
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetTreatyClaimArgs = {
  treaty_claim_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetTreatyClaimPaymentArgs = {
  participant_id: Scalars["ID"]["input"];
  treaty_claim_id: Scalars["ID"]["input"];
};

export type QueryGetTreatyClaimPaymentsArgs = {
  participant_id: Scalars["ID"]["input"];
  treaty_claim_id: Scalars["ID"]["input"];
};

export type QueryGetTreatyClaimShareArgs = {
  participant_id: InputMaybe<Scalars["ID"]["input"]>;
  treaty_claim_id: Scalars["ID"]["input"];
};

export type QueryGetTreatyClaimSharesArgs = {
  treaty_claim_id: Scalars["ID"]["input"];
};

export type QueryGetTreatyClaimsArgs = {
  insurer_id: InputMaybe<Scalars["ID"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetTreatyClaimsCountArgs = {
  insurer_id: InputMaybe<Scalars["ID"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetTreatyEndorsementArgs = {
  filter: TreatyEndorsementFilter;
};

export type QueryGetTreatyEndorsementsArgs = {
  filter: InputMaybe<TreatyEndorsementFilter>;
};

export type QueryGetTreatyEndorsementsCountArgs = {
  filter: InputMaybe<TreatyEndorsementFilter>;
};

export type QueryGetTreatyProgramDeductionArgs = {
  treaty_associate_deduction_id: Scalars["ID"]["input"];
};

export type QueryGetTreatyProgramDeductionsArgs = {
  treaty_program_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetTreatyProgramsArgs = {
  args: InputMaybe<TreatyProgramFilters>;
};

export type QueryGetTreatyProgramsCountArgs = {
  args: InputMaybe<TreatyProgramFilters>;
};

export type QueryGetTreatyReinsurerAssociatesArgs = {
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetTreatyReinsurerParticipantsArgs = {
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetTreatyReinsurerParticipationArgs = {
  participation_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetUserActivitiesArgs = {
  filter: InputMaybe<ActivityFilter>;
  pagination: InputMaybe<Pagination>;
};

export type QueryGetUserActivitiesCountArgs = {
  filter: InputMaybe<ActivityFilter>;
};

export type QueryInsurerArgs = {
  insurer_id: Scalars["ID"]["input"];
};

export type QueryInsurerTreatyProgramArgs = {
  insurer_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryOfferDocumentsArgs = {
  offer_id: Scalars["ID"]["input"];
};

export type QueryOfferOverviewArgs = {
  filter_by: Array<InputMaybe<Scalars["String"]["input"]>>;
  for?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryOfferParticipantTransactionThreadArgs = {
  input: OfferParticipantTransactionThreadInput;
};

export type QueryOfferTransactionThreadArgs = {
  input: OfferTransactionThreadInput;
};

export type QueryOffersArgs = {
  for?: InputMaybe<Scalars["ID"]["input"]>;
  offer_status: Array<InputMaybe<Scalars["String"]["input"]>>;
  year?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryPublishedOffersArgs = {
  OfferStatus: OfferStatus;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryPublishedOffersCountArgs = {
  OfferStatus: OfferStatus;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryReadParticipationsForEndorsementArgs = {
  offer_endorsement_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryReadSystemNotificationsArgs = {
  employee_id: Scalars["ID"]["input"];
};

export type QueryReinsurerArgs = {
  reinsurer_id: Scalars["ID"]["input"];
};

export type QuerySingleClassOfBusinessArgs = {
  class_of_business_id: Scalars["ID"]["input"];
};

export type QuerySingleEndorsementArgs = {
  offer_endorsement_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryTreatiesArgs = {
  insurer_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryTreatyArgs = {
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryTreatyAssociateDeductionArgs = {
  deduction_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryTreatyAssociateDeductionsArgs = {
  program_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryTreatyProgramArgs = {
  program_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryTreatyProgramsCountArgs = {
  args: InputMaybe<TreatyProgramFilters>;
};

export type QueryTreatyReinsurerAccountsPaymentArgs = {
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
  treaty_participation_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryTreatyYearsArgs = {
  insurer_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type Query_Data = {
  business_id: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  client_type: InputMaybe<Scalars["String"]["input"]>;
  convert_from: InputMaybe<Array<InputMaybe<Convert_Type>>>;
  convert_to: InputMaybe<Scalars["String"]["input"]>;
  deduction: InputMaybe<Filterbydeduction>;
  endorsement: InputMaybe<Scalars["Boolean"]["input"]>;
  from: InputMaybe<Scalars["Date"]["input"]>;
  insurer_id: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  offer_source: InputMaybe<Scalars["String"]["input"]>;
  offer_status: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  payment_from: InputMaybe<Scalars["Date"]["input"]>;
  payment_status: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  payment_to: InputMaybe<Scalars["Date"]["input"]>;
  period_status: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  queryOnPayment: InputMaybe<Scalars["Boolean"]["input"]>;
  reinsurer_id: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  to: InputMaybe<Scalars["Date"]["input"]>;
};

export type QueueReportPayload = {
  __typename?: "QueueReportPayload";
  message: Maybe<Scalars["String"]["output"]>;
  report_id: Maybe<Scalars["ID"]["output"]>;
  status: Maybe<Scalars["String"]["output"]>;
};

export type Rate = {
  __typename?: "Rate";
  currency: Scalars["String"]["output"];
  currency_code: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  rate_value: Scalars["Float"]["output"];
};

export type ReBroker = {
  __typename?: "ReBroker";
  broker_overview: Maybe<Treaty_Overview>;
  re_broker_address: Maybe<ReBrokerAddress>;
  re_broker_associates: Maybe<Array<Maybe<ReBrokerAssociate>>>;
  re_broker_email: Maybe<Scalars["String"]["output"]>;
  re_broker_id: Maybe<Scalars["ID"]["output"]>;
  re_broker_name: Maybe<Scalars["String"]["output"]>;
  re_broker_participations: Maybe<Array<Maybe<ReBrokerTreatiesParticipation>>>;
  re_broker_website: Maybe<Scalars["String"]["output"]>;
};

export type ReBrokerAddress = {
  __typename?: "ReBrokerAddress";
  city: Maybe<Scalars["String"]["output"]>;
  country: Maybe<Scalars["String"]["output"]>;
  re_broker: Maybe<ReBroker>;
  re_broker_address_id: Maybe<Scalars["ID"]["output"]>;
  re_primary_phone: Maybe<Scalars["String"]["output"]>;
  re_secondary_phone: Maybe<Scalars["String"]["output"]>;
  region: Maybe<Scalars["String"]["output"]>;
  street: Maybe<Scalars["String"]["output"]>;
};

export type ReBrokerAddressInput = {
  city: InputMaybe<Scalars["String"]["input"]>;
  country: InputMaybe<Scalars["String"]["input"]>;
  re_primary_phone: InputMaybe<Scalars["String"]["input"]>;
  re_secondary_phone: InputMaybe<Scalars["String"]["input"]>;
  region: InputMaybe<Scalars["String"]["input"]>;
  street: InputMaybe<Scalars["String"]["input"]>;
};

export type ReBrokerAssociate = {
  __typename?: "ReBrokerAssociate";
  re_broker: Maybe<ReBroker>;
  re_broker_assoc_email: Maybe<Scalars["String"]["output"]>;
  re_broker_assoc_first_name: Maybe<Scalars["String"]["output"]>;
  re_broker_assoc_last_name: Maybe<Scalars["String"]["output"]>;
  re_broker_assoc_position: Maybe<Scalars["String"]["output"]>;
  re_broker_assoc_primary_phone: Maybe<Scalars["String"]["output"]>;
  re_broker_assoc_secondary_phone: Maybe<Scalars["String"]["output"]>;
  re_broker_associate_id: Maybe<Scalars["ID"]["output"]>;
};

export type ReBrokerAssociateInput = {
  re_broker_assoc_email: InputMaybe<Scalars["String"]["input"]>;
  re_broker_assoc_first_name: InputMaybe<Scalars["String"]["input"]>;
  re_broker_assoc_last_name: InputMaybe<Scalars["String"]["input"]>;
  re_broker_assoc_position: InputMaybe<Scalars["String"]["input"]>;
  re_broker_assoc_primary_phone: InputMaybe<Scalars["String"]["input"]>;
  re_broker_assoc_secondary_phone: InputMaybe<Scalars["String"]["input"]>;
  re_brokersre_broker_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type ReBrokerInput = {
  re_broker_address: InputMaybe<ReBrokerAddressInput>;
  re_broker_email: InputMaybe<Scalars["String"]["input"]>;
  re_broker_name: InputMaybe<Scalars["String"]["input"]>;
  re_broker_website: InputMaybe<Scalars["String"]["input"]>;
};

export type ReBrokerParticipationPercentageInput = {
  admin_percentage: InputMaybe<Scalars["Float"]["input"]>;
  re_broker_treaties_participation_id: InputMaybe<Scalars["ID"]["input"]>;
  share_percentage: InputMaybe<Scalars["Float"]["input"]>;
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
  treaty_type: InputMaybe<TreatyType>;
};

export type ReBrokerTreatiesParticipation = {
  __typename?: "ReBrokerTreatiesParticipation";
  admin_percentage: Maybe<Scalars["Float"]["output"]>;
  payment_status: Maybe<Payment_Status>;
  re_broker: Maybe<ReBroker>;
  re_broker_treaties_participation_id: Maybe<Scalars["ID"]["output"]>;
  share_percentage: Maybe<Scalars["Float"]["output"]>;
  surplus_participation: Maybe<
    Array<Maybe<ReBrokerTreatiesSurplusParticipation>>
  >;
  treaty: Maybe<Treaty>;
  xl_particiation: Maybe<ReBrokerTreatiesXlParticipation>;
};

export type ReBrokerTreatiesParticipationPayment = {
  __typename?: "ReBrokerTreatiesParticipationPayment";
  payment_amount: Maybe<Scalars["Float"]["output"]>;
  payment_details: Maybe<Scalars["String"]["output"]>;
  re_broker_treaties_participation: Maybe<
    Array<Maybe<ReBrokerTreatiesParticipation>>
  >;
};

export type ReBrokerTreatiesSurplusParticipation = {
  __typename?: "ReBrokerTreatiesSurplusParticipation";
  admin_charge: Maybe<Scalars["Float"]["output"]>;
  broker_surplus_participation_payments: Maybe<
    Array<Maybe<ReBrokerTreatiesSurplusParticipationPayment>>
  >;
  re_broker_treaties_surplus_participation_id: Maybe<Scalars["ID"]["output"]>;
  share_amount: Maybe<Scalars["Float"]["output"]>;
  treaty_account: Maybe<TreatyAccount>;
  treaty_participation: Maybe<ReBrokerTreatiesParticipation>;
};

export type ReBrokerTreatiesSurplusParticipationPayment = {
  __typename?: "ReBrokerTreatiesSurplusParticipationPayment";
  payment_amount: Maybe<Scalars["Float"]["output"]>;
  payment_details: Maybe<Scalars["String"]["output"]>;
  re_broker_treaties_surplus_participation_payment_id: Maybe<
    Scalars["ID"]["output"]
  >;
};

export type ReBrokerTreatiesXlParticipation = {
  __typename?: "ReBrokerTreatiesXlParticipation";
  admin_charge: Maybe<Scalars["Float"]["output"]>;
  re_broker_treaties_xl_participation_id: Maybe<Scalars["ID"]["output"]>;
  share_amount: Maybe<Scalars["Float"]["output"]>;
  xl_participation_payments: Maybe<
    Array<Maybe<ReBrokerTreatiesXlParticipationPayment>>
  >;
};

export type ReBrokerTreatiesXlParticipationPayment = {
  __typename?: "ReBrokerTreatiesXlParticipationPayment";
  payment_amount: Maybe<Scalars["Float"]["output"]>;
  payment_details: Maybe<Scalars["String"]["output"]>;
  re_broker_treaties_xl_participation_payment_id: Maybe<
    Scalars["ID"]["output"]
  >;
};

export type Receivable = Employee | Reinsurer_Representative;

export type ReceivablePayment = {
  __typename?: "ReceivablePayment";
  created_at: Maybe<Scalars["DateTime"]["output"]>;
  payment_amount: Maybe<Scalars["Float"]["output"]>;
  payment_detail: Maybe<Scalars["String"]["output"]>;
  receivable_payment_id: Maybe<Scalars["ID"]["output"]>;
  treaty: Maybe<Treaty>;
  treaty_participant: Maybe<TreatyParticipation>;
  uuid: Maybe<Scalars["String"]["output"]>;
};

export type ReceivablePaymentInput = {
  payment_amount: InputMaybe<Scalars["Float"]["input"]>;
  payment_detail: InputMaybe<Scalars["String"]["input"]>;
  treaty_claimstreaty_claim_id: InputMaybe<Scalars["ID"]["input"]>;
  treaty_participation_id: InputMaybe<Scalars["ID"]["input"]>;
  uuid: InputMaybe<Scalars["String"]["input"]>;
};

export type RedeemedUser = {
  __typename?: "RedeemedUser";
  assoc_email: Scalars["String"]["output"];
  assoc_first_name: Scalars["String"]["output"];
  assoc_last_name: Scalars["String"]["output"];
  assoc_primary_phonenumber: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  position: Scalars["String"]["output"];
};

export type RefreshTokenInput = {
  refresh_token: InputMaybe<Scalars["String"]["input"]>;
};

export type RefreshTokenPayload = {
  __typename?: "RefreshTokenPayload";
  access_token: Scalars["String"]["output"];
  expires_in: Scalars["Int"]["output"];
  refresh_token: Scalars["String"]["output"];
  token_type: Scalars["String"]["output"];
};

export type RegisterInput = {
  email: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
  password_confirmation: Scalars["String"]["input"];
};

export type RegisterResponse = {
  __typename?: "RegisterResponse";
  status: RegisterStatuses;
  tokens: Maybe<AuthPayload>;
};

export enum RegisterStatuses {
  MustVerifyEmail = "MUST_VERIFY_EMAIL",
  Success = "SUCCESS",
}

export type Reinsurer = {
  __typename?: "Reinsurer";
  offers_participant: Maybe<Array<Maybe<Offer_Participant>>>;
  re_abbrv: Maybe<Scalars["String"]["output"]>;
  re_company_email: Scalars["String"]["output"];
  re_company_name: Scalars["String"]["output"];
  re_company_website: Maybe<Scalars["String"]["output"]>;
  reinsurer_address: Maybe<Reinsurer_Address>;
  reinsurer_id: Maybe<Scalars["ID"]["output"]>;
  reinsurer_overview: Maybe<Client_Overview>;
  reinsurer_representatives: Maybe<Array<Maybe<Reinsurer_Representative>>>;
  treaty_participations: Maybe<Array<Maybe<TreatyParticipation>>>;
};

export type ReinsurerDeduction = {
  __typename?: "ReinsurerDeduction";
  brokerage: Maybe<Scalars["Float"]["output"]>;
  brokerage_amount: Maybe<Scalars["Float"]["output"]>;
  commission: Maybe<Scalars["Float"]["output"]>;
  commission_amount: Maybe<Scalars["Float"]["output"]>;
  nic_levy: Maybe<Scalars["Float"]["output"]>;
  nic_levy_amount: Maybe<Scalars["Float"]["output"]>;
  participant_share: Maybe<Scalars["Float"]["output"]>;
  treaty_participant_deduction_id: Scalars["ID"]["output"];
  withholding_tax: Maybe<Scalars["Float"]["output"]>;
  withholding_tax_amount: Maybe<Scalars["Float"]["output"]>;
};

export type ReinsurerDeductionsFilter = {
  participation_id: Scalars["ID"]["input"];
};

export type ReinsurerDistributionData = {
  reinsurer_id: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type ReinsurerParticipationUpdate = {
  deductions: InputMaybe<Deductions>;
  participant_id: InputMaybe<Scalars["ID"]["input"]>;
  treaty_participant_deduction_id: InputMaybe<
    Array<InputMaybe<Scalars["ID"]["input"]>>
  >;
};

export type ReinsurerRepresentative = {
  __typename?: "ReinsurerRepresentative";
  delete_status: Maybe<Scalars["String"]["output"]>;
  position: Scalars["String"]["output"];
  reinsurer_representative_id: Scalars["ID"]["output"];
  rep_email: Scalars["String"]["output"];
  rep_first_name: Scalars["String"]["output"];
  rep_last_name: Scalars["String"]["output"];
  rep_primary_phonenumber: Maybe<Scalars["String"]["output"]>;
  rep_secondary_phonenumber: Maybe<Scalars["String"]["output"]>;
};

export type Reinsurer_Address = {
  __typename?: "Reinsurer_address";
  country: Scalars["String"]["output"];
  region: Scalars["String"]["output"];
  reinsurer_address_id: Scalars["ID"]["output"];
  street: Scalars["String"]["output"];
  suburb: Scalars["String"]["output"];
};

export type Reinsurer_Data = {
  country: Scalars["String"]["input"];
  re_company_email: Scalars["String"]["input"];
  re_company_name: Scalars["String"]["input"];
  re_company_website: InputMaybe<Scalars["String"]["input"]>;
  region: Scalars["String"]["input"];
  street: Scalars["String"]["input"];
  suburb: Scalars["String"]["input"];
};

export type Reinsurer_Extra_Charge = {
  agreed_brokerage_percentage: Scalars["Float"]["input"];
  agreed_commission: Scalars["Float"]["input"];
  nic_levy: Scalars["Float"]["input"];
  reinsurer_id: InputMaybe<Scalars["ID"]["input"]>;
  reinsurer_participant_id: InputMaybe<Scalars["ID"]["input"]>;
  withholding_tax: Scalars["Float"]["input"];
};

export type Reinsurer_Rep_Data = {
  position: Scalars["String"]["input"];
  reinsurersreinsurer_id: InputMaybe<Scalars["ID"]["input"]>;
  rep_email: Scalars["String"]["input"];
  rep_first_name: Scalars["String"]["input"];
  rep_last_name: Scalars["String"]["input"];
  rep_primary_phonenumber: Scalars["String"]["input"];
  rep_secondary_phonenumber: InputMaybe<Scalars["String"]["input"]>;
};

export type Reinsurer_Representative = {
  __typename?: "Reinsurer_representative";
  position: Scalars["String"]["output"];
  reinsurer: Reinsurer;
  reinsurer_representative_id: Maybe<Scalars["ID"]["output"]>;
  reinsurersreinsurer_id: Scalars["ID"]["output"];
  rep_email: Scalars["String"]["output"];
  rep_first_name: Scalars["String"]["output"];
  rep_last_name: Scalars["String"]["output"];
  rep_primary_phonenumber: Scalars["String"]["output"];
  rep_secondary_phonenumber: Maybe<Scalars["String"]["output"]>;
};

export type Reinsurer_Representative_Data = {
  reinsurer_id: InputMaybe<Scalars["ID"]["input"]>;
  representatives_ids: Array<Scalars["ID"]["input"]>;
};

export type RejectOfferParticipantInput = {
  offer_published_participant_id: Scalars["ID"]["input"];
};

export type Remainder = {
  __typename?: "Remainder";
  insurersinsurer_id: Maybe<Scalars["ID"]["output"]>;
  offersoffer_id: Maybe<Scalars["ID"]["output"]>;
  postponed_till: Maybe<Scalars["Date"]["output"]>;
  remainder_id: Maybe<Scalars["ID"]["output"]>;
};

export type Report = {
  __typename?: "Report";
  created_at: Scalars["DateTime"]["output"];
  description: Maybe<Scalars["String"]["output"]>;
  downloadable_pdf_link: Maybe<Scalars["String"]["output"]>;
  downloadable_xlsx_link: Maybe<Scalars["String"]["output"]>;
  employee: Maybe<Employee>;
  report_id: Scalars["ID"]["output"];
  request_body: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  updated_at: Scalars["DateTime"]["output"];
};

export type Response = {
  __typename?: "Response";
  msg: Scalars["String"]["output"];
};

export type ResponseData = {
  __typename?: "ResponseData";
  data: Maybe<Scalars["String"]["output"]>;
  message: Maybe<Scalars["String"]["output"]>;
  status: Maybe<Scalars["String"]["output"]>;
};

export type SendOfferParticipationMessage = {
  firstname: Scalars["String"]["input"];
  lastname: Scalars["String"]["input"];
  message: Scalars["String"]["input"];
  offer_published_id: Scalars["ID"]["input"];
  offer_published_participant: Scalars["ID"]["input"];
};

export enum Sent_Status {
  Sent = "SENT",
  Unsent = "UNSENT",
}

export type SetOfferPublishInput = {
  offer_id: Scalars["ID"]["input"];
};

export type SocialLoginInput = {
  provider: Scalars["String"]["input"];
  token: Scalars["String"]["input"];
};

/** The available directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = "ASC",
  /** Sort records in descending order. */
  Desc = "DESC",
}

export type Subscription = {
  __typename?: "Subscription";
  employeeUpdate: Maybe<Scalars["String"]["output"]>;
};

export type SystemNotification = {
  __typename?: "SystemNotification";
  created_at: Maybe<Scalars["DateTime"]["output"]>;
  employee_notification: Maybe<EmployeeNotification>;
  notification_content: Maybe<Scalars["String"]["output"]>;
  notification_type: Maybe<Scalars["String"]["output"]>;
  system_notification_id: Maybe<Scalars["ID"]["output"]>;
};

export type Target = {
  __typename?: "Target";
  base_currency: Maybe<Scalars["String"]["output"]>;
  broker_id: Maybe<Scalars["ID"]["output"]>;
  end_date: Maybe<Scalars["String"]["output"]>;
  id: Maybe<Scalars["ID"]["output"]>;
  insurer_id: Maybe<Scalars["ID"]["output"]>;
  start_date: Maybe<Scalars["String"]["output"]>;
  target_badges: Maybe<Array<Maybe<TargetBadge>>>;
  target_name: Maybe<Scalars["String"]["output"]>;
};

export type TargetBadge = {
  __typename?: "TargetBadge";
  cash_equivalent: Maybe<Scalars["Int"]["output"]>;
  description: Maybe<Scalars["String"]["output"]>;
  gift_basket: Maybe<Array<Maybe<GiftBasketItem>>>;
  id: Maybe<Scalars["ID"]["output"]>;
  max_points: Maybe<Scalars["Int"]["output"]>;
  min_points: Maybe<Scalars["Int"]["output"]>;
  minimum_cash_equivalent: Maybe<Scalars["Int"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
};

export type TargetBadgeInput = {
  cash_equivalent: InputMaybe<Scalars["Int"]["input"]>;
  description: InputMaybe<Scalars["String"]["input"]>;
  gift_basket: InputMaybe<Array<InputMaybe<GiftBasketItemInput>>>;
  max_points: Scalars["Int"]["input"];
  min_points: Scalars["Int"]["input"];
  minimum_cash_equivalent: InputMaybe<Scalars["Int"]["input"]>;
  name: Scalars["String"]["input"];
};

export type TargetRate = {
  __typename?: "TargetRate";
  currency: Scalars["String"]["output"];
  currency_code: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  rate_value: Scalars["Float"]["output"];
  target_id: Scalars["ID"]["output"];
};

export type TargetRateInput = {
  currency: Scalars["String"]["input"];
  currency_code: Scalars["String"]["input"];
  rate_value: Scalars["Float"]["input"];
};

export type ThreadMessage = {
  __typename?: "ThreadMessage";
  message: Scalars["String"]["output"];
  sender_name: Scalars["String"]["output"];
  state: Scalars["String"]["output"];
  timeStamp: Maybe<Scalars["String"]["output"]>;
  uuid: Scalars["ID"]["output"];
};

export type ThreadNotification = {
  __typename?: "ThreadNotification";
  id: Maybe<Scalars["ID"]["output"]>;
  status: Maybe<Scalars["String"]["output"]>;
};

export type TotalCashAccumulated = {
  __typename?: "TotalCashAccumulated";
  project_revenue: Maybe<Array<Maybe<ProjectedRevenue>>>;
  total_cash_accumulated: Maybe<Scalars["Float"]["output"]>;
};

export type TransactionThread = {
  __typename?: "TransactionThread";
  id: Maybe<Scalars["ID"]["output"]>;
  offer: Maybe<Offer>;
  offer_published_participant_id: Maybe<Scalars["ID"]["output"]>;
  receivable: Maybe<Receivable>;
  receiver_type: Maybe<Scalars["String"]["output"]>;
  sender_name: Maybe<Scalars["String"]["output"]>;
  status: Maybe<Scalars["String"]["output"]>;
};

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = "ONLY",
  /** Return both trashed and non-trashed results. */
  With = "WITH",
  /** Only return non-trashed results. */
  Without = "WITHOUT",
}

export type Treaty = {
  __typename?: "Treaty";
  currency: Maybe<Scalars["String"]["output"]>;
  employee: Maybe<Employee>;
  insurer: Maybe<Insurer>;
  kek_reference: Maybe<Scalars["String"]["output"]>;
  layer_limit: Maybe<Scalars["String"]["output"]>;
  order_hereon: Maybe<Scalars["Float"]["output"]>;
  re_broker_treaties_participation: Maybe<
    Array<Maybe<ReBrokerTreatiesParticipation>>
  >;
  receivable_payments: Maybe<Array<Maybe<ReceivablePayment>>>;
  treaty_accounts: Maybe<Array<Maybe<TreatyAccount>>>;
  treaty_claims: Maybe<Array<Maybe<TreatyClaim>>>;
  treaty_deduction: Maybe<TreatyAssociateDeduction>;
  treaty_details: Maybe<Scalars["String"]["output"]>;
  treaty_id: Maybe<Scalars["ID"]["output"]>;
  treaty_insurer_emails: Maybe<Array<Maybe<TreatyInsurerEmail>>>;
  treaty_np_detail: Maybe<TreatyNpDetail>;
  treaty_np_payments: Maybe<Array<Maybe<TreatyNpPayment>>>;
  treaty_p_payments: Maybe<Array<Maybe<TreatyPPayment>>>;
  treaty_participant_payment: Maybe<Array<Maybe<TreatyParticipantsPayment>>>;
  treaty_participants: Maybe<Array<Maybe<TreatyParticipation>>>;
  treaty_payment_status: Maybe<Payment_Status>;
  treaty_program: Maybe<TreatyProgram>;
  treaty_proportional_detail: Maybe<TreatyProportionalDetail>;
  treaty_reference: Maybe<Scalars["String"]["output"]>;
  treaty_to_associates: Maybe<Array<Maybe<TreatyToAssociate>>>;
  treaty_to_broker_associates: Maybe<
    Array<Maybe<TreatyParticipationToBrokerAssociates>>
  >;
};

export type TreatyAccount = {
  __typename?: "TreatyAccount";
  account_periods: Maybe<TreatyAccountPeriod>;
  account_year: Maybe<Scalars["String"]["output"]>;
  cash_loss: Maybe<Scalars["Float"]["output"]>;
  claim_settled: Maybe<Scalars["Float"]["output"]>;
  exchange_rate: Maybe<Scalars["String"]["output"]>;
  gross_premium: Maybe<Scalars["Float"]["output"]>;
  payment_status: Maybe<Payment_Status>;
  reinsurer_treaty_participation: Maybe<Array<Maybe<TreatyPPaymentExtras>>>;
  treaty_account_deduction: Maybe<Array<Maybe<TreatyAccountDeduction>>>;
  treaty_account_id: Maybe<Scalars["ID"]["output"]>;
  treaty_p_payments: Maybe<Array<Maybe<TreatyPPayment>>>;
  treaty_participant_deduction: Maybe<Array<Maybe<TreatyParticipantDeduction>>>;
  treaty_surpulus: Maybe<Array<Maybe<TreatyAccountSurpulus>>>;
};

export type TreatyAccountData = {
  account_periods: InputMaybe<TreatyAccountPeriod>;
  account_year: InputMaybe<Scalars["String"]["input"]>;
  exchange_rate: InputMaybe<Scalars["String"]["input"]>;
  participant_deduction_id: InputMaybe<Scalars["ID"]["input"]>;
  surpulus_data: InputMaybe<Array<InputMaybe<TreatyAccountSurpulusInput>>>;
  treatiestreaty_id: Scalars["ID"]["input"];
};

export type TreatyAccountDeduction = {
  __typename?: "TreatyAccountDeduction";
  brokerage_amount: Maybe<Scalars["Float"]["output"]>;
  cash_loss: Maybe<Scalars["Float"]["output"]>;
  claim_settled: Maybe<Scalars["Float"]["output"]>;
  commission_amount: Maybe<Scalars["Float"]["output"]>;
  gross_premium: Maybe<Scalars["Float"]["output"]>;
  nic_levy_amount: Maybe<Scalars["Float"]["output"]>;
  surpulus_uuid: Maybe<Scalars["String"]["output"]>;
  treaty_account_deduction_id: Maybe<Scalars["ID"]["output"]>;
  withholding_tax_amount: Maybe<Scalars["Float"]["output"]>;
};

export enum TreatyAccountPeriod {
  Firstquarter = "FIRSTQUARTER",
  Fourthquarter = "FOURTHQUARTER",
  Secondquarter = "SECONDQUARTER",
  Thirdquarter = "THIRDQUARTER",
}

export type TreatyAccountSurpulus = {
  __typename?: "TreatyAccountSurpulus";
  gross_premium: Maybe<Scalars["Float"]["output"]>;
  surpulus_uuid: Maybe<Scalars["String"]["output"]>;
  treaty_account: Maybe<TreatyAccount>;
  treaty_account_surpulus_id: Maybe<Scalars["ID"]["output"]>;
};

export type TreatyAccountSurpulusInput = {
  account_deduction_id: InputMaybe<Scalars["ID"]["input"]>;
  cash_loss: InputMaybe<Scalars["Float"]["input"]>;
  claim_settled: InputMaybe<Scalars["Float"]["input"]>;
  gross_premium: Scalars["Float"]["input"];
  surpulus_uuid: Scalars["String"]["input"];
};

export type TreatyAssociateDeduction = {
  __typename?: "TreatyAssociateDeduction";
  brokerage: Maybe<Scalars["Float"]["output"]>;
  commission: Maybe<Scalars["Float"]["output"]>;
  nic_levy: Maybe<Scalars["Float"]["output"]>;
  treaty_associate_deduction_id: Maybe<Scalars["ID"]["output"]>;
  treaty_period_from: Maybe<Scalars["Date"]["output"]>;
  treaty_period_to: Maybe<Scalars["Date"]["output"]>;
  treaty_program: Maybe<TreatyProgram>;
  withholding_tax: Maybe<Scalars["Float"]["output"]>;
};

export type TreatyAssociateDeductionData = {
  brokerage: Scalars["Float"]["input"];
  commission: InputMaybe<Scalars["Float"]["input"]>;
  nic_levy: Scalars["Float"]["input"];
  treaty_period_from: Scalars["Date"]["input"];
  treaty_period_to: Scalars["Date"]["input"];
  treaty_programstreaty_program_id: Scalars["ID"]["input"];
  withholding_tax: Scalars["Float"]["input"];
};

export type TreatyClaim = {
  __typename?: "TreatyClaim";
  claim_date: Maybe<Scalars["Date"]["output"]>;
  claim_number: Maybe<Scalars["String"]["output"]>;
  claim_paid: Maybe<Scalars["Float"]["output"]>;
  date_of_loss: Maybe<Scalars["Date"]["output"]>;
  expected_deductible: Maybe<Scalars["Float"]["output"]>;
  insured_name: Maybe<Scalars["String"]["output"]>;
  layer_number: Maybe<Scalars["Int"]["output"]>;
  policy_number: Maybe<Scalars["String"]["output"]>;
  receivable_payments: Maybe<Array<Maybe<ReceivablePayment>>>;
  reinstatement_premium: Maybe<Scalars["Float"]["output"]>;
  treaty: Maybe<Treaty>;
  treaty_claim_details: Maybe<Scalars["String"]["output"]>;
  treaty_claim_id: Maybe<Scalars["ID"]["output"]>;
  treaty_comment: Maybe<Scalars["String"]["output"]>;
};

export type TreatyClaimData = {
  claim_date: InputMaybe<Scalars["Date"]["input"]>;
  claim_number: InputMaybe<Scalars["String"]["input"]>;
  claim_paid: Scalars["Float"]["input"];
  date_of_loss: InputMaybe<Scalars["Date"]["input"]>;
  expected_deductible: InputMaybe<Scalars["Float"]["input"]>;
  insured_name: Scalars["String"]["input"];
  layer_number: Scalars["Int"]["input"];
  policy_number: InputMaybe<Scalars["String"]["input"]>;
  treaty_claim_details: InputMaybe<Scalars["String"]["input"]>;
  treaty_comment: InputMaybe<Scalars["String"]["input"]>;
};

export type TreatyData = {
  currency: InputMaybe<Scalars["String"]["input"]>;
  installment_type: InputMaybe<Scalars["Int"]["input"]>;
  insurersinsurer_id: InputMaybe<Scalars["ID"]["input"]>;
  kek_reference: InputMaybe<Scalars["String"]["input"]>;
  layer_limit: InputMaybe<Scalars["String"]["input"]>;
  m_and_d_premium: InputMaybe<Scalars["Float"]["input"]>;
  order_hereon: InputMaybe<Scalars["Float"]["input"]>;
  treaty_associate_deductionstreaty_associate_deduction_id: InputMaybe<
    Scalars["ID"]["input"]
  >;
  treaty_details: InputMaybe<Scalars["String"]["input"]>;
  treaty_extended_details: InputMaybe<ExtendedTreatyDetails>;
  treaty_programstreaty_program_id: InputMaybe<Scalars["ID"]["input"]>;
  treaty_reference: InputMaybe<Scalars["String"]["input"]>;
  type: InputMaybe<Scalars["String"]["input"]>;
};

export type TreatyEndorsement = {
  __typename?: "TreatyEndorsement";
  employee: Employee;
  employeesemployee_id: Scalars["ID"]["output"];
  endorsement_comment: Maybe<Scalars["String"]["output"]>;
  treatiestreaty_id: Scalars["ID"]["output"];
  treaty: Maybe<Treaty>;
  treaty_endorsement_id: Scalars["ID"]["output"];
};

export type TreatyEndorsementFilter = {
  treatiestreaty_id: InputMaybe<Scalars["ID"]["input"]>;
  treaty_endorsement_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type TreatyFilters = {
  broker_id: InputMaybe<Scalars["ID"]["input"]>;
  insurer_id: InputMaybe<Scalars["ID"]["input"]>;
  limit: InputMaybe<Scalars["Int"]["input"]>;
  offset: InputMaybe<Scalars["Int"]["input"]>;
  search: InputMaybe<Scalars["String"]["input"]>;
  treaty_claim_status: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >;
  treaty_expiry_status: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >;
  treaty_payment_status: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >;
  treaty_program_type: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >;
};

export type TreatyInsurerEmail = {
  __typename?: "TreatyInsurerEmail";
  email_status: Maybe<Sent_Status>;
  treaty_insurer_email_id: Maybe<Scalars["ID"]["output"]>;
};

export type TreatyNpDetail = {
  __typename?: "TreatyNPDetail";
  adjustment_created: Maybe<Scalars["Boolean"]["output"]>;
  burning_cost_rate: Maybe<Scalars["Float"]["output"]>;
  claims_paid: Maybe<Scalars["Float"]["output"]>;
  created_at: Maybe<Scalars["DateTime"]["output"]>;
  egrnpi: Maybe<Scalars["Float"]["output"]>;
  loaded_burning_cost: Maybe<Scalars["Float"]["output"]>;
  outstanding_payment: Maybe<Scalars["Float"]["output"]>;
  pure_burning_cost: Maybe<Scalars["Float"]["output"]>;
  treaty: Maybe<Treaty>;
  treaty_np_id: Maybe<Scalars["ID"]["output"]>;
};

export type TreatyNpDetailInput = {
  adjustment_created: InputMaybe<Scalars["Boolean"]["input"]>;
  egrnpi: InputMaybe<Scalars["Float"]["input"]>;
};

export type TreatyNpPayment = {
  __typename?: "TreatyNPPayment";
  created_at: Maybe<Scalars["DateTime"]["output"]>;
  date_of_receipt: Maybe<Scalars["Date"]["output"]>;
  distribute_payment: Maybe<Scalars["String"]["output"]>;
  installment_type: Maybe<Scalars["Int"]["output"]>;
  treaty_n_p_payment_id: Maybe<Scalars["ID"]["output"]>;
  treaty_participant_payment: Maybe<Array<Maybe<TreatyParticipantsPayment>>>;
  treaty_payment_amount: Maybe<Scalars["Float"]["output"]>;
  treaty_payment_comment: Maybe<Scalars["String"]["output"]>;
  treaty_payment_details: Maybe<Scalars["String"]["output"]>;
  updated_at: Maybe<Scalars["DateTime"]["output"]>;
  uuid: Maybe<Scalars["String"]["output"]>;
};

export type TreatyPPayment = {
  __typename?: "TreatyPPayment";
  created_at: Maybe<Scalars["DateTime"]["output"]>;
  date_of_receipt: Maybe<Scalars["Date"]["output"]>;
  distribute_payment: Maybe<Scalars["String"]["output"]>;
  surpulus_uuid: Maybe<Scalars["String"]["output"]>;
  treaty: Maybe<Treaty>;
  treaty_accounts: Maybe<TreatyAccount>;
  treaty_accountstreaty_account_id: Maybe<Scalars["ID"]["output"]>;
  treaty_p_payment_id: Maybe<Scalars["ID"]["output"]>;
  treaty_participant_payment: Maybe<Array<Maybe<TreatyParticipantsPayment>>>;
  treaty_payment_amount: Maybe<Scalars["Float"]["output"]>;
  treaty_payment_comment: Maybe<Scalars["String"]["output"]>;
  treaty_payment_details: Maybe<Scalars["String"]["output"]>;
  updated_at: Maybe<Scalars["DateTime"]["output"]>;
};

export type TreatyPPaymentExtras = {
  __typename?: "TreatyPPaymentExtras";
  brokerage_paid: Maybe<Scalars["Float"]["output"]>;
  commission_paid: Maybe<Scalars["Float"]["output"]>;
  created_at: Maybe<Scalars["DateTime"]["output"]>;
  nic_levy_paid: Maybe<Scalars["Float"]["output"]>;
  participant_payment_amount: Maybe<Scalars["Float"]["output"]>;
  participant_payment_comment: Maybe<Scalars["String"]["output"]>;
  participant_payment_details: Maybe<Scalars["String"]["output"]>;
  participant_payment_status: Maybe<Payment_Status>;
  surpulus_uuid: Maybe<Scalars["String"]["output"]>;
  treaty_np_paymentstreaty_np_payment_id: Maybe<Scalars["ID"]["output"]>;
  treaty_p_paymentstreaty_p_payment_id: Maybe<Scalars["ID"]["output"]>;
  treaty_participants_payment_id: Maybe<Scalars["ID"]["output"]>;
  treaty_participationstreaty_participation_id: Maybe<Scalars["ID"]["output"]>;
  updated_at: Maybe<Scalars["DateTime"]["output"]>;
  withholding_tax_paid: Maybe<Scalars["Float"]["output"]>;
};

export type TreatyParticipantDeduction = {
  __typename?: "TreatyParticipantDeduction";
  brokerage: Maybe<Scalars["Float"]["output"]>;
  brokerage_amount: Maybe<Scalars["Float"]["output"]>;
  commission: Maybe<Scalars["Float"]["output"]>;
  commission_amount: Maybe<Scalars["Float"]["output"]>;
  nic_levy: Maybe<Scalars["Float"]["output"]>;
  nic_levy_amount: Maybe<Scalars["Float"]["output"]>;
  treaty_account: Maybe<TreatyAccount>;
  treaty_accountstreaty_account_id: Maybe<Scalars["ID"]["output"]>;
  treaty_participant_deduction_id: Maybe<Scalars["ID"]["output"]>;
  treaty_participation: Maybe<TreatyParticipation>;
  treaty_participation_share: Maybe<Scalars["Float"]["output"]>;
  treaty_participationstreaty_participation_id: Maybe<Scalars["ID"]["output"]>;
  uuid: Maybe<Scalars["String"]["output"]>;
  withholding_tax: Maybe<Scalars["Float"]["output"]>;
  withholding_tax_amount: Maybe<Scalars["Float"]["output"]>;
};

export type TreatyParticipantEmail = {
  __typename?: "TreatyParticipantEmail";
  email_status: Maybe<Sent_Status>;
  treaty_participant_email_id: Maybe<Scalars["ID"]["output"]>;
};

export type TreatyParticipantsData = {
  reinsurers: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  treatiestreaty_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type TreatyParticipantsPayment = {
  __typename?: "TreatyParticipantsPayment";
  brokerage_paid: Maybe<Scalars["Float"]["output"]>;
  commission_paid: Maybe<Scalars["Float"]["output"]>;
  created_at: Maybe<Scalars["DateTime"]["output"]>;
  nic_levy_paid: Maybe<Scalars["Float"]["output"]>;
  participant_payment_amount: Maybe<Scalars["Float"]["output"]>;
  participant_payment_comment: Maybe<Scalars["String"]["output"]>;
  participant_payment_details: Maybe<Scalars["String"]["output"]>;
  participant_payment_status: Maybe<Payment_Status>;
  surpulus_uuid: Maybe<Scalars["String"]["output"]>;
  treaty: Maybe<Treaty>;
  treaty_np_paymentstreaty_np_payment_id: Maybe<Scalars["ID"]["output"]>;
  treaty_p_paymentstreaty_p_payment_id: Maybe<Scalars["ID"]["output"]>;
  treaty_participants_payment_id: Maybe<Scalars["ID"]["output"]>;
  treaty_participation: Maybe<Array<Maybe<TreatyParticipation>>>;
  treaty_participationstreaty_participation_id: Maybe<Scalars["ID"]["output"]>;
  treaty_payment: Maybe<TreatyPPayment>;
  updated_at: Maybe<Scalars["DateTime"]["output"]>;
  withholding_tax_paid: Maybe<Scalars["Float"]["output"]>;
};

export type TreatyParticipation = {
  __typename?: "TreatyParticipation";
  layer_number: Maybe<Scalars["Int"]["output"]>;
  reinsurer: Maybe<Reinsurer>;
  treaty: Maybe<Treaty>;
  treaty_claims: Maybe<Array<Maybe<TreatyClaim>>>;
  treaty_participant_deductions: Maybe<
    Array<Maybe<TreatyParticipantDeduction>>
  >;
  treaty_participant_emails: Maybe<Array<Maybe<TreatyParticipantEmail>>>;
  treaty_participant_payments: Maybe<Array<Maybe<TreatyParticipantsPayment>>>;
  treaty_participation_id: Maybe<Scalars["ID"]["output"]>;
  treaty_participation_percentage: Maybe<Scalars["Float"]["output"]>;
};

export type TreatyParticipationToBrokerAssociates = {
  __typename?: "TreatyParticipationToBrokerAssociates";
  broker_associate: Maybe<ReBrokerAssociate>;
  message_content: Maybe<Scalars["String"]["output"]>;
  participation_to_broker_associate_id: Maybe<Scalars["ID"]["output"]>;
  sent_status: Maybe<Sent_Status>;
  treaty: Maybe<Treaty>;
};

export type TreatyPaymentDistribution = {
  participant_payment_id: InputMaybe<Scalars["ID"]["input"]>;
  payment_comment: InputMaybe<Scalars["String"]["input"]>;
  payment_details: InputMaybe<Scalars["String"]["input"]>;
};

export type TreatyPaymentFilter = {
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type TreatyProgram = {
  __typename?: "TreatyProgram";
  insurer: Maybe<Insurer>;
  treaties: Maybe<Array<Maybe<Treaty>>>;
  treaty_associate_deductions: Maybe<Array<Maybe<TreatyAssociateDeduction>>>;
  treaty_details: Maybe<Scalars["String"]["output"]>;
  treaty_name: Maybe<Scalars["String"]["output"]>;
  treaty_program_id: Maybe<Scalars["ID"]["output"]>;
  treaty_type: Maybe<TreatyType>;
};

export type TreatyProgramData = {
  insurersinsurer_id: InputMaybe<Scalars["ID"]["input"]>;
  treaty_details: InputMaybe<Scalars["String"]["input"]>;
  treaty_name: Scalars["String"]["input"];
  treaty_type: InputMaybe<TreatyType>;
};

export type TreatyProgramFilters = {
  insurer_id: InputMaybe<Scalars["String"]["input"]>;
  limit: InputMaybe<Scalars["Int"]["input"]>;
  offset: InputMaybe<Scalars["Int"]["input"]>;
  search: InputMaybe<Scalars["String"]["input"]>;
  treaty_type: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type TreatyProportionalDetail = {
  __typename?: "TreatyProportionalDetail";
  created_at: Maybe<Scalars["DateTime"]["output"]>;
  ernpi: Maybe<Scalars["Float"]["output"]>;
  losses_outstanding: Maybe<Scalars["Float"]["output"]>;
  overall_gross_premium: Maybe<Scalars["Float"]["output"]>;
  portfolio_entry: Maybe<Scalars["String"]["output"]>;
  portfolio_entry_compute: Maybe<Scalars["String"]["output"]>;
  prev_year_configuration: Maybe<Scalars["String"]["output"]>;
  profit_commission: Maybe<Scalars["Float"]["output"]>;
  re_mgmt_expense: Maybe<Scalars["Float"]["output"]>;
  treaty: Maybe<Treaty>;
  treaty_proportional_detail_id: Maybe<Scalars["ID"]["output"]>;
};

export type TreatyProportionalDetailInput = {
  ernpi: InputMaybe<Scalars["Float"]["input"]>;
  losses_outstanding: InputMaybe<Scalars["Float"]["input"]>;
  overall_gross_premium: InputMaybe<Scalars["Float"]["input"]>;
  portfolio_entry: InputMaybe<PortFolioEntry>;
  portfolio_entry_compute: InputMaybe<Scalars["Float"]["input"]>;
  prev_year_configuration: InputMaybe<Scalars["String"]["input"]>;
  profit_commission: InputMaybe<Scalars["Float"]["input"]>;
  re_mgmt_expense: InputMaybe<Scalars["Float"]["input"]>;
  treaty_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type TreatyRelatedCurrencies = {
  __typename?: "TreatyRelatedCurrencies";
  currency: Maybe<Scalars["String"]["output"]>;
  layer_limit: Maybe<Scalars["String"]["output"]>;
  quarters: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  treaty_id: Maybe<Scalars["ID"]["output"]>;
};

export type TreatyToAssociate = {
  __typename?: "TreatyToAssociate";
  layer_number: Maybe<Scalars["Int"]["output"]>;
  reinsurer: Maybe<Reinsurer>;
  reinsurer_representative: Maybe<Reinsurer_Representative>;
  sent_status: Maybe<Sent_Status>;
  treaty_to_associate_id: Maybe<Scalars["ID"]["output"]>;
};

export enum TreatyType {
  Nonproportional = "NONPROPORTIONAL",
  Proportional = "PROPORTIONAL",
}

export type Treaty_Email_Data = {
  attachment: InputMaybe<Array<Scalars["String"]["input"]>>;
  copied_emails: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  message_content: InputMaybe<Scalars["String"]["input"]>;
  subject: InputMaybe<Scalars["String"]["input"]>;
  treaty_id: Scalars["ID"]["input"];
};

export type Treaty_Overview = {
  __typename?: "Treaty_overview";
  brokerage_chart: Maybe<Scalars["String"]["output"]>;
  total_brokerage_amt: Maybe<Scalars["String"]["output"]>;
  total_nonproportional: Maybe<Scalars["Int"]["output"]>;
  total_paid_treaties: Maybe<Scalars["Int"]["output"]>;
  total_partpayment_treaties: Maybe<Scalars["Int"]["output"]>;
  total_proportional: Maybe<Scalars["Int"]["output"]>;
  total_treaties: Maybe<Scalars["Int"]["output"]>;
  total_treaty_recoveries_due: Maybe<Scalars["String"]["output"]>;
  total_unpaid_treaties: Maybe<Scalars["Int"]["output"]>;
};

export type UpdatePassword = {
  old_password: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
  password_confirmation: Scalars["String"]["input"];
};

export type UpdatePasswordResponse = {
  __typename?: "UpdatePasswordResponse";
  message: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
};

export type UploadOffer = {
  files: InputMaybe<Array<Scalars["Upload"]["input"]>>;
  offer_id: InputMaybe<Scalars["ID"]["input"]>;
};

export type Usage = {
  __typename?: "Usage";
  created_at: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  pointsRedemption: Maybe<PointsRedemption>;
  points_redemptions_id: Scalars["Int"]["output"];
  prize: Scalars["String"]["output"];
  redeemed_by: Maybe<RedeemedUser>;
  status: Scalars["String"]["output"];
  updated_at: Scalars["String"]["output"];
  voucher: Scalars["String"]["output"];
};

export type User = {
  __typename?: "User";
  created_at: Scalars["DateTime"]["output"];
  email: Scalars["String"]["output"];
  employee: Maybe<Employee>;
  first_time_signin: Scalars["Boolean"]["output"];
  position: Scalars["String"]["output"];
  updated_at: Scalars["DateTime"]["output"];
  user_id: Scalars["ID"]["output"];
};

export type VerifyEmailInput = {
  token: Scalars["String"]["input"];
};

export type GetAutoFacConfigQueryVariables = Exact<{
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
}>;

export type GetAutoFacConfigQuery = {
  __typename?: "Query";
  getAutoFacConfigCount: number;
  getAutoFacConfig: Array<{
    __typename?: "AutoFacConfig";
    name: string | null;
    auto_fac_config_id: number | null;
    employee: {
      __typename?: "Employee";
      employee_first_name: string;
      employee_last_name: string;
      employee_email: string;
      emp_abbrv: string | null;
    } | null;
  }>;
};

export type GetAutoFacParticipantsQueryVariables = Exact<{
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
  autoFacConfigId: Scalars["Int"]["input"];
}>;

export type GetAutoFacParticipantsQuery = {
  __typename?: "Query";
  getAutoFacParticipants: Array<{
    __typename?: "AutoFacParticipant";
    share_percentage: number | null;
    auto_fac_participant_id: number | null;
    reinsurer: {
      __typename?: "Reinsurer";
      re_company_email: string;
      re_abbrv: string | null;
      re_company_name: string;
      re_company_website: string | null;
      reinsurer_id: string | null;
    } | null;
    employee: {
      __typename?: "Employee";
      emp_abbrv: string | null;
      employee_email: string;
      employee_first_name: string;
      employee_last_name: string;
    } | null;
  }>;
};

export type GetAutoFacParticipantQueryVariables = Exact<{
  autoFacParticipantId: Scalars["ID"]["input"];
}>;

export type GetAutoFacParticipantQuery = {
  __typename?: "Query";
  getAutoFacParticipant: {
    __typename?: "AutoFacParticipant";
    share_percentage: number | null;
    auto_fac_participant_id: number | null;
    reinsurer: {
      __typename?: "Reinsurer";
      reinsurer_id: string | null;
      re_company_name: string;
      re_company_email: string;
      re_company_website: string | null;
      re_abbrv: string | null;
      reinsurer_address: {
        __typename?: "Reinsurer_address";
        reinsurer_address_id: string;
        street: string;
        suburb: string;
        region: string;
        country: string;
      } | null;
    } | null;
    auto_fac_config: {
      __typename?: "AutoFacConfig";
      auto_fac_config_id: number | null;
      name: string | null;
    } | null;
    auto_fac_deduction: {
      __typename?: "AutoFacParticipantDeductions";
      brokerage: number | null;
      commission: number | null;
      wht: number | null;
      nic: number | null;
      overrider: number | null;
    } | null;
  } | null;
};

export type GetAutoFacConfigurationQueryVariables = Exact<{
  autoFacConfigurationId: Scalars["ID"]["input"];
}>;

export type GetAutoFacConfigurationQuery = {
  __typename?: "Query";
  getAutoFacConfiguration: {
    __typename?: "AutoFacConfig";
    name: string | null;
    employee: {
      __typename?: "Employee";
      employee_id: string;
      employee_first_name: string;
      employee_last_name: string;
      employee_phonenumber: string;
      employee_email: string;
      emp_abbrv: string | null;
    } | null;
    auto_fac_participants: Array<{
      __typename?: "AutoFacParticipant";
      share_percentage: number | null;
      reinsurer: {
        __typename?: "Reinsurer";
        reinsurer_id: string | null;
        re_company_name: string;
        re_company_email: string;
        re_company_website: string | null;
        re_abbrv: string | null;
      } | null;
      employee: {
        __typename?: "Employee";
        employee_first_name: string;
        employee_last_name: string;
      } | null;
    } | null> | null;
  } | null;
};

export type BrokersQueryVariables = Exact<{ [key: string]: never }>;

export type BrokersQuery = {
  __typename?: "Query";
  brokers: Array<{
    __typename?: "ReBroker";
    re_broker_id: string | null;
    re_broker_name: string | null;
    re_broker_email: string | null;
    re_broker_website: string | null;
    re_broker_address: {
      __typename?: "ReBrokerAddress";
      re_broker_address_id: string | null;
      street: string | null;
      city: string | null;
      region: string | null;
      country: string | null;
      re_primary_phone: string | null;
      re_secondary_phone: string | null;
    } | null;
    re_broker_associates: Array<{
      __typename?: "ReBrokerAssociate";
      re_broker_associate_id: string | null;
      re_broker_assoc_first_name: string | null;
      re_broker_assoc_last_name: string | null;
      re_broker_assoc_primary_phone: string | null;
      re_broker_assoc_secondary_phone: string | null;
      re_broker_assoc_position: string | null;
      re_broker_assoc_email: string | null;
      re_broker: {
        __typename?: "ReBroker";
        re_broker_id: string | null;
        re_broker_name: string | null;
      } | null;
    } | null> | null;
  } | null> | null;
};

export type BrokerQueryVariables = Exact<{
  brokerId: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type BrokerQuery = {
  __typename?: "Query";
  broker: {
    __typename?: "ReBroker";
    re_broker_id: string | null;
    re_broker_name: string | null;
    re_broker_email: string | null;
    re_broker_website: string | null;
    broker_overview: {
      __typename?: "Treaty_overview";
      total_treaties: number | null;
      total_proportional: number | null;
      total_nonproportional: number | null;
      total_unpaid_treaties: number | null;
      total_paid_treaties: number | null;
      total_partpayment_treaties: number | null;
      brokerage_chart: string | null;
      total_brokerage_amt: string | null;
    } | null;
    re_broker_address: {
      __typename?: "ReBrokerAddress";
      re_broker_address_id: string | null;
      street: string | null;
      city: string | null;
      region: string | null;
      country: string | null;
      re_primary_phone: string | null;
      re_secondary_phone: string | null;
    } | null;
  } | null;
};

export type GetBrokerAssociatesQueryVariables = Exact<{
  brokerId: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetBrokerAssociatesQuery = {
  __typename?: "Query";
  getBrokerAssociates: Array<{
    __typename?: "ReBrokerAssociate";
    re_broker_associate_id: string | null;
    re_broker_assoc_first_name: string | null;
    re_broker_assoc_last_name: string | null;
    re_broker_assoc_primary_phone: string | null;
    re_broker_assoc_secondary_phone: string | null;
    re_broker_assoc_position: string | null;
    re_broker_assoc_email: string | null;
  } | null> | null;
};

export type GetBrokerAssociateQueryVariables = Exact<{
  brokerAssociateId: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetBrokerAssociateQuery = {
  __typename?: "Query";
  getBrokerAssociate: {
    __typename?: "ReBrokerAssociate";
    re_broker_associate_id: string | null;
    re_broker_assoc_first_name: string | null;
    re_broker_assoc_last_name: string | null;
    re_broker_assoc_primary_phone: string | null;
    re_broker_assoc_secondary_phone: string | null;
    re_broker_assoc_position: string | null;
    re_broker_assoc_email: string | null;
  } | null;
};

export type ClassOfBusinessesQueryVariables = Exact<{
  category: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ClassOfBusinessesQuery = {
  __typename?: "Query";
  count: number | null;
  rows: Array<{
    __typename?: "Class_of_business";
    class_of_business_id: string;
    business_name: string;
    business_details: string;
    business_category: string | null;
    created_at: any;
  }>;
};

export type GetBusinessCategoriesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetBusinessCategoriesQuery = {
  __typename?: "Query";
  getBusinessCategories: Array<{
    __typename?: "BusinessCategory";
    name: string | null;
  } | null> | null;
};

export type SingleClassOfBusinessQueryVariables = Exact<{
  classOfBusinessId: Scalars["ID"]["input"];
}>;

export type SingleClassOfBusinessQuery = {
  __typename?: "Query";
  singleClassOfBusiness: {
    __typename?: "Class_of_business";
    class_of_business_id: string;
    business_name: string;
    business_details: string;
    business_category: string | null;
    created_at: any;
  };
};

export type GetDashboardOverviewQueryVariables = Exact<{
  dashboardInput: InputMaybe<DashboardOverviewInput>;
}>;

export type GetDashboardOverviewQuery = {
  __typename?: "Query";
  getDashboardOverview: {
    __typename?: "DashboardOverview";
    total_offers: number | null;
    total_pending_offers: number | null;
    total_open_offers: number | null;
    total_closed_offers: number | null;
    total_claim_offers: number | null;
    total_brokers: number | null;
    total_reinsurers: number | null;
    total_insurers: number | null;
    total_unclaim_offers: number | null;
    brokerage_earnings: {
      __typename?: "CurrencyDisaggregation";
      total_dollar: string | null;
      total_pounds: string | null;
      total_euros: string | null;
      total_cedis: string | null;
    } | null;
    total_fac_premium: {
      __typename?: "CurrencyDisaggregation";
      total_dollar: string | null;
      total_pounds: string | null;
      total_euros: string | null;
      total_cedis: string | null;
    } | null;
    total_fac_sum_insured: {
      __typename?: "CurrencyDisaggregation";
      total_dollar: string | null;
      total_pounds: string | null;
      total_euros: string | null;
      total_cedis: string | null;
    } | null;
    total_premium: {
      __typename?: "CurrencyDisaggregation";
      total_dollar: string | null;
      total_pounds: string | null;
      total_euros: string | null;
      total_cedis: string | null;
    } | null;
    total_sum_insured: {
      __typename?: "CurrencyDisaggregation";
      total_dollar: string | null;
      total_pounds: string | null;
      total_euros: string | null;
      total_cedis: string | null;
    } | null;
  } | null;
};

export type EmployeesQueryVariables = Exact<{ [key: string]: never }>;

export type EmployeesQuery = {
  __typename?: "Query";
  count: number | null;
  rows: Array<{
    __typename?: "Employee";
    employee_id: string;
    employee_first_name: string;
    employee_last_name: string;
    employee_phonenumber: string;
    employee_email: string;
    emp_abbrv: string | null;
    user: { __typename?: "User"; position: string };
  }>;
};

export type EmployeeQueryVariables = Exact<{
  employeeId: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type EmployeeQuery = {
  __typename?: "Query";
  employee: {
    __typename?: "Employee";
    employee_id: string;
    employee_first_name: string;
    employee_last_name: string;
    employee_phonenumber: string;
    employee_email: string;
    emp_abbrv: string | null;
    user: { __typename?: "User"; position: string };
  } | null;
};

export type GetEndorsementsQueryVariables = Exact<{
  args: InputMaybe<EndorsementFilters>;
}>;

export type GetEndorsementsQuery = {
  __typename?: "Query";
  count: number | null;
  rows: Array<{
    __typename?: "OfferEndorsement";
    rate: number | null;
    commission: number | null;
    commission_amount: number | null;
    brokerage: number | null;
    facultative_offer: number | null;
    sum_insured: number | null;
    fac_sum_insured: number | null;
    premium: number | null;
    fac_premium: number | null;
    created_at: any | null;
    approval_status: string | null;
    co_insurance_share: number | null;
    endorsement_status: Offer_Status | null;
    updated_at: any | null;
    offer_endorsement_id: string | null;
    offer: { __typename?: "Offer"; offer_id: string } | null;
    insurer: {
      __typename?: "Insurer";
      insurer_id: string;
      insurer_company_name: string;
      insurer_company_email: string;
      insurer_company_website: string | null;
      insurer_address: {
        __typename?: "Insurer_address";
        suburb: string;
        region: string;
        country: string;
      } | null;
    } | null;
    classofbusiness: {
      __typename?: "Class_of_business";
      class_of_business_id: string;
      business_name: string;
      business_details: string;
      created_at: any;
    } | null;
    offer_endorsement_detail: {
      __typename?: "OfferEndorsementDetail";
      offer_endorsement_detail_id: string | null;
      policy_number: string | null;
      insured_by: string | null;
      period_of_insurance_to: any | null;
      period_of_insurance_from: any | null;
      currency: string | null;
      offer_comment: string | null;
      information_comment: string | null;
      offer_detail: string | null;
    } | null;
    offer_endorsement_participants: Array<{
      __typename?: "OfferEndorsementParticipants";
      offer_end_participant_id: string | null;
      offer_end_participant_percentage: number | null;
      offer_end_amount: number | null;
      offer_end_participant_fac_premium: number | null;
      offer_end_participant_fac_sum_insured: number | null;
      offer_endorsement_extra_charges: {
        __typename?: "OfferEndorsementExtraCharge";
        end_nic_levy: number | null;
        end_nic_levy_amount: number | null;
        end_withholding_tax: number | null;
        end_agreed_brokerage_percentage: number | null;
        end_brokerage_amount: number | null;
        end_withholding_tax_amount: number | null;
        end_agreed_commission: number | null;
        end_agreed_commission_amount: number | null;
      } | null;
      reinsurer: {
        __typename?: "Reinsurer";
        reinsurer_id: string | null;
        re_company_name: string;
        re_company_email: string;
        re_company_website: string | null;
        re_abbrv: string | null;
      } | null;
    } | null> | null;
  } | null> | null;
};

export type GetEndorsementQueryVariables = Exact<{
  offerEndorsementId: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetEndorsementQuery = {
  __typename?: "Query";
  singleEndorsement: {
    __typename?: "OfferEndorsement";
    rate: number | null;
    commission: number | null;
    commission_amount: number | null;
    brokerage: number | null;
    facultative_offer: number | null;
    sum_insured: number | null;
    fac_sum_insured: number | null;
    premium: number | null;
    fac_premium: number | null;
    created_at: any | null;
    approval_status: string | null;
    co_insurance_share: number | null;
    endorsement_status: Offer_Status | null;
    updated_at: any | null;
    offer_endorsement_id: string | null;
    offer: {
      __typename?: "Offer";
      offer_id: string;
      rate: number;
      commission: number;
      commission_amount: number | null;
      brokerage: number;
      facultative_offer: number;
      sum_insured: number;
      fac_sum_insured: number;
      premium: number;
      fac_premium: number;
      offer_status: Offer_Status;
      payment_status: Payment_Status;
      claim_status: Claim_Status;
      created_at: any;
      offer_detail: {
        __typename?: "Offer_details";
        offer_detail_id: string;
        offersoffer_id: string;
        policy_number: string | null;
        insured_by: string;
        period_of_insurance_to: any | null;
        period_of_insurance_from: any | null;
        currency: string;
        offer_comment: string | null;
        offer_details: string | null;
      } | null;
      insurer: {
        __typename?: "Insurer";
        insurer_id: string;
        insurer_company_name: string;
        insurer_company_email: string;
        insurer_company_website: string | null;
        insurer_address: {
          __typename?: "Insurer_address";
          suburb: string;
          region: string;
          country: string;
        } | null;
      } | null;
      classofbusiness: {
        __typename?: "Class_of_business";
        class_of_business_id: string;
        business_name: string;
        business_details: string;
        created_at: any;
      } | null;
    } | null;
    insurer: {
      __typename?: "Insurer";
      insurer_id: string;
      insurer_company_name: string;
      insurer_company_email: string;
      insurer_company_website: string | null;
      insurer_address: {
        __typename?: "Insurer_address";
        suburb: string;
        region: string;
        country: string;
      } | null;
    } | null;
    classofbusiness: {
      __typename?: "Class_of_business";
      class_of_business_id: string;
      business_name: string;
      business_details: string;
      created_at: any;
    } | null;
    offer_endorsement_detail: {
      __typename?: "OfferEndorsementDetail";
      offer_endorsement_detail_id: string | null;
      policy_number: string | null;
      insured_by: string | null;
      period_of_insurance_to: any | null;
      period_of_insurance_from: any | null;
      currency: string | null;
      offer_comment: string | null;
      information_comment: string | null;
      offer_detail: string | null;
    } | null;
    offer_endorsement_participants: Array<{
      __typename?: "OfferEndorsementParticipants";
      offer_end_participant_id: string | null;
      offer_end_participant_percentage: number | null;
      offer_end_amount: number | null;
      offer_end_participant_fac_premium: number | null;
      offer_end_participant_fac_sum_insured: number | null;
      offer_endorsement_extra_charges: {
        __typename?: "OfferEndorsementExtraCharge";
        end_nic_levy: number | null;
        end_nic_levy_amount: number | null;
        end_withholding_tax: number | null;
        end_agreed_brokerage_percentage: number | null;
        end_brokerage_amount: number | null;
        end_withholding_tax_amount: number | null;
        end_agreed_commission: number | null;
        end_agreed_commission_amount: number | null;
      } | null;
      reinsurer: {
        __typename?: "Reinsurer";
        reinsurer_id: string | null;
        re_company_name: string;
        re_company_email: string;
        re_company_website: string | null;
        re_abbrv: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type InsurersQueryVariables = Exact<{ [key: string]: never }>;

export type InsurersQuery = {
  __typename?: "Query";
  count: number | null;
  rows: Array<{
    __typename?: "Insurer";
    insurer_id: string;
    insurer_company_name: string;
    insurer_company_email: string;
    insurer_company_website: string | null;
    insurer_abbrv: string | null;
    insurer_address: {
      __typename?: "Insurer_address";
      country: string;
      insurer_address_id: string;
      region: string;
      street: string;
      suburb: string;
    } | null;
    remainders: Array<{
      __typename?: "Remainder";
      remainder_id: string | null;
    } | null> | null;
  }>;
};

export type InsurerQueryVariables = Exact<{
  insurerId: Scalars["ID"]["input"];
}>;

export type InsurerQuery = {
  __typename?: "Query";
  insurer: {
    __typename?: "Insurer";
    insurer_id: string;
    insurer_company_name: string;
    insurer_company_email: string;
    insurer_company_website: string | null;
    insurer_abbrv: string | null;
    insurer_overview: {
      __typename?: "Client_overview";
      total_brokerage_amt: string | null;
      total_closed: number | null;
      total_fac_premium: string | null;
      total_nic_tax: string | null;
      total_paid: number | null;
      total_pending: number | null;
      total_unpaid: number | null;
      total_withholding_tax: string | null;
      total_fac_nic_levy: string | null;
      total_fac_recoveries_due: string | null;
      total_outstanding_fac_premium: string | null;
      treaties_overview: {
        __typename?: "Treaty_overview";
        total_brokerage_amt: string | null;
        total_nonproportional: number | null;
        total_paid_treaties: number | null;
        total_partpayment_treaties: number | null;
        total_proportional: number | null;
        total_treaties: number | null;
        total_unpaid_treaties: number | null;
        total_treaty_recoveries_due: string | null;
      } | null;
    } | null;
    insurer_address: {
      __typename?: "Insurer_address";
      country: string;
      insurer_address_id: string;
      region: string;
      street: string;
      suburb: string;
    } | null;
  } | null;
};

export type GetInsurerAssociatesQueryVariables = Exact<{
  insurerId: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetInsurerAssociatesQuery = {
  __typename?: "Query";
  getInsurerAssociates: Array<{
    __typename?: "Insurer_associate";
    insurer_associate_id: string;
    assoc_first_name: string;
    assoc_last_name: string;
    assoc_primary_phonenumber: string;
    assoc_secondary_phonenumber: string | null;
    assoc_email: string | null;
    position: string | null;
  } | null> | null;
};

export type GetInsurerAssociateQueryVariables = Exact<{
  insurerAssociateId: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetInsurerAssociateQuery = {
  __typename?: "Query";
  getInsurerAssociate: {
    __typename?: "Insurer_associate";
    insurer_associate_id: string;
    assoc_first_name: string;
    assoc_last_name: string;
    assoc_primary_phonenumber: string;
    assoc_secondary_phonenumber: string | null;
    assoc_email: string | null;
    position: string | null;
  } | null;
};

export type FetchLeaderboardStatisticsQueryVariables = Exact<{
  brokerId: Scalars["ID"]["input"];
  startDate: InputMaybe<Scalars["String"]["input"]>;
  endDate: InputMaybe<Scalars["String"]["input"]>;
  badge: InputMaybe<Scalars["String"]["input"]>;
  year: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type FetchLeaderboardStatisticsQuery = {
  __typename?: "Query";
  fetchTotalCashAccumulated: {
    __typename?: "TotalCashAccumulated";
    total_cash_accumulated: number | null;
  } | null;
  fetchLeaderboardStatistics: {
    __typename?: "LeaderboardResponse";
    badges: Array<{
      __typename?: "Badge";
      name: string;
      count: number;
      insurers: Array<{
        __typename?: "InsuranceStatistic";
        id: string;
        insurer_id: string;
        insurer_name: string;
        total_points: number | null;
        total_redeemable_points: number | null;
        total_redeemable_cash_equivalent: number | null;
      }>;
    }>;
    target: {
      __typename?: "Target";
      id: string | null;
      broker_id: string | null;
      target_name: string | null;
      base_currency: string | null;
      start_date: string | null;
      end_date: string | null;
      insurer_id: string | null;
      target_badges: Array<{
        __typename?: "TargetBadge";
        id: string | null;
        name: string | null;
        min_points: number | null;
        max_points: number | null;
        description: string | null;
        minimum_cash_equivalent: number | null;
        cash_equivalent: number | null;
        gift_basket: Array<{
          __typename?: "GiftBasketItem";
          gift_name: string;
          gift_type: string;
          gift_image: string | null;
          gift_description: string | null;
        } | null> | null;
      } | null> | null;
    } | null;
  } | null;
};

export type GetNotificationsQueryVariables = Exact<{
  filter: InputMaybe<NotificationFilter>;
  pagination: InputMaybe<Pagination>;
}>;

export type GetNotificationsQuery = {
  __typename?: "Query";
  getNotificationsCount: number | null;
  getNotifications: Array<{
    __typename?: "EmployeeNotification";
    employee_notification_id: string | null;
    created_at: any | null;
    system_notification: {
      __typename?: "SystemNotification";
      system_notification_id: string | null;
      notification_type: string | null;
      notification_content: string | null;
      created_at: any | null;
    } | null;
  } | null> | null;
};

export type OffersQueryVariables = Exact<{
  args: InputMaybe<OfferFilters>;
}>;

export type OffersQuery = {
  __typename?: "Query";
  count: number | null;
  rows: Array<{
    __typename?: "Offer";
    offer_id: string;
    rate: number;
    commission: number;
    commission_amount: number | null;
    brokerage: number;
    facultative_offer: number;
    expiry_status: Expiry_Status;
    distribute_status: string | null;
    sum_insured: number;
    fac_sum_insured: number;
    offer_from: string | null;
    premium: number;
    fac_premium: number;
    offer_status: Offer_Status;
    payment_status: Payment_Status;
    claim_status: Claim_Status;
    created_at: any;
    place_it_id: string | null;
    offer_published: {
      __typename?: "OfferPublished";
      published_status: PublishedStatus;
    } | null;
    offer_detail: {
      __typename?: "Offer_details";
      offer_detail_id: string;
      offersoffer_id: string;
      policy_number: string | null;
      insured_by: string;
      period_of_insurance_to: any | null;
      period_of_insurance_from: any | null;
      currency: string;
      offer_comment: string | null;
      offer_details: string | null;
    } | null;
    offer_claims: Array<{
      __typename?: "Offer_claim";
      offer_claim_id: string | null;
      claim_amount: number | null;
      claim_comment: string | null;
      claim_date: any | null;
      created_at: any | null;
      offer_claim_participants: Array<{
        __typename?: "Offer_claim_participant";
        offer_claimsoffer_claim_id: string | null;
        offer_claim_participant_id: string | null;
        reinsurer_id: string | null;
        offer_participantsoffer_participant_id: string | null;
        offer_participant_percentage: number | null;
        re_company_name: string | null;
        claim_share: number;
        created_at: any;
      } | null> | null;
    } | null> | null;
    offer_participant: Array<{
      __typename?: "Offer_participant";
      offer_participant_id: string | null;
      offer_participant_percentage: number | null;
      offer_amount: number | null;
      participant_fac_premium: number | null;
      participant_fac_sum_insured: number | null;
      offer_extra_charges: {
        __typename?: "Offer_extra_charges";
        nic_levy: number;
        agreed_brokerage_percentage: number;
        withholding_tax: number;
        agreed_commission: number | null;
        agreed_commission_amount: number | null;
        brokerage_amount: number;
        nic_levy_amount: number;
        withholding_tax_amount: number;
      } | null;
      offer_deduction_charge: {
        __typename?: "Offer_deduction_payment";
        nic_levy_paid: number | null;
        withholding_tax_paid: number | null;
        brokerage_amount_paid: number | null;
        commission_taken: number | null;
      } | null;
      reinsurer: {
        __typename?: "Reinsurer";
        reinsurer_id: string | null;
        re_company_name: string;
        re_company_email: string;
        reinsurer_address: {
          __typename?: "Reinsurer_address";
          country: string;
        } | null;
      };
    } | null> | null;
    insurer: {
      __typename?: "Insurer";
      insurer_id: string;
      insurer_company_name: string;
      insurer_company_email: string;
      insurer_company_website: string | null;
      insurer_address: {
        __typename?: "Insurer_address";
        suburb: string;
        region: string;
        country: string;
      } | null;
    } | null;
    classofbusiness: {
      __typename?: "Class_of_business";
      class_of_business_id: string;
      business_name: string;
      business_details: string;
      created_at: any;
    } | null;
    employee: {
      __typename?: "Employee";
      employee_id: string;
      employee_first_name: string;
      employee_last_name: string;
      employee_phonenumber: string;
      employee_email: string;
      emp_abbrv: string | null;
    };
    thread_notification: Array<{
      __typename?: "ThreadNotification";
      id: string | null;
      status: string | null;
    } | null> | null;
  } | null> | null;
};

export type GetReinsurerOffersQueryVariables = Exact<{
  args: InputMaybe<OfferFiltersReinsurer>;
  reinsurer_id: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetReinsurerOffersQuery = {
  __typename?: "Query";
  getReinsurerOffersCount: number | null;
  getReinsurerOffers: Array<{
    __typename?: "Offer_participant";
    offersoffer_id: string | null;
    offer_participant_id: string | null;
    offer_participant_percentage: number | null;
    participant_fac_premium: number | null;
    offer_detail: {
      __typename?: "Offer_details";
      currency: string;
      policy_number: string | null;
    } | null;
    offer_extra_charges: {
      __typename?: "Offer_extra_charges";
      offer_extra_charge_id: string;
      withholding_tax: number;
      agreed_commission: number | null;
      nic_levy: number;
      agreed_brokerage_percentage: number;
    } | null;
    offer_participant_payment: Array<{
      __typename?: "Offer_participant_payment";
      offer_participant_payment_id: string;
      offer_payment_amount: number;
      paid_details: string;
      offer_participant_payment_comment: string;
      payment_status: Payment_Status;
      created_at: any;
      updated_at: any;
      offer_deduction_charge: {
        __typename?: "Offer_deduction_payment";
        offer_deduction_payment_id: string;
        nic_levy_paid: number | null;
        withholding_tax_paid: number | null;
        brokerage_amount_paid: number | null;
        commission_taken: number | null;
      } | null;
    } | null> | null;
    reinsurer_offers_only: {
      __typename?: "Offer";
      offer_id: string;
      rate: number;
      premium: number;
      brokerage: number;
      fac_premium: number;
      facultative_offer: number;
      commission: number;
      fac_sum_insured: number;
      sum_insured: number;
      created_at: any;
      offer_status: Offer_Status;
      payment_status: Payment_Status;
      classofbusiness: {
        __typename?: "Class_of_business";
        business_name: string;
        class_of_business_id: string;
        business_details: string;
      } | null;
      insurer: { __typename?: "Insurer"; insurer_company_name: string } | null;
      offer_detail: {
        __typename?: "Offer_details";
        insured_by: string;
        currency: string;
        policy_number: string | null;
        period_of_insurance_from: any | null;
        period_of_insurance_to: any | null;
        offer_comment: string | null;
        offer_details: string | null;
      } | null;
    };
  } | null> | null;
};

export type GetOfferParticipantQueryVariables = Exact<{
  participantId: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetOfferParticipantQuery = {
  __typename?: "Query";
  getOfferParticipant: {
    __typename?: "Offer_participant";
    offersoffer_id: string | null;
    offer_participant_id: string | null;
    offer_participant_percentage: number | null;
    offer_amount: number | null;
    participant_fac_premium: number | null;
    participant_fac_sum_insured: number | null;
    created_at: any;
    reinsurer: {
      __typename?: "Reinsurer";
      reinsurer_id: string | null;
      re_abbrv: string | null;
      re_company_email: string;
      re_company_name: string;
      reinsurer_address: {
        __typename?: "Reinsurer_address";
        country: string;
      } | null;
    };
  } | null;
};

export type GetEndorsementParticipantQueryVariables = Exact<{
  offerEndParticipantId: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetEndorsementParticipantQuery = {
  __typename?: "Query";
  getEndorsementParticipant: {
    __typename?: "OfferEndorsementParticipants";
    offer_end_participant_id: string | null;
    offer_end_participant_percentage: number | null;
    offer_end_amount: number | null;
    offer_end_participant_fac_premium: number | null;
    offer_end_participant_fac_sum_insured: number | null;
    offer_endorsement_extra_charges: {
      __typename?: "OfferEndorsementExtraCharge";
      end_nic_levy: number | null;
      end_nic_levy_amount: number | null;
      end_withholding_tax: number | null;
      end_agreed_brokerage_percentage: number | null;
      end_brokerage_amount: number | null;
      end_withholding_tax_amount: number | null;
      end_agreed_commission: number | null;
      end_agreed_commission_amount: number | null;
    } | null;
    reinsurer: {
      __typename?: "Reinsurer";
      reinsurer_id: string | null;
      re_company_name: string;
    } | null;
  } | null;
};

export type GetOfferAssociatesQueryVariables = Exact<{
  offerId: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetOfferAssociatesQuery = {
  __typename?: "Query";
  getOfferAssociates: Array<{
    __typename?: "Offer_to_associates";
    offer_to_associate_id: string;
    message_content: string;
    message_attachment: string | null;
    sent_status: Sent_Status;
    created_at: any;
    offer_participants: Array<{
      __typename?: "Offer_participant";
      offersoffer_id: string | null;
      offer_participant_id: string | null;
      offer_participant_percentage: number | null;
      offer_amount: number | null;
      participant_fac_premium: number | null;
      participant_fac_sum_insured: number | null;
      created_at: any;
    } | null> | null;
    reinsurer_representative: {
      __typename?: "Reinsurer_representative";
      reinsurer_representative_id: string | null;
      reinsurersreinsurer_id: string;
      rep_first_name: string;
      rep_last_name: string;
      rep_primary_phonenumber: string;
      rep_secondary_phonenumber: string | null;
      rep_email: string;
      position: string;
      reinsurer: {
        __typename?: "Reinsurer";
        re_company_email: string;
        re_company_name: string;
      };
    } | null;
  } | null> | null;
};

export type OfferFleetQueryVariables = Exact<{
  policy_number: InputMaybe<Scalars["String"]["input"]>;
  skip: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type OfferFleetQuery = {
  __typename?: "Query";
  getOfferFleet: Array<{
    __typename?: "MotorFleet";
    offer_id: string | null;
    vehile_reg_no: string | null;
  } | null> | null;
};

export type OfferQueryVariables = Exact<{
  offer_id: Scalars["ID"]["input"];
}>;

export type OfferQuery = {
  __typename?: "Query";
  findSingleOffer: {
    __typename?: "Offer";
    offer_id: string;
    place_it_id: string | null;
    offer_from: string | null;
    rate: number;
    commission: number;
    commission_amount: number | null;
    brokerage: number;
    facultative_offer: number;
    sum_insured: number;
    fac_sum_insured: number;
    premium: number;
    fac_premium: number;
    offer_status: Offer_Status;
    payment_status: Payment_Status;
    claim_status: Claim_Status;
    offer_published: {
      __typename?: "OfferPublished";
      published_status: PublishedStatus;
    } | null;
    offer_detail: {
      __typename?: "Offer_details";
      offer_detail_id: string;
      offersoffer_id: string;
      policy_number: string | null;
      insured_by: string;
      period_of_insurance_to: any | null;
      period_of_insurance_from: any | null;
      currency: string;
      offer_comment: string | null;
      offer_details: string | null;
    } | null;
    offer_participant: Array<{
      __typename?: "Offer_participant";
      offer_participant_id: string | null;
      offer_participant_percentage: number | null;
      offer_amount: number | null;
      reinsurer: {
        __typename?: "Reinsurer";
        reinsurer_id: string | null;
        re_company_name: string;
        re_company_email: string;
        re_abbrv: string | null;
      };
      thread_notification: Array<{
        __typename?: "ThreadNotification";
        id: string | null;
        status: string | null;
      } | null> | null;
      offer_published_participant: {
        __typename?: "OfferPublishedParticipant";
        offer_published_participant_id: string;
      } | null;
    } | null> | null;
    classofbusiness: {
      __typename?: "Class_of_business";
      class_of_business_id: string;
      business_name: string;
      business_details: string;
      business_category: string | null;
      created_at: any;
    } | null;
    insurer: {
      __typename?: "Insurer";
      insurer_company_name: string;
      insurer_company_email: string;
      insurer_company_website: string | null;
      insurer_id: string;
    } | null;
    offer_associates: Array<{
      __typename?: "Offer_to_associates";
      offer_to_associate_id: string;
      sent_status: Sent_Status;
      reinsurer_representative: {
        __typename?: "Reinsurer_representative";
        rep_email: string;
        rep_first_name: string;
        rep_last_name: string;
        rep_primary_phonenumber: string;
        rep_secondary_phonenumber: string | null;
        reinsurer: {
          __typename?: "Reinsurer";
          re_company_name: string;
          re_company_email: string;
        };
      } | null;
    } | null> | null;
    offer_claims: Array<{
      __typename?: "Offer_claim";
      claim_amount: number | null;
      claim_comment: string | null;
      claim_date: any | null;
      created_at: any | null;
      offer_claim_id: string | null;
      offer_claim_participants: Array<{
        __typename?: "Offer_claim_participant";
        claim_share: number;
        created_at: any;
        offer_claim_participant_id: string | null;
        offer_claimsoffer_claim_id: string | null;
        offer_participant_percentage: number | null;
        offer_participantsoffer_participant_id: string | null;
        re_company_name: string | null;
        reinsurer_id: string | null;
      } | null> | null;
    } | null> | null;
    reinsurer_offer_extra_charge: {
      __typename?: "Offer_extra_charges";
      offer_extra_charge_id: string;
      nic_levy: number;
      nic_levy_amount: number;
      withholding_tax: number;
      withholding_tax_amount: number;
      agreed_brokerage_percentage: number;
      brokerage_amount: number;
      agreed_commission: number | null;
      agreed_commission_amount: number | null;
      created_at: any;
    } | null;
    offer_endorsements: Array<{
      __typename?: "OfferEndorsement";
      offer_endorsement_id: string | null;
      rate: number | null;
      commission: number | null;
      commission_amount: number | null;
      brokerage: number | null;
      facultative_offer: number | null;
      co_insurance_share: number | null;
      sum_insured: number | null;
      fac_sum_insured: number | null;
      premium: number | null;
      fac_premium: number | null;
      endorsement_status: Offer_Status | null;
      approval_status: string | null;
      created_at: any | null;
      updated_at: any | null;
    } | null> | null;
  };
};

export type GetOfferClaimsQueryVariables = Exact<{
  args: InputMaybe<ClaimsFilter>;
}>;

export type GetOfferClaimsQuery = {
  __typename?: "Query";
  getOfferClaims: Array<{
    __typename?: "OfferClaim";
    offer_claim_id: string;
    claim_amount: number | null;
    claim_comment: string | null;
    claim_date: any | null;
    currency: string | null;
    rate: string | null;
    offer: {
      __typename?: "Offer";
      offer_detail: { __typename?: "Offer_details"; currency: string } | null;
    } | null;
  } | null> | null;
};

export type GetClaimSharesQueryVariables = Exact<{
  offerClaimId: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetClaimSharesQuery = {
  __typename?: "Query";
  getClaimShares: Array<{
    __typename?: "Offer_claim_participant";
    offer_claim_participant_id: string | null;
    claim_share: number;
    created_at: any;
    offer_claimsoffer_claim_id: string | null;
    reinsurer_id: string | null;
    re_company_name: string | null;
    offer_participantsoffer_participant_id: string | null;
    offer_participant_percentage: number | null;
    offer_claim: {
      __typename?: "Offer_claim";
      offer_claim_id: string | null;
      claim_amount: number | null;
      claim_date: any | null;
      created_at: any | null;
      claim_comment: string | null;
    } | null;
    offer_participant: {
      __typename?: "Offer_participant";
      offersoffer_id: string | null;
      offer_participant_id: string | null;
      offer_participant_percentage: number | null;
      offer_amount: number | null;
      participant_fac_premium: number | null;
      participant_fac_sum_insured: number | null;
      created_at: any;
      reinsurer: {
        __typename?: "Reinsurer";
        re_company_name: string;
        reinsurer_id: string | null;
      };
      offer_detail: { __typename?: "Offer_details"; currency: string } | null;
    } | null;
  } | null> | null;
};

export type GetClaimShareQueryVariables = Exact<{
  offerClaimParticipantId: Scalars["ID"]["input"];
}>;

export type GetClaimShareQuery = {
  __typename?: "Query";
  getClaimShare: {
    __typename?: "Offer_claim_participant";
    offer_claim_participant_id: string | null;
    claim_share: number;
    created_at: any;
    offer_claimsoffer_claim_id: string | null;
    reinsurer_id: string | null;
    re_company_name: string | null;
    offer_participantsoffer_participant_id: string | null;
    offer_participant_percentage: number | null;
  } | null;
};

export type GetOfferClaimParticipantPaymentsQueryVariables = Exact<{
  offerClaimParticipantId: Scalars["ID"]["input"];
}>;

export type GetOfferClaimParticipantPaymentsQuery = {
  __typename?: "Query";
  getOfferClaimParticipantPayments: Array<{
    __typename?: "OfferClaimParticipantPayment";
    offer_claim_participant_payment_id: string;
    claim_share_payment_amount: number;
    payment_details: string;
    payment_comment: string | null;
    payment_date: any;
    delete_status: DeleteStatusEnum;
    created_at: any;
    updated_at: any;
    offer_claim_participant: {
      __typename?: "OfferClaimParticipant";
      offer_claim_participant_id: string;
      claim_share: number;
      payment_status: Payment_Status | null;
      delete_status: string;
      created_at: any;
      updated_at: any;
      offer_claim: {
        __typename?: "OfferClaim";
        offer_claim_id: string;
        claim_amount: number | null;
        claim_comment: string | null;
        claim_date: any | null;
        currency: string | null;
        rate: string | null;
      };
      offer_participant: {
        __typename?: "OfferParticipant";
        offer_participantsoffer_participant_id: string;
      };
    };
  } | null> | null;
};

export type GetSupportingDocsListQueryVariables = Exact<{
  offerId: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetSupportingDocsListQuery = {
  __typename?: "Query";
  getSupportingDocsList: Array<string | null> | null;
};

export type GetNotAcceptedParticipantsQueryVariables = Exact<{
  offerId: Scalars["ID"]["input"];
}>;

export type GetNotAcceptedParticipantsQuery = {
  __typename?: "Query";
  getNotAcceptedParticipants: Array<{
    __typename?: "OfferPublishedParticipant";
    offer_published_participant_id: string;
    offer_participant_percentage: number;
    transaction_thread: string;
    participation_status: string;
    reinsurer: {
      __typename?: "Reinsurer";
      reinsurer_id: string | null;
      re_company_name: string;
      re_company_email: string;
      re_company_website: string | null;
      re_abbrv: string | null;
    };
  }>;
};

export type GetUserActivitiesQueryVariables = Exact<{
  filter: InputMaybe<ActivityFilter>;
  pagination: InputMaybe<Pagination>;
}>;

export type GetUserActivitiesQuery = {
  __typename?: "Query";
  getUserActivities: Array<{
    __typename?: "Log_activity";
    device_ip: string | null;
    device_type: string | null;
    country: string | null;
    region: string | null;
    city: string | null;
    created_at: any | null;
  }>;
};

export type GetOfferPaymentsQueryVariables = Exact<{
  args: InputMaybe<OfferPaymentInput>;
}>;

export type GetOfferPaymentsQuery = {
  __typename?: "Query";
  getOfferPayments: Array<{
    __typename?: "Offer_payment";
    offer_payment_id: string;
    payment_amount: number;
    offer_payment_comment: string;
    payment_details: string;
    created_at: any;
    updated_at: any;
    distribute_payment: string | null;
    offer: {
      __typename?: "Offer";
      offer_id: string;
      rate: number;
      commission: number;
      commission_amount: number | null;
      brokerage: number;
      facultative_offer: number;
      sum_insured: number;
      fac_sum_insured: number;
      premium: number;
      fac_premium: number;
      offer_status: Offer_Status;
      payment_status: Payment_Status;
      claim_status: Claim_Status;
      created_at: any;
      updated_at: any;
    } | null;
  } | null> | null;
};

export type GetOfferPaymentQueryVariables = Exact<{
  id: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetOfferPaymentQuery = {
  __typename?: "Query";
  getOfferPayment: {
    __typename?: "Offer_payment";
    offer_payment_id: string;
    payment_amount: number;
    offer_payment_comment: string;
    payment_details: string;
    created_at: any;
    updated_at: any;
    offer: {
      __typename?: "Offer";
      offer_id: string;
      rate: number;
      commission: number;
      commission_amount: number | null;
      brokerage: number;
      facultative_offer: number;
      sum_insured: number;
      fac_sum_insured: number;
      premium: number;
      fac_premium: number;
      offer_status: Offer_Status;
      payment_status: Payment_Status;
      claim_status: Claim_Status;
      created_at: any;
      updated_at: any;
    } | null;
  } | null;
};

export type OfferparticipantDeductionsQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
  offer_id: InputMaybe<Scalars["ID"]["input"]>;
  payment_id: Scalars["ID"]["input"];
}>;

export type OfferparticipantDeductionsQuery = {
  __typename?: "Query";
  getOfferparticipantDeductions: string | null;
};

export type GetAllPointRedemptionUsagesQueryVariables = Exact<{
  broker_id: Scalars["ID"]["input"];
}>;

export type GetAllPointRedemptionUsagesQuery = {
  __typename?: "Query";
  getAllPointRedemptionUsages: Array<{
    __typename?: "Usage";
    id: string;
    points_redemptions_id: number;
    status: string;
    prize: string;
    voucher: string;
    created_at: string;
    updated_at: string;
    redeemed_by: {
      __typename?: "RedeemedUser";
      id: string;
      assoc_first_name: string;
      assoc_last_name: string;
      assoc_email: string;
      assoc_primary_phonenumber: string;
      position: string;
    } | null;
  }>;
};

export type GetPointRedemptionUsageQueryVariables = Exact<{
  redemption_id: Scalars["ID"]["input"];
}>;

export type GetPointRedemptionUsageQuery = {
  __typename?: "Query";
  getPointRedemptionUsage: {
    __typename?: "Usage";
    id: string;
    points_redemptions_id: number;
    status: string;
    prize: string;
    voucher: string;
    created_at: string;
    updated_at: string;
    redeemed_by: {
      __typename?: "RedeemedUser";
      id: string;
      assoc_first_name: string;
      assoc_last_name: string;
      assoc_email: string;
      assoc_primary_phonenumber: string;
      position: string;
    } | null;
  };
};

export type PublishedOffersQueryVariables = Exact<{
  offerStatus: OfferStatus;
  limit: InputMaybe<Scalars["Int"]["input"]>;
  offset: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type PublishedOffersQuery = {
  __typename?: "Query";
  publishedOffers: Array<{
    __typename?: "OfferPublished";
    offer_published_id: string;
    published_status: PublishedStatus;
    employeesemployee_id: number | null;
    updated_by: number | null;
    time_of_expiry: string;
    created_at: any;
    updated_at: any;
    status: string;
    employee: {
      __typename?: "Employee";
      employee_id: string;
      employee_first_name: string;
      employee_email: string;
      emp_abbrv: string | null;
      employee_last_name: string;
      employee_phonenumber: string;
    } | null;
    offer: { __typename?: "Offer"; offer_id: string };
  }>;
};

export type QueryQueryVariables = Exact<{
  offerStatus: OfferStatus;
  limit: InputMaybe<Scalars["Int"]["input"]>;
  offset: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type QueryQuery = { __typename?: "Query"; publishedOffersCount: number };

export type GetOfferPublishedParticipantsQueryVariables = Exact<{
  offerId: Scalars["ID"]["input"];
}>;

export type GetOfferPublishedParticipantsQuery = {
  __typename?: "Query";
  getOfferPublishedParticipants: Array<{
    __typename?: "OfferPublishedParticipant";
    offer_published_participant_id: string;
    offer_participant_percentage: number;
    transaction_thread: string;
    participation_status: string;
    reinsurer: {
      __typename?: "Reinsurer";
      reinsurer_id: string | null;
      re_company_website: string | null;
      re_company_name: string;
      re_company_email: string;
      re_abbrv: string | null;
    };
    reinsurer_representative: {
      __typename?: "ReinsurerRepresentative";
      rep_first_name: string;
      rep_last_name: string;
      rep_primary_phonenumber: string | null;
      rep_secondary_phonenumber: string | null;
      rep_email: string;
      reinsurer_representative_id: string;
      position: string;
      delete_status: string | null;
    } | null;
    offer: {
      __typename?: "Offer";
      offer_id: string;
      facultative_offer: number;
    };
    unread_messages: Array<{
      __typename?: "TransactionThread";
      id: string | null;
      status: string | null;
      receiver_type: string | null;
      offer_published_participant_id: string | null;
      offer: { __typename?: "Offer"; offer_id: string } | null;
    } | null> | null;
  }>;
};

export type ReinsurersQueryVariables = Exact<{ [key: string]: never }>;

export type ReinsurersQuery = {
  __typename?: "Query";
  count: number | null;
  rows: Array<{
    __typename?: "Reinsurer";
    re_abbrv: string | null;
    re_company_email: string;
    re_company_name: string;
    re_company_website: string | null;
    reinsurer_id: string | null;
    reinsurer_address: {
      __typename?: "Reinsurer_address";
      country: string;
      region: string;
      reinsurer_address_id: string;
      street: string;
      suburb: string;
    } | null;
    reinsurer_representatives: Array<{
      __typename?: "Reinsurer_representative";
      reinsurer_representative_id: string | null;
    } | null> | null;
  }>;
};

export type GetReinsurerParticipantPaymentsQueryVariables = Exact<{
  offerParticipantId: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetReinsurerParticipantPaymentsQuery = {
  __typename?: "Query";
  getReinsurerParticipantPayments: Array<{
    __typename?: "Offer_participant_payment";
    offer_participant_payment_id: string;
    offer_payment_amount: number;
    paid_details: string;
    offer_participant_payment_comment: string;
    payment_status: Payment_Status;
    created_at: any;
    updated_at: any;
    offer_deduction_charge: {
      __typename?: "Offer_deduction_payment";
      offer_deduction_payment_id: string;
      nic_levy_paid: number | null;
      withholding_tax_paid: number | null;
      brokerage_amount_paid: number | null;
      commission_taken: number | null;
    } | null;
  } | null> | null;
};

export type GetReinsurerParticipantPaymentQueryVariables = Exact<{
  participant_payment_id: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetReinsurerParticipantPaymentQuery = {
  __typename?: "Query";
  getReinsurerParticipantPayment: {
    __typename?: "Offer_participant_payment";
    offer_participant_payment_id: string;
    offer_payment_amount: number;
    paid_details: string;
    offer_participant_payment_comment: string;
    payment_status: Payment_Status;
    created_at: any;
    updated_at: any;
    offer_deduction_charge: {
      __typename?: "Offer_deduction_payment";
      offer_deduction_payment_id: string;
      nic_levy_paid: number | null;
      withholding_tax_paid: number | null;
      brokerage_amount_paid: number | null;
      commission_taken: number | null;
    } | null;
  } | null;
};

export type GetReinsurerAssociatesQueryVariables = Exact<{
  reinsurerId: InputMaybe<Scalars["ID"]["input"]>;
  pagination: InputMaybe<Pagination>;
}>;

export type GetReinsurerAssociatesQuery = {
  __typename?: "Query";
  count: number | null;
  getReinsurerAssociates: Array<{
    __typename?: "Reinsurer_representative";
    reinsurer_representative_id: string | null;
    reinsurersreinsurer_id: string;
    rep_first_name: string;
    rep_last_name: string;
    rep_primary_phonenumber: string;
    rep_secondary_phonenumber: string | null;
    rep_email: string;
    position: string;
    reinsurer: {
      __typename?: "Reinsurer";
      re_abbrv: string | null;
      re_company_email: string;
      re_company_name: string;
      re_company_website: string | null;
      reinsurer_id: string | null;
    };
  } | null> | null;
};

export type GetReinsurerRepQueryVariables = Exact<{
  repId: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetReinsurerRepQuery = {
  __typename?: "Query";
  getReinsurerRep: {
    __typename?: "Reinsurer_representative";
    reinsurer_representative_id: string | null;
    reinsurersreinsurer_id: string;
    rep_first_name: string;
    rep_last_name: string;
    rep_primary_phonenumber: string;
    rep_secondary_phonenumber: string | null;
    rep_email: string;
    position: string;
  } | null;
};

export type GetReinsurerRepsQueryVariables = Exact<{ [key: string]: never }>;

export type GetReinsurerRepsQuery = {
  __typename?: "Query";
  getReinsurerReps: Array<{
    __typename?: "Reinsurer_representative";
    reinsurer_representative_id: string | null;
    reinsurersreinsurer_id: string;
    rep_first_name: string;
    rep_last_name: string;
    rep_primary_phonenumber: string;
    rep_secondary_phonenumber: string | null;
    rep_email: string;
    position: string;
    reinsurer: {
      __typename?: "Reinsurer";
      re_abbrv: string | null;
      re_company_email: string;
      re_company_name: string;
    };
  } | null> | null;
};

export type ReinsurerQueryVariables = Exact<{
  reinsurerId: Scalars["ID"]["input"];
}>;

export type ReinsurerQuery = {
  __typename?: "Query";
  reinsurer: {
    __typename?: "Reinsurer";
    reinsurer_id: string | null;
    re_company_name: string;
    re_company_email: string;
    re_company_website: string | null;
    re_abbrv: string | null;
    reinsurer_address: {
      __typename?: "Reinsurer_address";
      reinsurer_address_id: string;
      street: string;
      suburb: string;
      region: string;
      country: string;
    } | null;
    reinsurer_overview: {
      __typename?: "Client_overview";
      brokerage_chart: string | null;
      total_brokerage_amt: string | null;
      total_closed: number | null;
      total_fac_premium: string | null;
      total_nic_tax: string | null;
      total_paid: number | null;
      total_pending: number | null;
      total_unpaid: number | null;
      total_withholding_tax: string | null;
    } | null;
  };
};

export type ReportOnQueryMutationVariables = Exact<{
  data: InputMaybe<Query_Data>;
}>;

export type ReportOnQueryMutation = {
  __typename?: "Mutation";
  reportOnQuery: string | null;
};

export type GetPaidChequesForStatementQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetPaidChequesForStatementQuery = {
  __typename?: "Query";
  getPaidChequesForStatement: Array<{
    __typename?: "PaidChequesForStatement";
    cheque_number: string | null;
    reinsured: string | null;
    offer_ids: Array<string | null> | null;
    payment_ids: Array<string | null> | null;
  } | null> | null;
};

export type GetBatchReportsQueryVariables = Exact<{
  filter: InputMaybe<BatchReportFilter>;
  pagination: InputMaybe<Pagination>;
}>;

export type GetBatchReportsQuery = {
  __typename?: "Query";
  count: number;
  data: Array<{
    __typename?: "Report";
    report_id: string;
    status: string;
    request_body: string | null;
    downloadable_xlsx_link: string | null;
    downloadable_pdf_link: string | null;
    created_at: any;
    updated_at: any;
    description: string | null;
    employee: {
      __typename?: "Employee";
      employee_id: string;
      employee_first_name: string;
      employee_last_name: string;
      employee_phonenumber: string;
      employee_email: string;
      emp_abbrv: string | null;
      accept_waiver_aggreement: boolean | null;
      waiver_accepted_at: string | null;
    } | null;
  }>;
};

export type FetchTargetBadgeQueryVariables = Exact<{
  target_badge_id: Scalars["ID"]["input"];
}>;

export type FetchTargetBadgeQuery = {
  __typename?: "Query";
  fetchTargetBadge: {
    __typename?: "TargetBadge";
    id: string | null;
    name: string | null;
    description: string | null;
    min_points: number | null;
    max_points: number | null;
    cash_equivalent: number | null;
    minimum_cash_equivalent: number | null;
    gift_basket: Array<{
      __typename?: "GiftBasketItem";
      gift_name: string;
      gift_type: string;
      gift_image: string | null;
      gift_description: string | null;
    } | null> | null;
  } | null;
};

export type FetchTargetRatesQueryVariables = Exact<{
  targetId: Scalars["ID"]["input"];
}>;

export type FetchTargetRatesQuery = {
  __typename?: "Query";
  fetchTargetRates: Array<{
    __typename?: "TargetRate";
    id: string;
    target_id: string;
    rate_value: number;
    currency_code: string;
    currency: string;
  } | null> | null;
};

export type FetchTargetRateQueryVariables = Exact<{
  targetRateId: Scalars["ID"]["input"];
}>;

export type FetchTargetRateQuery = {
  __typename?: "Query";
  fetchTargetRate: {
    __typename?: "Rate";
    id: string;
    rate_value: number;
    currency_code: string;
    currency: string;
  } | null;
};

export type FetchTargetsQueryVariables = Exact<{
  brokerId: Scalars["ID"]["input"];
}>;

export type FetchTargetsQuery = {
  __typename?: "Query";
  fetchTargets: Array<{
    __typename?: "Target";
    id: string | null;
    broker_id: string | null;
    target_name: string | null;
    base_currency: string | null;
    start_date: string | null;
    end_date: string | null;
    insurer_id: string | null;
    target_badges: Array<{
      __typename?: "TargetBadge";
      id: string | null;
      name: string | null;
      min_points: number | null;
      max_points: number | null;
      description: string | null;
      minimum_cash_equivalent: number | null;
      cash_equivalent: number | null;
      gift_basket: Array<{
        __typename?: "GiftBasketItem";
        gift_name: string;
        gift_type: string;
        gift_image: string | null;
        gift_description: string | null;
      } | null> | null;
    } | null> | null;
  } | null> | null;
};

export type FetchTargetQueryVariables = Exact<{
  targetId: Scalars["ID"]["input"];
}>;

export type FetchTargetQuery = {
  __typename?: "Query";
  fetchTarget: {
    __typename?: "Target";
    id: string | null;
    broker_id: string | null;
    target_name: string | null;
    base_currency: string | null;
    start_date: string | null;
    end_date: string | null;
    insurer_id: string | null;
    target_badges: Array<{
      __typename?: "TargetBadge";
      id: string | null;
      name: string | null;
      min_points: number | null;
      max_points: number | null;
      description: string | null;
      minimum_cash_equivalent: number | null;
      cash_equivalent: number | null;
      gift_basket: Array<{
        __typename?: "GiftBasketItem";
        gift_name: string;
        gift_type: string;
        gift_image: string | null;
        gift_description: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type GetTreatiesQueryVariables = Exact<{
  args: InputMaybe<TreatyFilters>;
}>;

export type GetTreatiesQuery = {
  __typename?: "Query";
  count: number | null;
  rows: Array<{
    __typename?: "Treaty";
    treaty_id: string | null;
    treaty_reference: string | null;
    kek_reference: string | null;
    treaty_details: string | null;
    currency: string | null;
    order_hereon: number | null;
    treaty_payment_status: Payment_Status | null;
    layer_limit: string | null;
    insurer: {
      __typename?: "Insurer";
      insurer_id: string;
      insurer_company_name: string;
      insurer_company_email: string;
      insurer_company_website: string | null;
      insurer_abbrv: string | null;
    } | null;
    treaty_program: {
      __typename?: "TreatyProgram";
      treaty_name: string | null;
      treaty_type: TreatyType | null;
    } | null;
    treaty_deduction: {
      __typename?: "TreatyAssociateDeduction";
      treaty_period_from: any | null;
      treaty_period_to: any | null;
    } | null;
    employee: {
      __typename?: "Employee";
      employee_first_name: string;
      employee_last_name: string;
    } | null;
  } | null> | null;
};

export type GetNonProportionalTreatyPaymentsQueryVariables = Exact<{
  filter: TreatyPaymentFilter;
}>;

export type GetNonProportionalTreatyPaymentsQuery = {
  __typename?: "Query";
  getNonProportionalTreatyPayments: Array<{
    __typename?: "TreatyNPPayment";
    uuid: string | null;
    installment_type: number | null;
    treaty_payment_amount: number | null;
    treaty_payment_details: string | null;
    treaty_payment_comment: string | null;
    created_at: any | null;
    updated_at: any | null;
    treaty_n_p_payment_id: string | null;
    distribute_payment: string | null;
  }> | null;
};

export type GetNonProportionalReceivablePaymentsQueryVariables = Exact<{
  treatyId: Scalars["ID"]["input"];
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
}>;

export type GetNonProportionalReceivablePaymentsQuery = {
  __typename?: "Query";
  count: number;
  rows: Array<{
    __typename?: "ReceivablePayment";
    receivable_payment_id: string | null;
    uuid: string | null;
    payment_amount: number | null;
    payment_detail: string | null;
    created_at: any | null;
    treaty_participant: {
      __typename?: "TreatyParticipation";
      treaty_participation_id: string | null;
      treaty_participation_percentage: number | null;
      layer_number: number | null;
    } | null;
    treaty: {
      __typename?: "Treaty";
      treaty_id: string | null;
      treaty_reference: string | null;
      kek_reference: string | null;
      treaty_details: string | null;
      currency: string | null;
      order_hereon: number | null;
      treaty_payment_status: Payment_Status | null;
      layer_limit: string | null;
    } | null;
  }>;
};

export type DistributePaymentForTreatyMutationVariables = Exact<{
  treatyId: InputMaybe<Scalars["ID"]["input"]>;
  paymentInformation: InputMaybe<
    | Array<InputMaybe<TreatyPaymentDistribution>>
    | InputMaybe<TreatyPaymentDistribution>
  >;
  treatyPaymentId: InputMaybe<Scalars["ID"]["input"]>;
  type: TreatyType;
}>;

export type DistributePaymentForTreatyMutation = {
  __typename?: "Mutation";
  distributePaymentForTreaty: boolean | null;
};

export type GetNonProportionalTreatyPaymentQueryVariables = Exact<{
  treatyNpPaymentId: Scalars["ID"]["input"];
}>;

export type GetNonProportionalTreatyPaymentQuery = {
  __typename?: "Query";
  getNonProportionalTreatyPayment: {
    __typename?: "TreatyNPPayment";
    uuid: string | null;
    installment_type: number | null;
    treaty_payment_amount: number | null;
    treaty_payment_details: string | null;
    treaty_payment_comment: string | null;
    created_at: any | null;
    updated_at: any | null;
    treaty_n_p_payment_id: string | null;
    distribute_payment: string | null;
    date_of_receipt: any | null;
    treaty_participant_payment: Array<{
      __typename?: "TreatyParticipantsPayment";
      treaty_participants_payment_id: string | null;
      participant_payment_amount: number | null;
      participant_payment_details: string | null;
      participant_payment_comment: string | null;
      participant_payment_status: Payment_Status | null;
      surpulus_uuid: string | null;
      nic_levy_paid: number | null;
      withholding_tax_paid: number | null;
      brokerage_paid: number | null;
      commission_paid: number | null;
      treaty_np_paymentstreaty_np_payment_id: string | null;
      treaty_participationstreaty_participation_id: string | null;
      treaty_p_paymentstreaty_p_payment_id: string | null;
      created_at: any | null;
      updated_at: any | null;
    } | null> | null;
  } | null;
};

export type GetProportionalTreatyPaymentsQueryVariables = Exact<{
  filter: TreatyPaymentFilter;
}>;

export type GetProportionalTreatyPaymentsQuery = {
  __typename?: "Query";
  getProportionalTreatyPayments: Array<{
    __typename?: "TreatyPPayment";
    treaty_p_payment_id: string | null;
    treaty_payment_amount: number | null;
    treaty_payment_details: string | null;
    treaty_payment_comment: string | null;
    created_at: any | null;
    updated_at: any | null;
    treaty_accountstreaty_account_id: string | null;
    surpulus_uuid: string | null;
    distribute_payment: string | null;
    treaty_accounts: {
      __typename?: "TreatyAccount";
      account_periods: TreatyAccountPeriod | null;
    } | null;
  }> | null;
};

export type GetProportionalTreatyPaymentQueryVariables = Exact<{
  treatyPaymentId: Scalars["ID"]["input"];
}>;

export type GetProportionalTreatyPaymentQuery = {
  __typename?: "Query";
  getProportionalTreatyPayment: {
    __typename?: "TreatyPPayment";
    treaty_p_payment_id: string | null;
    treaty_payment_amount: number | null;
    treaty_payment_details: string | null;
    treaty_payment_comment: string | null;
    created_at: any | null;
    updated_at: any | null;
    treaty_accountstreaty_account_id: string | null;
    surpulus_uuid: string | null;
    distribute_payment: string | null;
    date_of_receipt: any | null;
    treaty_participant_payment: Array<{
      __typename?: "TreatyParticipantsPayment";
      treaty_participants_payment_id: string | null;
      participant_payment_amount: number | null;
      participant_payment_details: string | null;
      participant_payment_comment: string | null;
      participant_payment_status: Payment_Status | null;
      surpulus_uuid: string | null;
      nic_levy_paid: number | null;
      withholding_tax_paid: number | null;
      brokerage_paid: number | null;
      commission_paid: number | null;
      treaty_np_paymentstreaty_np_payment_id: string | null;
      treaty_participationstreaty_participation_id: string | null;
      treaty_p_paymentstreaty_p_payment_id: string | null;
      created_at: any | null;
      updated_at: any | null;
    } | null> | null;
  } | null;
};

export type TreatyYearsQueryVariables = Exact<{
  insurerId: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type TreatyYearsQuery = {
  __typename?: "Query";
  treatyYears: Array<string | null> | null;
};

export type TreatyQueryVariables = Exact<{
  treatyId: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type TreatyQuery = {
  __typename?: "Query";
  treaty: {
    __typename?: "Treaty";
    treaty_id: string | null;
    treaty_reference: string | null;
    kek_reference: string | null;
    treaty_details: string | null;
    currency: string | null;
    order_hereon: number | null;
    treaty_payment_status: Payment_Status | null;
    layer_limit: string | null;
    insurer: {
      __typename?: "Insurer";
      insurer_company_name: string;
      insurer_id: string;
      insurer_abbrv: string | null;
    } | null;
    treaty_program: {
      __typename?: "TreatyProgram";
      treaty_name: string | null;
      treaty_program_id: string | null;
      treaty_type: TreatyType | null;
    } | null;
    treaty_deduction: {
      __typename?: "TreatyAssociateDeduction";
      treaty_associate_deduction_id: string | null;
      commission: number | null;
      brokerage: number | null;
      nic_levy: number | null;
      withholding_tax: number | null;
      treaty_period_from: any | null;
      treaty_period_to: any | null;
    } | null;
    treaty_to_associates: Array<{
      __typename?: "TreatyToAssociate";
      treaty_to_associate_id: string | null;
      sent_status: Sent_Status | null;
      layer_number: number | null;
      reinsurer_representative: {
        __typename?: "Reinsurer_representative";
        rep_first_name: string;
        rep_last_name: string;
        rep_primary_phonenumber: string;
        rep_secondary_phonenumber: string | null;
        rep_email: string;
        position: string;
      } | null;
    } | null> | null;
    treaty_participants: Array<{
      __typename?: "TreatyParticipation";
      treaty_participation_id: string | null;
      treaty_participation_percentage: number | null;
      layer_number: number | null;
      reinsurer: {
        __typename?: "Reinsurer";
        re_company_email: string;
        re_company_name: string;
        reinsurer_id: string | null;
        re_abbrv: string | null;
      } | null;
      treaty_participant_deductions: Array<{
        __typename?: "TreatyParticipantDeduction";
        treaty_participant_deduction_id: string | null;
        treaty_accountstreaty_account_id: string | null;
        treaty_participationstreaty_participation_id: string | null;
        uuid: string | null;
        brokerage: number | null;
        brokerage_amount: number | null;
        commission_amount: number | null;
        nic_levy_amount: number | null;
        withholding_tax_amount: number | null;
        treaty_participation_share: number | null;
        nic_levy: number | null;
        withholding_tax: number | null;
        commission: number | null;
      } | null> | null;
    } | null> | null;
    re_broker_treaties_participation: Array<{
      __typename?: "ReBrokerTreatiesParticipation";
      re_broker_treaties_participation_id: string | null;
      share_percentage: number | null;
      admin_percentage: number | null;
      payment_status: Payment_Status | null;
      re_broker: {
        __typename?: "ReBroker";
        re_broker_id: string | null;
        re_broker_email: string | null;
        re_broker_name: string | null;
        re_broker_website: string | null;
      } | null;
    } | null> | null;
    treaty_accounts: Array<{
      __typename?: "TreatyAccount";
      treaty_account_id: string | null;
      account_periods: TreatyAccountPeriod | null;
      gross_premium: number | null;
      claim_settled: number | null;
      cash_loss: number | null;
      exchange_rate: string | null;
      account_year: string | null;
      payment_status: Payment_Status | null;
      treaty_account_deduction: Array<{
        __typename?: "TreatyAccountDeduction";
        treaty_account_deduction_id: string | null;
        surpulus_uuid: string | null;
        gross_premium: number | null;
        commission_amount: number | null;
        brokerage_amount: number | null;
        claim_settled: number | null;
        cash_loss: number | null;
        withholding_tax_amount: number | null;
        nic_levy_amount: number | null;
      } | null> | null;
    } | null> | null;
    treaty_np_detail: {
      __typename?: "TreatyNPDetail";
      treaty_np_id: string | null;
      egrnpi: number | null;
      burning_cost_rate: number | null;
      loaded_burning_cost: number | null;
      pure_burning_cost: number | null;
      adjustment_created: boolean | null;
      outstanding_payment: number | null;
      claims_paid: number | null;
      created_at: any | null;
    } | null;
    treaty_proportional_detail: {
      __typename?: "TreatyProportionalDetail";
      treaty_proportional_detail_id: string | null;
      profit_commission: number | null;
      re_mgmt_expense: number | null;
      portfolio_entry: string | null;
      ernpi: number | null;
      overall_gross_premium: number | null;
      losses_outstanding: number | null;
      created_at: any | null;
      prev_year_configuration: string | null;
      portfolio_entry_compute: string | null;
    } | null;
  } | null;
};

export type GetTreatyEndorsementQueryVariables = Exact<{
  filter: TreatyEndorsementFilter;
}>;

export type GetTreatyEndorsementQuery = {
  __typename?: "Query";
  getTreatyEndorsement: {
    __typename?: "TreatyEndorsement";
    treaty_endorsement_id: string;
    treatiestreaty_id: string;
    endorsement_comment: string | null;
    employeesemployee_id: string;
  } | null;
};

export type GetTreatyEndorsementsQueryVariables = Exact<{
  filter: InputMaybe<TreatyEndorsementFilter>;
}>;

export type GetTreatyEndorsementsQuery = {
  __typename?: "Query";
  getTreatyEndorsements: Array<{
    __typename?: "TreatyEndorsement";
    treaty_endorsement_id: string;
    treatiestreaty_id: string;
    endorsement_comment: string | null;
    employeesemployee_id: string;
    employee: {
      __typename?: "Employee";
      employee_first_name: string;
      employee_last_name: string;
    };
  } | null> | null;
};

export type GetTreatyBrokersParticipantsQueryVariables = Exact<{
  treatyId: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetTreatyBrokersParticipantsQuery = {
  __typename?: "Query";
  getTreatyBrokersParticipants: Array<{
    __typename?: "ReBrokerTreatiesParticipation";
    re_broker_treaties_participation_id: string | null;
    share_percentage: number | null;
    admin_percentage: number | null;
    payment_status: Payment_Status | null;
    re_broker: {
      __typename?: "ReBroker";
      re_broker_id: string | null;
      re_broker_name: string | null;
      re_broker_email: string | null;
      re_broker_website: string | null;
    } | null;
  } | null> | null;
};

export type GetTreatyReinsurerParticipantsQueryVariables = Exact<{
  treatyId: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetTreatyReinsurerParticipantsQuery = {
  __typename?: "Query";
  getTreatyReinsurerParticipants: Array<{
    __typename?: "TreatyParticipation";
    treaty_participation_id: string | null;
    treaty_participation_percentage: number | null;
    layer_number: number | null;
    reinsurer: {
      __typename?: "Reinsurer";
      re_company_email: string;
      re_abbrv: string | null;
      re_company_name: string;
      re_company_website: string | null;
      reinsurer_id: string | null;
    } | null;
    treaty_participant_deductions: Array<{
      __typename?: "TreatyParticipantDeduction";
      treaty_participant_deduction_id: string | null;
      treaty_accountstreaty_account_id: string | null;
      treaty_participationstreaty_participation_id: string | null;
      uuid: string | null;
      brokerage: number | null;
      brokerage_amount: number | null;
      commission_amount: number | null;
      nic_levy_amount: number | null;
      withholding_tax_amount: number | null;
      treaty_participation_share: number | null;
      nic_levy: number | null;
      withholding_tax: number | null;
      commission: number | null;
    } | null> | null;
  } | null> | null;
};

export type GetTreatyReinsurerAssociatesQueryVariables = Exact<{
  treatyId: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetTreatyReinsurerAssociatesQuery = {
  __typename?: "Query";
  getTreatyReinsurerAssociates: Array<{
    __typename?: "TreatyToAssociate";
    treaty_to_associate_id: string | null;
    sent_status: Sent_Status | null;
    layer_number: number | null;
    reinsurer_representative: {
      __typename?: "Reinsurer_representative";
      reinsurer_representative_id: string | null;
      reinsurersreinsurer_id: string;
      rep_first_name: string;
      rep_last_name: string;
      rep_primary_phonenumber: string;
      rep_secondary_phonenumber: string | null;
      rep_email: string;
      position: string;
    } | null;
    reinsurer: {
      __typename?: "Reinsurer";
      re_company_name: string;
      re_company_email: string;
    } | null;
  } | null> | null;
};

export type GetTreatyReinsurerParticipationQueryVariables = Exact<{
  participationId: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetTreatyReinsurerParticipationQuery = {
  __typename?: "Query";
  getTreatyReinsurerParticipation: {
    __typename?: "TreatyParticipation";
    treaty_participation_id: string | null;
    treaty_participation_percentage: number | null;
    layer_number: number | null;
    reinsurer: {
      __typename?: "Reinsurer";
      re_company_name: string;
      reinsurer_id: string | null;
    } | null;
  } | null;
};

export type GetTreatyBrokerParticipationQueryVariables = Exact<{
  reBrokerTreatiesParticipationId: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetTreatyBrokerParticipationQuery = {
  __typename?: "Query";
  getTreatyBrokerParticipation: {
    __typename?: "ReBrokerTreatiesParticipation";
    re_broker_treaties_participation_id: string | null;
    share_percentage: number | null;
    admin_percentage: number | null;
    payment_status: Payment_Status | null;
    re_broker: {
      __typename?: "ReBroker";
      re_broker_name: string | null;
      re_broker_id: string | null;
    } | null;
  } | null;
};

export type GetTreatyBrokerAssociatesQueryVariables = Exact<{
  treatyId: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetTreatyBrokerAssociatesQuery = {
  __typename?: "Query";
  getTreatyBrokerAssociates: Array<{
    __typename?: "TreatyParticipationToBrokerAssociates";
    participation_to_broker_associate_id: string | null;
    sent_status: Sent_Status | null;
    message_content: string | null;
    broker_associate: {
      __typename?: "ReBrokerAssociate";
      re_broker_associate_id: string | null;
      re_broker_assoc_first_name: string | null;
      re_broker_assoc_last_name: string | null;
      re_broker_assoc_primary_phone: string | null;
      re_broker_assoc_secondary_phone: string | null;
      re_broker_assoc_position: string | null;
      re_broker_assoc_email: string | null;
    } | null;
  } | null> | null;
};

export type FetchTreatyAccountsQueryVariables = Exact<{
  insurer_id: InputMaybe<Scalars["ID"]["input"]>;
  treaty_program_name: InputMaybe<Scalars["String"]["input"]>;
  treaty_period_from: InputMaybe<Scalars["Date"]["input"]>;
  treaty_period_to: InputMaybe<Scalars["Date"]["input"]>;
  type: InputMaybe<Scalars["Boolean"]["input"]>;
  quarter: InputMaybe<Scalars["String"]["input"]>;
}>;

export type FetchTreatyAccountsQuery = {
  __typename?: "Query";
  fetchTreatyAccounts: Array<{
    __typename?: "AccountResponse";
    treaty_id: string | null;
    currency: string | null;
    quarters: Array<string | null> | null;
    quarter: string | null;
    account_year: string | null;
    layer_limit: string | null;
    surpluses: Array<{
      __typename?: "AccountResponseDepth";
      gross_premium: number | null;
      claim_settled: number | null;
      cash_loss: number | null;
    } | null> | null;
  } | null> | null;
};

export type GetTreatyClaimPaymentsQueryVariables = Exact<{
  treatyClaimId: Scalars["ID"]["input"];
  participantId: Scalars["ID"]["input"];
}>;

export type GetTreatyClaimPaymentsQuery = {
  __typename?: "Query";
  getTreatyClaimPayments: Array<{
    __typename?: "ClaimPayment";
    treaty_claim_id: string;
    participant_id: string;
    reinsurer: string;
    payment_uuid: string;
    payment_amount: number;
    payment_detail: string | null;
    currency: string;
    created_at: string;
    payment_id: string;
    participant: {
      __typename?: "ParticipantInfo";
      id: string;
      percentage: number;
      layer_number: number;
    };
  } | null> | null;
};

export type GetTreatyClaimsQueryVariables = Exact<{
  treatyId: InputMaybe<Scalars["ID"]["input"]>;
  insurerId: InputMaybe<Scalars["ID"]["input"]>;
  limit: InputMaybe<Scalars["Int"]["input"]>;
  offset: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetTreatyClaimsQuery = {
  __typename?: "Query";
  getTreatyClaimsCount: number | null;
  getTreatyClaims: Array<{
    __typename?: "TreatyClaim";
    treaty_claim_id: string | null;
    policy_number: string | null;
    claim_number: string | null;
    insured_name: string | null;
    date_of_loss: any | null;
    claim_date: any | null;
    claim_paid: number | null;
    layer_number: number | null;
    expected_deductible: number | null;
    treaty_comment: string | null;
    treaty_claim_details: string | null;
    reinstatement_premium: number | null;
    treaty: {
      __typename?: "Treaty";
      treaty_id: string | null;
      treaty_reference: string | null;
      kek_reference: string | null;
      treaty_details: string | null;
      currency: string | null;
      order_hereon: number | null;
      treaty_payment_status: Payment_Status | null;
      layer_limit: string | null;
      insurer: { __typename?: "Insurer"; insurer_company_name: string } | null;
      treaty_participants: Array<{
        __typename?: "TreatyParticipation";
        treaty_participation_id: string | null;
        treaty_participation_percentage: number | null;
        layer_number: number | null;
        reinsurer: {
          __typename?: "Reinsurer";
          re_company_email: string;
          re_abbrv: string | null;
          re_company_name: string;
        } | null;
      } | null> | null;
      treaty_program: {
        __typename?: "TreatyProgram";
        treaty_name: string | null;
      } | null;
    } | null;
  } | null> | null;
};

export type GetTreatyClaimQueryVariables = Exact<{
  treatyClaimId: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetTreatyClaimQuery = {
  __typename?: "Query";
  getTreatyClaim: {
    __typename?: "TreatyClaim";
    treaty_claim_id: string | null;
    policy_number: string | null;
    claim_number: string | null;
    insured_name: string | null;
    date_of_loss: any | null;
    claim_date: any | null;
    claim_paid: number | null;
    layer_number: number | null;
    expected_deductible: number | null;
    treaty_comment: string | null;
    treaty_claim_details: string | null;
    reinstatement_premium: number | null;
    treaty: {
      __typename?: "Treaty";
      treaty_id: string | null;
      treaty_reference: string | null;
      kek_reference: string | null;
      treaty_details: string | null;
      currency: string | null;
      order_hereon: number | null;
      treaty_payment_status: Payment_Status | null;
      layer_limit: string | null;
      treaty_program: {
        __typename?: "TreatyProgram";
        treaty_name: string | null;
        treaty_type: TreatyType | null;
        treaty_details: string | null;
        insurer: {
          __typename?: "Insurer";
          insurer_company_name: string;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type GetTreatyClaimSharesQueryVariables = Exact<{
  treatyClaimId: Scalars["ID"]["input"];
}>;

export type GetTreatyClaimSharesQuery = {
  __typename?: "Query";
  getTreatyClaimShares: Array<{
    __typename?: "ClaimShare";
    treaty_claim_id: string | null;
    participant_id: string | null;
    reinsurer: string | null;
    percentage: number | null;
    claim_paid: number | null;
    claim_payment_share: number | null;
  } | null> | null;
};

export type GetTreatyClaimShareQueryVariables = Exact<{
  treatyClaimId: Scalars["ID"]["input"];
  participantId: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetTreatyClaimShareQuery = {
  __typename?: "Query";
  getTreatyClaimShare: {
    __typename?: "ClaimShare";
    treaty_claim_id: string | null;
    participant_id: string | null;
    reinsurer: string | null;
    percentage: number | null;
    claim_paid: number | null;
    claim_payment_share: number | null;
  } | null;
};

export type TreatyProgramsQueryVariables = Exact<{
  args: InputMaybe<TreatyProgramFilters>;
}>;

export type TreatyProgramsQuery = {
  __typename?: "Query";
  count: number | null;
  rows: Array<{
    __typename?: "TreatyProgram";
    treaty_program_id: string | null;
    treaty_name: string | null;
    treaty_details: string | null;
    treaty_type: TreatyType | null;
    insurer: {
      __typename?: "Insurer";
      insurer_abbrv: string | null;
      insurer_company_email: string;
      insurer_company_name: string;
      insurer_id: string;
    } | null;
    treaty_associate_deductions: Array<{
      __typename?: "TreatyAssociateDeduction";
      treaty_associate_deduction_id: string | null;
      commission: number | null;
      brokerage: number | null;
      nic_levy: number | null;
      withholding_tax: number | null;
      treaty_period_from: any | null;
      treaty_period_to: any | null;
    } | null> | null;
  } | null> | null;
};

export type TreatyProgramQueryVariables = Exact<{
  programId: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type TreatyProgramQuery = {
  __typename?: "Query";
  treatyProgram: {
    __typename?: "TreatyProgram";
    treaty_program_id: string | null;
    treaty_name: string | null;
    treaty_details: string | null;
    treaty_type: TreatyType | null;
    insurer: {
      __typename?: "Insurer";
      insurer_abbrv: string | null;
      insurer_company_email: string;
      insurer_company_name: string;
      insurer_id: string;
    } | null;
    treaty_associate_deductions: Array<{
      __typename?: "TreatyAssociateDeduction";
      treaty_associate_deduction_id: string | null;
      commission: number | null;
      brokerage: number | null;
      nic_levy: number | null;
      withholding_tax: number | null;
      treaty_period_from: any | null;
      treaty_period_to: any | null;
    } | null> | null;
  } | null;
};

export type GetTreatyProgramDeductionsQueryVariables = Exact<{
  treatyProgramId: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetTreatyProgramDeductionsQuery = {
  __typename?: "Query";
  getTreatyProgramDeductions: Array<{
    __typename?: "TreatyAssociateDeduction";
    treaty_associate_deduction_id: string | null;
    commission: number | null;
    brokerage: number | null;
    nic_levy: number | null;
    withholding_tax: number | null;
    treaty_period_from: any | null;
    treaty_period_to: any | null;
  } | null> | null;
};

export type GetTreatyProgramDeductionQueryVariables = Exact<{
  treatyAssociateDeductionId: Scalars["ID"]["input"];
}>;

export type GetTreatyProgramDeductionQuery = {
  __typename?: "Query";
  getTreatyProgramDeduction: {
    __typename?: "TreatyAssociateDeduction";
    treaty_associate_deduction_id: string | null;
    commission: number | null;
    brokerage: number | null;
    nic_levy: number | null;
    withholding_tax: number | null;
    treaty_period_from: any | null;
    treaty_period_to: any | null;
    treaty_program: {
      __typename?: "TreatyProgram";
      treaty_program_id: string | null;
      treaty_details: string | null;
      treaty_name: string | null;
      treaty_type: TreatyType | null;
    } | null;
  } | null;
};

export type GetUnReadNotificationMessagesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetUnReadNotificationMessagesQuery = {
  __typename?: "Query";
  getUnReadNotificationMessages: Array<{
    __typename?: "Offer";
    offer_status: Offer_Status;
    payment_status: Payment_Status;
    offer_detail: {
      __typename?: "Offer_details";
      policy_number: string | null;
      insured_by: string;
      period_of_insurance_from: any | null;
      period_of_insurance_to: any | null;
    } | null;
    thread_notification: Array<{
      __typename?: "ThreadNotification";
      id: string | null;
      status: string | null;
    } | null> | null;
    insurer: {
      __typename?: "Insurer";
      insurer_company_name: string;
      insurer_id: string;
    } | null;
    classofbusiness: {
      __typename?: "Class_of_business";
      business_name: string;
    } | null;
  } | null> | null;
};

export type FetchUnreadTransactionThreadMessagesForBrokerQueryVariables =
  Exact<{ [key: string]: never }>;

export type FetchUnreadTransactionThreadMessagesForBrokerQuery = {
  __typename?: "Query";
  fetchUnreadTransactionThreadMessagesForBroker: Array<{
    __typename?: "TransactionThread";
    status: string | null;
    receiver_type: string | null;
    offer: {
      __typename?: "Offer";
      offer_id: string;
      rate: number;
      commission: number;
      commission_amount: number | null;
      brokerage: number;
      facultative_offer: number;
      sum_insured: number;
      fac_sum_insured: number;
      premium: number;
      fac_premium: number;
      offer_status: Offer_Status;
      payment_status: Payment_Status;
      claim_status: Claim_Status;
      expiry_status: Expiry_Status;
      created_at: any;
      updated_at: any;
      offer_from: string | null;
      place_it_id: string | null;
      offer_detail: {
        __typename?: "Offer_details";
        offer_detail_id: string;
        offersoffer_id: string;
        policy_number: string | null;
        insured_by: string;
        period_of_insurance_from: any | null;
        period_of_insurance_to: any | null;
        currency: string;
        offer_comment: string | null;
        offer_details: string | null;
        updated_at: any;
      } | null;
      thread_notification: Array<{
        __typename?: "ThreadNotification";
        id: string | null;
        status: string | null;
      } | null> | null;
      classofbusiness: {
        __typename?: "Class_of_business";
        class_of_business_id: string;
        business_name: string;
        business_details: string;
        business_category: string | null;
        single_total_overview: string | null;
        single_total_offers: number | null;
        created_at: any;
      } | null;
      insurer: {
        __typename?: "Insurer";
        insurer_id: string;
        insurer_company_name: string;
        insurer_company_email: string;
        insurer_company_website: string | null;
        insurer_abbrv: string | null;
      } | null;
    } | null;
  } | null> | null;
};

export const GetAutoFacConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAutoFacConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAutoFacConfigCount" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "getAutoFacConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee_first_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee_last_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee_email" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "emp_abbrv" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "auto_fac_config_id" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAutoFacConfigQuery,
  GetAutoFacConfigQueryVariables
>;
export const GetAutoFacParticipantsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAutoFacParticipants" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "autoFacConfigId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAutoFacParticipants" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "auto_fac_config_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "autoFacConfigId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "share_percentage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinsurer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_company_email" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_abbrv" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_company_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_company_website" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reinsurer_id" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "emp_abbrv" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee_email" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee_first_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee_last_name" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "auto_fac_participant_id" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAutoFacParticipantsQuery,
  GetAutoFacParticipantsQueryVariables
>;
export const GetAutoFacParticipantDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAutoFacParticipant" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "autoFacParticipantId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAutoFacParticipant" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "auto_fac_participant_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "autoFacParticipantId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "share_percentage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "auto_fac_participant_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinsurer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reinsurer_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_company_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_company_email" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_company_website" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_abbrv" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reinsurer_address" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "reinsurer_address_id",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "street" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "suburb" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "region" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "country" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "auto_fac_config" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "auto_fac_config_id" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "auto_fac_deduction" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "brokerage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "commission" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "wht" } },
                      { kind: "Field", name: { kind: "Name", value: "nic" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "overrider" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAutoFacParticipantQuery,
  GetAutoFacParticipantQueryVariables
>;
export const GetAutoFacConfigurationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAutoFacConfiguration" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "autoFacConfigurationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAutoFacConfiguration" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "auto_fac_configuration_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "autoFacConfigurationId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee_first_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee_last_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee_phonenumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee_email" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "emp_abbrv" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "auto_fac_participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "share_percentage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reinsurer" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reinsurer_id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "re_company_name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "re_company_email" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "re_company_website",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "re_abbrv" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "employee_first_name",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "employee_last_name",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAutoFacConfigurationQuery,
  GetAutoFacConfigurationQueryVariables
>;
export const BrokersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Brokers" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "brokers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "re_broker_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "re_broker_name" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "re_broker_email" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "re_broker_website" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "re_broker_address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_broker_address_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "street" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "region" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_primary_phone" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_secondary_phone" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "re_broker_associates" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_broker_associate_id" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "re_broker_assoc_first_name",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "re_broker_assoc_last_name",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "re_broker_assoc_primary_phone",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "re_broker_assoc_secondary_phone",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "re_broker_assoc_position",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_broker_assoc_email" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_broker" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "re_broker_id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "re_broker_name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BrokersQuery, BrokersQueryVariables>;
export const BrokerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Broker" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "brokerId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "broker" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "broker_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "brokerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "re_broker_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "re_broker_name" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "re_broker_email" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "re_broker_website" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "broker_overview" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_treaties" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_proportional" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_nonproportional" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_unpaid_treaties" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_paid_treaties" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "total_partpayment_treaties",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "brokerage_chart" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_brokerage_amt" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "re_broker_address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_broker_address_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "street" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "region" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_primary_phone" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_secondary_phone" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BrokerQuery, BrokerQueryVariables>;
export const GetBrokerAssociatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetBrokerAssociates" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "brokerId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getBrokerAssociates" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "broker_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "brokerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "re_broker_associate_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "re_broker_assoc_first_name" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "re_broker_assoc_last_name" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "re_broker_assoc_primary_phone",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "re_broker_assoc_secondary_phone",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "re_broker_assoc_position" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "re_broker_assoc_email" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetBrokerAssociatesQuery,
  GetBrokerAssociatesQueryVariables
>;
export const GetBrokerAssociateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetBrokerAssociate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "brokerAssociateId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getBrokerAssociate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "broker_associate_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "brokerAssociateId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "re_broker_associate_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "re_broker_assoc_first_name" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "re_broker_assoc_last_name" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "re_broker_assoc_primary_phone",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "re_broker_assoc_secondary_phone",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "re_broker_assoc_position" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "re_broker_assoc_email" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetBrokerAssociateQuery,
  GetBrokerAssociateQueryVariables
>;
export const ClassOfBusinessesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ClassOfBusinesses" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "category" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "rows" },
            name: { kind: "Name", value: "classOfBusinesses" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "category" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "category" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "class_of_business_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "business_name" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "business_details" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "business_category" },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "count" },
            name: { kind: "Name", value: "getClassOfBusinessCount" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ClassOfBusinessesQuery,
  ClassOfBusinessesQueryVariables
>;
export const GetBusinessCategoriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetBusinessCategories" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getBusinessCategories" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetBusinessCategoriesQuery,
  GetBusinessCategoriesQueryVariables
>;
export const SingleClassOfBusinessDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SingleClassOfBusiness" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "classOfBusinessId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "singleClassOfBusiness" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "class_of_business_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "classOfBusinessId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "class_of_business_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "business_name" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "business_details" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "business_category" },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SingleClassOfBusinessQuery,
  SingleClassOfBusinessQueryVariables
>;
export const GetDashboardOverviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDashboardOverview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dashboardInput" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "DashboardOverviewInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getDashboardOverview" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "dashboardInput" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "dashboardInput" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "total_offers" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "total_pending_offers" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "total_open_offers" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "total_closed_offers" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "total_claim_offers" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "total_brokers" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "total_reinsurers" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "total_insurers" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "brokerage_earnings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_dollar" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_pounds" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_euros" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_cedis" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "total_fac_premium" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_dollar" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_pounds" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_euros" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_cedis" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "total_fac_sum_insured" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_dollar" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_pounds" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_euros" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_cedis" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "total_premium" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_dollar" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_pounds" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_euros" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_cedis" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "total_sum_insured" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_dollar" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_pounds" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_euros" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_cedis" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "total_unclaim_offers" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetDashboardOverviewQuery,
  GetDashboardOverviewQueryVariables
>;
export const EmployeesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Employees" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "rows" },
            name: { kind: "Name", value: "employees" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "employee_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employee_first_name" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employee_last_name" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employee_phonenumber" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employee_email" },
                },
                { kind: "Field", name: { kind: "Name", value: "emp_abbrv" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "position" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "count" },
            name: { kind: "Name", value: "getEmployeesCount" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EmployeesQuery, EmployeesQueryVariables>;
export const EmployeeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Employee" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "employeeId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "employee" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "employee_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "employeeId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "employee_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employee_first_name" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employee_last_name" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employee_phonenumber" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employee_email" },
                },
                { kind: "Field", name: { kind: "Name", value: "emp_abbrv" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "position" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EmployeeQuery, EmployeeQueryVariables>;
export const GetEndorsementsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEndorsements" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "args" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EndorsementFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "count" },
            name: { kind: "Name", value: "getEndorsementsCount" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "args" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "args" },
                },
              },
            ],
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "rows" },
            name: { kind: "Name", value: "getEndorsements" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "args" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "args" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rate" } },
                { kind: "Field", name: { kind: "Name", value: "commission" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "commission_amount" },
                },
                { kind: "Field", name: { kind: "Name", value: "brokerage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facultative_offer" },
                },
                { kind: "Field", name: { kind: "Name", value: "sum_insured" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fac_sum_insured" },
                },
                { kind: "Field", name: { kind: "Name", value: "premium" } },
                { kind: "Field", name: { kind: "Name", value: "fac_premium" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_id" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "insurer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_company_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_company_email" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "insurer_company_website",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_address" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "suburb" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "region" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "country" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classofbusiness" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "class_of_business_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "business_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "business_details" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "created_at" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_endorsement_detail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "offer_endorsement_detail_id",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "policy_number" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insured_by" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "period_of_insurance_to" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "period_of_insurance_from",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currency" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_comment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "information_comment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_detail" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "offer_endorsement_participants",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "offer_end_participant_id",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "offer_end_participant_percentage",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_end_amount" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "offer_end_participant_fac_premium",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "offer_end_participant_fac_sum_insured",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "offer_endorsement_extra_charges",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "end_nic_levy" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "end_nic_levy_amount",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "end_withholding_tax",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "end_agreed_brokerage_percentage",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "end_brokerage_amount",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "end_withholding_tax_amount",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "end_agreed_commission",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "end_agreed_commission_amount",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reinsurer" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reinsurer_id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "re_company_name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "re_company_email" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "re_company_website",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "re_abbrv" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "approval_status" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "co_insurance_share" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "endorsement_status" },
                },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_endorsement_id" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetEndorsementsQuery,
  GetEndorsementsQueryVariables
>;
export const GetEndorsementDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEndorsement" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offerEndorsementId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "singleEndorsement" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "offer_endorsement_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offerEndorsementId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rate" } },
                { kind: "Field", name: { kind: "Name", value: "commission" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "commission_amount" },
                },
                { kind: "Field", name: { kind: "Name", value: "brokerage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facultative_offer" },
                },
                { kind: "Field", name: { kind: "Name", value: "sum_insured" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fac_sum_insured" },
                },
                { kind: "Field", name: { kind: "Name", value: "premium" } },
                { kind: "Field", name: { kind: "Name", value: "fac_premium" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_id" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "rate" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "commission" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "commission_amount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "brokerage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "facultative_offer" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sum_insured" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fac_sum_insured" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "premium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fac_premium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "payment_status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "claim_status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_detail" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "offer_detail_id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "offersoffer_id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "policy_number" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "insured_by" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "period_of_insurance_to",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "period_of_insurance_from",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "currency" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "offer_comment" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "offer_details" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "insurer_id" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "insurer_company_name",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "insurer_company_email",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "insurer_company_website",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "insurer_address" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "suburb" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "region" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "country" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "classofbusiness" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "class_of_business_id",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "business_name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "business_details" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "created_at" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "created_at" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "insurer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_company_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_company_email" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "insurer_company_website",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_address" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "suburb" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "region" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "country" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classofbusiness" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "class_of_business_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "business_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "business_details" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "created_at" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_endorsement_detail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "offer_endorsement_detail_id",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "policy_number" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insured_by" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "period_of_insurance_to" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "period_of_insurance_from",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currency" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_comment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "information_comment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_detail" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "offer_endorsement_participants",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "offer_end_participant_id",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "offer_end_participant_percentage",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_end_amount" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "offer_end_participant_fac_premium",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "offer_end_participant_fac_sum_insured",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "offer_endorsement_extra_charges",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "end_nic_levy" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "end_nic_levy_amount",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "end_withholding_tax",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "end_agreed_brokerage_percentage",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "end_brokerage_amount",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "end_withholding_tax_amount",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "end_agreed_commission",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "end_agreed_commission_amount",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reinsurer" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reinsurer_id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "re_company_name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "re_company_email" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "re_company_website",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "re_abbrv" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "approval_status" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "co_insurance_share" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "endorsement_status" },
                },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_endorsement_id" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetEndorsementQuery, GetEndorsementQueryVariables>;
export const InsurersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Insurers" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "count" },
            name: { kind: "Name", value: "getInsurersCount" },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "rows" },
            name: { kind: "Name", value: "insurers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "insurer_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "insurer_company_name" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "insurer_company_email" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "insurer_company_website" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "insurer_abbrv" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "insurer_address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_address_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "region" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "street" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "suburb" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "remainders" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "remainder_id" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InsurersQuery, InsurersQueryVariables>;
export const InsurerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Insurer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "insurerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insurer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "insurer_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "insurerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "insurer_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "insurer_company_name" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "insurer_company_email" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "insurer_company_website" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "insurer_abbrv" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "insurer_overview" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_brokerage_amt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_closed" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_fac_premium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_nic_tax" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_paid" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_pending" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_unpaid" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_withholding_tax" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaties_overview" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "total_brokerage_amt",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "total_nonproportional",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "total_paid_treaties",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "total_partpayment_treaties",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "total_proportional",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "total_treaties" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "total_unpaid_treaties",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "total_treaty_recoveries_due",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_fac_nic_levy" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "total_fac_recoveries_due",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "total_outstanding_fac_premium",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "insurer_address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_address_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "region" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "street" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "suburb" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InsurerQuery, InsurerQueryVariables>;
export const GetInsurerAssociatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetInsurerAssociates" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "insurerId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getInsurerAssociates" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "insurer_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "insurerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "insurer_associate_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assoc_first_name" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assoc_last_name" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assoc_primary_phonenumber" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assoc_secondary_phonenumber" },
                },
                { kind: "Field", name: { kind: "Name", value: "assoc_email" } },
                { kind: "Field", name: { kind: "Name", value: "position" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetInsurerAssociatesQuery,
  GetInsurerAssociatesQueryVariables
>;
export const GetInsurerAssociateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetInsurerAssociate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "insurerAssociateId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getInsurerAssociate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "insurer_associate_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "insurerAssociateId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "insurer_associate_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assoc_first_name" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assoc_last_name" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assoc_primary_phonenumber" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assoc_secondary_phonenumber" },
                },
                { kind: "Field", name: { kind: "Name", value: "assoc_email" } },
                { kind: "Field", name: { kind: "Name", value: "position" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetInsurerAssociateQuery,
  GetInsurerAssociateQueryVariables
>;
export const FetchLeaderboardStatisticsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FetchLeaderboardStatistics" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "brokerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startDate" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "endDate" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "badge" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "year" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fetchTotalCashAccumulated" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "year" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "year" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "total_cash_accumulated" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fetchLeaderboardStatistics" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "broker_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "brokerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "start_date" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "end_date" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "endDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "badge" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "badge" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "badges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurers" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "insurer_id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "insurer_name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "total_points" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "total_redeemable_points",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "total_redeemable_cash_equivalent",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "target" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "broker_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "target_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "base_currency" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "start_date" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "end_date" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "target_badges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "min_points" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "max_points" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "minimum_cash_equivalent",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "cash_equivalent" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "gift_basket" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "gift_name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "gift_type" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "gift_image" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "gift_description",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchLeaderboardStatisticsQuery,
  FetchLeaderboardStatisticsQueryVariables
>;
export const GetNotificationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetNotifications" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "NotificationFilter" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pagination" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "Pagination" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getNotifications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filter" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "pagination" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employee_notification_id" },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "system_notification" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "system_notification_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "notification_type" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "notification_content" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "created_at" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "getNotificationsCount" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filter" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetNotificationsQuery,
  GetNotificationsQueryVariables
>;
export const OffersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Offers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "args" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "OfferFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "count" },
            name: { kind: "Name", value: "getOffersCount" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "args" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "args" },
                },
              },
            ],
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "rows" },
            name: { kind: "Name", value: "getOffers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "args" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "args" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "offer_id" } },
                { kind: "Field", name: { kind: "Name", value: "rate" } },
                { kind: "Field", name: { kind: "Name", value: "commission" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "commission_amount" },
                },
                { kind: "Field", name: { kind: "Name", value: "brokerage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facultative_offer" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expiry_status" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "distribute_status" },
                },
                { kind: "Field", name: { kind: "Name", value: "sum_insured" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fac_sum_insured" },
                },
                { kind: "Field", name: { kind: "Name", value: "offer_from" } },
                { kind: "Field", name: { kind: "Name", value: "premium" } },
                { kind: "Field", name: { kind: "Name", value: "fac_premium" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_status" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_published" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "published_status" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "payment_status" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "claim_status" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_detail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_detail_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offersoffer_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "policy_number" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insured_by" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "period_of_insurance_to" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "period_of_insurance_from",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currency" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_comment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_details" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_claims" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_claim_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "claim_amount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "claim_comment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "claim_date" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "created_at" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "offer_claim_participants",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "offer_claimsoffer_claim_id",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "offer_claim_participant_id",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reinsurer_id" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "offer_participantsoffer_participant_id",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "offer_participant_percentage",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "re_company_name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "claim_share" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "created_at" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_participant" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_participant_id" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "offer_participant_percentage",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_amount" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "participant_fac_premium",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "participant_fac_sum_insured",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_extra_charges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "nic_levy" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "agreed_brokerage_percentage",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "withholding_tax" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "agreed_commission",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "agreed_commission_amount",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "brokerage_amount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "nic_levy_amount" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "withholding_tax_amount",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_deduction_charge" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "nic_levy_paid" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "withholding_tax_paid",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "brokerage_amount_paid",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "commission_taken" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reinsurer" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reinsurer_id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "re_company_name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "re_company_email" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "reinsurer_address",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "country" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "insurer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_company_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_company_email" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "insurer_company_website",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_address" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "suburb" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "region" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "country" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classofbusiness" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "class_of_business_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "business_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "business_details" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "created_at" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee_first_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee_last_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee_phonenumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee_email" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "emp_abbrv" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "place_it_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "thread_notification" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OffersQuery, OffersQueryVariables>;
export const GetReinsurerOffersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetReinsurerOffers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "args" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "OfferFiltersReinsurer" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "reinsurer_id" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getReinsurerOffersCount" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "reinsurer_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "reinsurer_id" },
                },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "getReinsurerOffers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "args" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "args" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offersoffer_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_participant_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_detail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currency" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "policy_number" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_participant_percentage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participant_fac_premium" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_extra_charges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_extra_charge_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "withholding_tax" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "agreed_commission" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nic_levy" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "agreed_brokerage_percentage",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_participant_payment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "offer_participant_payment_id",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_payment_amount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "paid_details" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "offer_participant_payment_comment",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "payment_status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "created_at" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updated_at" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_deduction_charge" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "offer_deduction_payment_id",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "nic_levy_paid" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "withholding_tax_paid",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "brokerage_amount_paid",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "commission_taken" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinsurer_offers_only" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_id" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "rate" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "premium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "brokerage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fac_premium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "facultative_offer" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "commission" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fac_sum_insured" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sum_insured" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "created_at" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "payment_status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "classofbusiness" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "business_name" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "class_of_business_id",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "business_details" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "insurer_company_name",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_detail" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "insured_by" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "currency" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "policy_number" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "period_of_insurance_from",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "period_of_insurance_to",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "offer_comment" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "offer_details" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetReinsurerOffersQuery,
  GetReinsurerOffersQueryVariables
>;
export const GetOfferParticipantDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOfferParticipant" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "participantId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOfferParticipant" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "participant_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "participantId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offersoffer_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_participant_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_participant_percentage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_amount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participant_fac_premium" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participant_fac_sum_insured" },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinsurer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reinsurer_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_abbrv" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_company_email" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_company_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reinsurer_address" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "country" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOfferParticipantQuery,
  GetOfferParticipantQueryVariables
>;
export const GetEndorsementParticipantDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEndorsementParticipant" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offerEndParticipantId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getEndorsementParticipant" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "offer_end_participant_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offerEndParticipantId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_end_participant_id" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "offer_end_participant_percentage",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_end_amount" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "offer_end_participant_fac_premium",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "offer_end_participant_fac_sum_insured",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "offer_endorsement_extra_charges",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "end_nic_levy" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "end_nic_levy_amount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "end_withholding_tax" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "end_agreed_brokerage_percentage",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "end_brokerage_amount" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "end_withholding_tax_amount",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "end_agreed_commission" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "end_agreed_commission_amount",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinsurer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reinsurer_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_company_name" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetEndorsementParticipantQuery,
  GetEndorsementParticipantQueryVariables
>;
export const GetOfferAssociatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOfferAssociates" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offerId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOfferAssociates" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "offer_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_to_associate_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "message_content" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "message_attachment" },
                },
                { kind: "Field", name: { kind: "Name", value: "sent_status" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offersoffer_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_participant_id" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "offer_participant_percentage",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_amount" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "participant_fac_premium",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "participant_fac_sum_insured",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "created_at" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinsurer_representative" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "reinsurer_representative_id",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reinsurersreinsurer_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rep_first_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rep_last_name" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "rep_primary_phonenumber",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "rep_secondary_phonenumber",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rep_email" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "position" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reinsurer" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "re_company_email" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "re_company_name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOfferAssociatesQuery,
  GetOfferAssociatesQueryVariables
>;
export const OfferFleetDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OfferFleet" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "policy_number" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "skip" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOfferFleet" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "policy_number" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "policy_number" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "skip" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "skip" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "offer_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "vehile_reg_no" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OfferFleetQuery, OfferFleetQueryVariables>;
export const OfferDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Offer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offer_id" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "findSingleOffer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "offer_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offer_id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "offer_id" } },
                { kind: "Field", name: { kind: "Name", value: "place_it_id" } },
                { kind: "Field", name: { kind: "Name", value: "offer_from" } },
                { kind: "Field", name: { kind: "Name", value: "rate" } },
                { kind: "Field", name: { kind: "Name", value: "commission" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "commission_amount" },
                },
                { kind: "Field", name: { kind: "Name", value: "brokerage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facultative_offer" },
                },
                { kind: "Field", name: { kind: "Name", value: "sum_insured" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fac_sum_insured" },
                },
                { kind: "Field", name: { kind: "Name", value: "premium" } },
                { kind: "Field", name: { kind: "Name", value: "fac_premium" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_status" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "payment_status" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "claim_status" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_published" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "published_status" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_detail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_detail_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offersoffer_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "policy_number" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insured_by" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "period_of_insurance_to" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "period_of_insurance_from",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currency" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_comment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_details" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_participant" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_participant_id" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "offer_participant_percentage",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_amount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reinsurer" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reinsurer_id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "re_company_name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "re_company_email" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "re_abbrv" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "thread_notification" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "offer_published_participant",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "offer_published_participant_id",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classofbusiness" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "class_of_business_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "business_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "business_details" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "business_category" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "created_at" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "insurer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_company_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_company_email" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "insurer_company_website",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_id" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_associates" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_to_associate_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sent_status" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "reinsurer_representative",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rep_email" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rep_first_name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rep_last_name" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "rep_primary_phonenumber",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "rep_secondary_phonenumber",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reinsurer" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "re_company_name",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "re_company_email",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_claims" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "claim_amount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "claim_comment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "claim_date" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "created_at" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_claim_id" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "offer_claim_participants",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "claim_share" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "created_at" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "offer_claim_participant_id",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "offer_claimsoffer_claim_id",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "offer_participant_percentage",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "offer_participantsoffer_participant_id",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "re_company_name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reinsurer_id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinsurer_offer_extra_charge" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_extra_charge_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nic_levy" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nic_levy_amount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "withholding_tax" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "withholding_tax_amount" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "agreed_brokerage_percentage",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "brokerage_amount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "agreed_commission" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "agreed_commission_amount",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "created_at" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_endorsements" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_endorsement_id" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "rate" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "commission" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "commission_amount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "brokerage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "facultative_offer" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "co_insurance_share" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sum_insured" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fac_sum_insured" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "premium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fac_premium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endorsement_status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "approval_status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "created_at" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updated_at" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OfferQuery, OfferQueryVariables>;
export const GetOfferClaimsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOfferClaims" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "args" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ClaimsFilter" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOfferClaims" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "args" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "args" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_claim_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "claim_amount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "claim_comment" },
                },
                { kind: "Field", name: { kind: "Name", value: "claim_date" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "rate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_detail" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "currency" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOfferClaimsQuery, GetOfferClaimsQueryVariables>;
export const GetClaimSharesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClaimShares" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offerClaimId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getClaimShares" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "offer_claim_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offerClaimId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_claim_participant_id" },
                },
                { kind: "Field", name: { kind: "Name", value: "claim_share" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_claimsoffer_claim_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinsurer_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "re_company_name" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "offer_participantsoffer_participant_id",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_participant_percentage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_claim" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_claim_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "claim_amount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "claim_date" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "created_at" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "claim_comment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_participant" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offersoffer_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_participant_id" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "offer_participant_percentage",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_amount" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "participant_fac_premium",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "participant_fac_sum_insured",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "created_at" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reinsurer" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "re_company_name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reinsurer_id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_detail" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "currency" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClaimSharesQuery, GetClaimSharesQueryVariables>;
export const GetClaimShareDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClaimShare" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offerClaimParticipantId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getClaimShare" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "offer_claim_participant_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offerClaimParticipantId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_claim_participant_id" },
                },
                { kind: "Field", name: { kind: "Name", value: "claim_share" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_claimsoffer_claim_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinsurer_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "re_company_name" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "offer_participantsoffer_participant_id",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_participant_percentage" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClaimShareQuery, GetClaimShareQueryVariables>;
export const GetOfferClaimParticipantPaymentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOfferClaimParticipantPayments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offerClaimParticipantId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOfferClaimParticipantPayments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "offer_claim_participant_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offerClaimParticipantId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "offer_claim_participant_payment_id",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "claim_share_payment_amount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "payment_details" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "payment_comment" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "payment_date" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "delete_status" },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_claim_participant" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "offer_claim_participant_id",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "claim_share" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "payment_status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "delete_status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "created_at" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updated_at" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_claim" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "offer_claim_id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "claim_amount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "claim_comment" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "claim_date" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "currency" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rate" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_participant" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "offer_participantsoffer_participant_id",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOfferClaimParticipantPaymentsQuery,
  GetOfferClaimParticipantPaymentsQueryVariables
>;
export const GetSupportingDocsListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSupportingDocsList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offerId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getSupportingDocsList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "offer_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offerId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSupportingDocsListQuery,
  GetSupportingDocsListQueryVariables
>;
export const GetNotAcceptedParticipantsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetNotAcceptedParticipants" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getNotAcceptedParticipants" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "offer_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "offer_published_participant_id",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_participant_percentage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "transaction_thread" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participation_status" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinsurer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reinsurer_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_company_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_company_email" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_company_website" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_abbrv" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetNotAcceptedParticipantsQuery,
  GetNotAcceptedParticipantsQueryVariables
>;
export const GetUserActivitiesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUserActivities" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ActivityFilter" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pagination" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "Pagination" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUserActivities" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filter" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "pagination" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "device_ip" } },
                { kind: "Field", name: { kind: "Name", value: "device_type" } },
                { kind: "Field", name: { kind: "Name", value: "country" } },
                { kind: "Field", name: { kind: "Name", value: "region" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserActivitiesQuery,
  GetUserActivitiesQueryVariables
>;
export const GetOfferPaymentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOfferPayments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "args" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "OfferPaymentInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOfferPayments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "args" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "args" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_payment_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "payment_amount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_payment_comment" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "payment_details" },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_id" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "rate" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "commission" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "commission_amount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "brokerage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "facultative_offer" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sum_insured" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fac_sum_insured" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "premium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fac_premium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "payment_status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "claim_status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "created_at" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updated_at" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "distribute_payment" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOfferPaymentsQuery,
  GetOfferPaymentsQueryVariables
>;
export const GetOfferPaymentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOfferPayment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOfferPayment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "payment_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_payment_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "payment_amount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_payment_comment" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "payment_details" },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_id" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "rate" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "commission" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "commission_amount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "brokerage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "facultative_offer" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sum_insured" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fac_sum_insured" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "premium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fac_premium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "payment_status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "claim_status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "created_at" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updated_at" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOfferPaymentQuery,
  GetOfferPaymentQueryVariables
>;
export const OfferparticipantDeductionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OfferparticipantDeductions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offer_id" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "payment_id" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOfferparticipantDeductions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "insurer_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offer_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offer_id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "payment_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "payment_id" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OfferparticipantDeductionsQuery,
  OfferparticipantDeductionsQueryVariables
>;
export const GetAllPointRedemptionUsagesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAllPointRedemptionUsages" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "broker_id" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllPointRedemptionUsages" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "broker_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "broker_id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "points_redemptions_id" },
                },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "prize" } },
                { kind: "Field", name: { kind: "Name", value: "voucher" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "redeemed_by" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assoc_first_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assoc_last_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assoc_email" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "assoc_primary_phonenumber",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "position" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAllPointRedemptionUsagesQuery,
  GetAllPointRedemptionUsagesQueryVariables
>;
export const GetPointRedemptionUsageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPointRedemptionUsage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "redemption_id" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPointRedemptionUsage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "redemption_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "redemption_id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "points_redemptions_id" },
                },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "prize" } },
                { kind: "Field", name: { kind: "Name", value: "voucher" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "redeemed_by" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assoc_first_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assoc_last_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assoc_email" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "assoc_primary_phonenumber",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "position" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPointRedemptionUsageQuery,
  GetPointRedemptionUsageQueryVariables
>;
export const PublishedOffersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PublishedOffers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offerStatus" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "OfferStatus" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "publishedOffers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "OfferStatus" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offerStatus" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_published_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "published_status" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employeesemployee_id" },
                },
                { kind: "Field", name: { kind: "Name", value: "updated_by" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "time_of_expiry" },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee_first_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee_email" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "emp_abbrv" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee_last_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee_phonenumber" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_id" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PublishedOffersQuery,
  PublishedOffersQueryVariables
>;
export const QueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Query" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offerStatus" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "OfferStatus" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "publishedOffersCount" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "OfferStatus" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offerStatus" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QueryQuery, QueryQueryVariables>;
export const GetOfferPublishedParticipantsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOfferPublishedParticipants" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOfferPublishedParticipants" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "offer_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "offer_published_participant_id",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinsurer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reinsurer_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_company_website" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_company_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_company_email" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_abbrv" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinsurer_representative" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rep_first_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rep_last_name" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "rep_primary_phonenumber",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "rep_secondary_phonenumber",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rep_email" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "reinsurer_representative_id",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "position" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "delete_status" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_participant_percentage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "transaction_thread" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participation_status" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "facultative_offer" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unread_messages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "offer_id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "receiver_type" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "offer_published_participant_id",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOfferPublishedParticipantsQuery,
  GetOfferPublishedParticipantsQueryVariables
>;
export const ReinsurersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Reinsurers" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "count" },
            name: { kind: "Name", value: "getReinsurersCount" },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "rows" },
            name: { kind: "Name", value: "reinsurers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "re_abbrv" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "re_company_email" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "re_company_name" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "re_company_website" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinsurer_address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "region" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reinsurer_address_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "street" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "suburb" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinsurer_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinsurer_representatives" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "reinsurer_representative_id",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReinsurersQuery, ReinsurersQueryVariables>;
export const GetReinsurerParticipantPaymentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetReinsurerParticipantPayments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offerParticipantId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getReinsurerParticipantPayments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "offer_participant_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offerParticipantId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_participant_payment_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_payment_amount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paid_details" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "offer_participant_payment_comment",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "payment_status" },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_deduction_charge" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "offer_deduction_payment_id",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nic_levy_paid" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "withholding_tax_paid" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "brokerage_amount_paid" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "commission_taken" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetReinsurerParticipantPaymentsQuery,
  GetReinsurerParticipantPaymentsQueryVariables
>;
export const GetReinsurerParticipantPaymentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetReinsurerParticipantPayment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "participant_payment_id" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getReinsurerParticipantPayment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "participant_payment_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "participant_payment_id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_participant_payment_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_payment_amount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paid_details" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "offer_participant_payment_comment",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "payment_status" },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_deduction_charge" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "offer_deduction_payment_id",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nic_levy_paid" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "withholding_tax_paid" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "brokerage_amount_paid" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "commission_taken" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetReinsurerParticipantPaymentQuery,
  GetReinsurerParticipantPaymentQueryVariables
>;
export const GetReinsurerAssociatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetReinsurerAssociates" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "reinsurerId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pagination" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "Pagination" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getReinsurerAssociates" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "reinsurer_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "reinsurerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "pagination" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinsurer_representative_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinsurersreinsurer_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rep_first_name" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rep_last_name" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rep_primary_phonenumber" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rep_secondary_phonenumber" },
                },
                { kind: "Field", name: { kind: "Name", value: "rep_email" } },
                { kind: "Field", name: { kind: "Name", value: "position" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinsurer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_abbrv" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_company_email" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_company_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_company_website" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reinsurer_id" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "count" },
            name: { kind: "Name", value: "getReinsurerAssociatesCount" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "reinsurer_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "reinsurerId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetReinsurerAssociatesQuery,
  GetReinsurerAssociatesQueryVariables
>;
export const GetReinsurerRepDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetReinsurerRep" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "repId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getReinsurerRep" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "rep_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "repId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinsurer_representative_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinsurersreinsurer_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rep_first_name" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rep_last_name" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rep_primary_phonenumber" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rep_secondary_phonenumber" },
                },
                { kind: "Field", name: { kind: "Name", value: "rep_email" } },
                { kind: "Field", name: { kind: "Name", value: "position" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetReinsurerRepQuery,
  GetReinsurerRepQueryVariables
>;
export const GetReinsurerRepsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetReinsurerReps" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getReinsurerReps" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinsurer_representative_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinsurersreinsurer_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rep_first_name" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rep_last_name" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rep_primary_phonenumber" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rep_secondary_phonenumber" },
                },
                { kind: "Field", name: { kind: "Name", value: "rep_email" } },
                { kind: "Field", name: { kind: "Name", value: "position" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinsurer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_abbrv" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_company_email" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_company_name" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetReinsurerRepsQuery,
  GetReinsurerRepsQueryVariables
>;
export const ReinsurerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Reinsurer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "reinsurerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reinsurer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "reinsurer_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "reinsurerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinsurer_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "re_company_name" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "re_company_email" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "re_company_website" },
                },
                { kind: "Field", name: { kind: "Name", value: "re_abbrv" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinsurer_address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reinsurer_address_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "street" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "suburb" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "region" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinsurer_overview" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "brokerage_chart" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_brokerage_amt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_closed" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_fac_premium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_nic_tax" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_paid" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_pending" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_unpaid" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_withholding_tax" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReinsurerQuery, ReinsurerQueryVariables>;
export const ReportOnQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ReportOnQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "Query_data" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reportOnQuery" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "query_data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "data" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReportOnQueryMutation,
  ReportOnQueryMutationVariables
>;
export const GetPaidChequesForStatementDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaidChequesForStatement" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaidChequesForStatement" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cheque_number" },
                },
                { kind: "Field", name: { kind: "Name", value: "reinsured" } },
                { kind: "Field", name: { kind: "Name", value: "offer_ids" } },
                { kind: "Field", name: { kind: "Name", value: "payment_ids" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPaidChequesForStatementQuery,
  GetPaidChequesForStatementQueryVariables
>;
export const GetBatchReportsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetBatchReports" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "BatchReportFilter" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pagination" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "Pagination" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "count" },
            name: { kind: "Name", value: "getBatchReportsCount" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filter" },
                },
              },
            ],
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "data" },
            name: { kind: "Name", value: "getBatchReports" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filter" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "pagination" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "report_id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "request_body" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "downloadable_xlsx_link" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "downloadable_pdf_link" },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee_first_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee_last_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee_phonenumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee_email" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "emp_abbrv" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "accept_waiver_aggreement",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "waiver_accepted_at" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetBatchReportsQuery,
  GetBatchReportsQueryVariables
>;
export const FetchTargetBadgeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FetchTargetBadge" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "target_badge_id" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fetchTargetBadge" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "target_badge_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "target_badge_id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "min_points" } },
                { kind: "Field", name: { kind: "Name", value: "max_points" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cash_equivalent" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "minimum_cash_equivalent" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "gift_basket" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gift_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gift_type" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gift_image" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gift_description" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchTargetBadgeQuery,
  FetchTargetBadgeQueryVariables
>;
export const FetchTargetRatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FetchTargetRates" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "targetId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fetchTargetRates" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "target_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "targetId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "target_id" } },
                { kind: "Field", name: { kind: "Name", value: "rate_value" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currency_code" },
                },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchTargetRatesQuery,
  FetchTargetRatesQueryVariables
>;
export const FetchTargetRateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FetchTargetRate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "targetRateId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fetchTargetRate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "target_rate_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "targetRateId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "rate_value" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currency_code" },
                },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchTargetRateQuery,
  FetchTargetRateQueryVariables
>;
export const FetchTargetsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FetchTargets" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "brokerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fetchTargets" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "broker_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "brokerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "broker_id" } },
                { kind: "Field", name: { kind: "Name", value: "target_name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "base_currency" },
                },
                { kind: "Field", name: { kind: "Name", value: "start_date" } },
                { kind: "Field", name: { kind: "Name", value: "end_date" } },
                { kind: "Field", name: { kind: "Name", value: "insurer_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "target_badges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "min_points" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "max_points" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "minimum_cash_equivalent",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cash_equivalent" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gift_basket" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "gift_name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "gift_type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "gift_image" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "gift_description" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchTargetsQuery, FetchTargetsQueryVariables>;
export const FetchTargetDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FetchTarget" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "targetId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fetchTarget" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "target_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "targetId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "broker_id" } },
                { kind: "Field", name: { kind: "Name", value: "target_name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "base_currency" },
                },
                { kind: "Field", name: { kind: "Name", value: "start_date" } },
                { kind: "Field", name: { kind: "Name", value: "end_date" } },
                { kind: "Field", name: { kind: "Name", value: "insurer_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "target_badges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "min_points" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "max_points" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "minimum_cash_equivalent",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cash_equivalent" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gift_basket" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "gift_name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "gift_type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "gift_image" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "gift_description" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchTargetQuery, FetchTargetQueryVariables>;
export const GetTreatiesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTreaties" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "args" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "TreatyFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "rows" },
            name: { kind: "Name", value: "getTreaties" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "args" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "args" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "treaty_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_reference" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "kek_reference" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_details" },
                },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "order_hereon" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_payment_status" },
                },
                { kind: "Field", name: { kind: "Name", value: "layer_limit" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "insurer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_company_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_company_email" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "insurer_company_website",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_abbrv" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_program" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_type" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_deduction" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_period_from" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_period_to" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee_first_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee_last_name" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "count" },
            name: { kind: "Name", value: "getTreatiesCount" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "args" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "args" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTreatiesQuery, GetTreatiesQueryVariables>;
export const GetNonProportionalTreatyPaymentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetNonProportionalTreatyPayments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "TreatyPaymentFilter" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getNonProportionalTreatyPayments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filter" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "installment_type" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_payment_amount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_payment_details" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_payment_comment" },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_n_p_payment_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "distribute_payment" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetNonProportionalTreatyPaymentsQuery,
  GetNonProportionalTreatyPaymentsQueryVariables
>;
export const GetNonProportionalReceivablePaymentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetNonProportionalReceivablePayments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "treatyId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "rows" },
            name: {
              kind: "Name",
              value: "getNonProportionalReceivablePayments",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "treaty_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "treatyId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "receivable_payment_id" },
                },
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "payment_amount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "payment_detail" },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_participant" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "treaty_participation_id",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "treaty_participation_percentage",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "layer_number" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_reference" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "kek_reference" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_details" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currency" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "order_hereon" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_payment_status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "layer_limit" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "count" },
            name: {
              kind: "Name",
              value: "getNonProportionalReceivablePaymentsLength",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "treaty_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "treatyId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetNonProportionalReceivablePaymentsQuery,
  GetNonProportionalReceivablePaymentsQueryVariables
>;
export const DistributePaymentForTreatyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DistributePaymentForTreaty" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "treatyId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "paymentInformation" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "TreatyPaymentDistribution" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "treatyPaymentId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "TreatyType" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "distributePaymentForTreaty" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "treaty_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "treatyId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "payment_information" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "paymentInformation" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "treaty_payment_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "treatyPaymentId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "type" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "type" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DistributePaymentForTreatyMutation,
  DistributePaymentForTreatyMutationVariables
>;
export const GetNonProportionalTreatyPaymentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetNonProportionalTreatyPayment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "treatyNpPaymentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getNonProportionalTreatyPayment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "treaty_np_payment_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "treatyNpPaymentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "installment_type" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_payment_amount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_payment_details" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_payment_comment" },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_n_p_payment_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "distribute_payment" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_participant_payment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "treaty_participants_payment_id",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "participant_payment_amount",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "participant_payment_details",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "participant_payment_comment",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "participant_payment_status",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "surpulus_uuid" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nic_levy_paid" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "withholding_tax_paid" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "brokerage_paid" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "commission_paid" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "treaty_np_paymentstreaty_np_payment_id",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "treaty_participationstreaty_participation_id",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "treaty_p_paymentstreaty_p_payment_id",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "created_at" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updated_at" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "date_of_receipt" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetNonProportionalTreatyPaymentQuery,
  GetNonProportionalTreatyPaymentQueryVariables
>;
export const GetProportionalTreatyPaymentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetProportionalTreatyPayments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "TreatyPaymentFilter" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getProportionalTreatyPayments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filter" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_p_payment_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_payment_amount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_payment_details" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_payment_comment" },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "treaty_accountstreaty_account_id",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "surpulus_uuid" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "distribute_payment" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_accounts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "account_periods" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetProportionalTreatyPaymentsQuery,
  GetProportionalTreatyPaymentsQueryVariables
>;
export const GetProportionalTreatyPaymentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetProportionalTreatyPayment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "treatyPaymentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getProportionalTreatyPayment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "treaty_payment_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "treatyPaymentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_p_payment_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_payment_amount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_payment_details" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_payment_comment" },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "treaty_accountstreaty_account_id",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "surpulus_uuid" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "distribute_payment" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_participant_payment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "treaty_participants_payment_id",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "participant_payment_amount",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "participant_payment_details",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "participant_payment_comment",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "participant_payment_status",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "surpulus_uuid" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nic_levy_paid" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "withholding_tax_paid" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "brokerage_paid" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "commission_paid" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "treaty_np_paymentstreaty_np_payment_id",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "treaty_participationstreaty_participation_id",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "treaty_p_paymentstreaty_p_payment_id",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "created_at" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updated_at" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "date_of_receipt" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetProportionalTreatyPaymentQuery,
  GetProportionalTreatyPaymentQueryVariables
>;
export const TreatyYearsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "TreatyYears" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "insurerId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "treatyYears" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "insurer_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "insurerId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TreatyYearsQuery, TreatyYearsQueryVariables>;
export const TreatyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Treaty" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "treatyId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "treaty" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "treaty_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "treatyId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "treaty_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_reference" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "kek_reference" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_details" },
                },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "order_hereon" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_payment_status" },
                },
                { kind: "Field", name: { kind: "Name", value: "layer_limit" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "insurer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_company_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_abbrv" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_program" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_program_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_type" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_deduction" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "treaty_associate_deduction_id",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "commission" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "brokerage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nic_levy" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "withholding_tax" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_period_from" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_period_to" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_to_associates" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_to_associate_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sent_status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "layer_number" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "reinsurer_representative",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rep_first_name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rep_last_name" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "rep_primary_phonenumber",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "rep_secondary_phonenumber",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rep_email" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "position" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "treaty_participation_id",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "treaty_participation_percentage",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "layer_number" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reinsurer" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "re_company_email" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "re_company_name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reinsurer_id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "re_abbrv" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "treaty_participant_deductions",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "treaty_participant_deduction_id",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "treaty_accountstreaty_account_id",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value:
                                  "treaty_participationstreaty_participation_id",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "uuid" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "brokerage" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "brokerage_amount" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "commission_amount",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "nic_levy_amount" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "withholding_tax_amount",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "treaty_participation_share",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "nic_levy" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "withholding_tax" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "commission" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "re_broker_treaties_participation",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "re_broker_treaties_participation_id",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "share_percentage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "admin_percentage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "payment_status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_broker" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "re_broker_id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "re_broker_email" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "re_broker_name" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "re_broker_website",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_accounts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_account_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "account_periods" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gross_premium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "claim_settled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cash_loss" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "exchange_rate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "account_year" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "payment_status" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "treaty_account_deduction",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "treaty_account_deduction_id",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "surpulus_uuid" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "gross_premium" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "commission_amount",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "brokerage_amount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "claim_settled" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "cash_loss" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "withholding_tax_amount",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "nic_levy_amount" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_np_detail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_np_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "egrnpi" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "burning_cost_rate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "loaded_burning_cost" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pure_burning_cost" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "adjustment_created" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "outstanding_payment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "claims_paid" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "created_at" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_proportional_detail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "treaty_proportional_detail_id",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "profit_commission" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_mgmt_expense" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "portfolio_entry" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "ernpi" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "overall_gross_premium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "losses_outstanding" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "created_at" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "prev_year_configuration",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "portfolio_entry_compute",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TreatyQuery, TreatyQueryVariables>;
export const GetTreatyEndorsementDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTreatyEndorsement" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "TreatyEndorsementFilter" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTreatyEndorsement" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filter" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_endorsement_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treatiestreaty_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "endorsement_comment" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employeesemployee_id" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTreatyEndorsementQuery,
  GetTreatyEndorsementQueryVariables
>;
export const GetTreatyEndorsementsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTreatyEndorsements" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "TreatyEndorsementFilter" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTreatyEndorsements" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filter" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_endorsement_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treatiestreaty_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "endorsement_comment" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employeesemployee_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee_first_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee_last_name" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTreatyEndorsementsQuery,
  GetTreatyEndorsementsQueryVariables
>;
export const GetTreatyBrokersParticipantsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTreatyBrokersParticipants" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "treatyId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTreatyBrokersParticipants" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "treaty_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "treatyId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "re_broker_treaties_participation_id",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "share_percentage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "admin_percentage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "payment_status" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "re_broker" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_broker_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_broker_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_broker_email" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_broker_website" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTreatyBrokersParticipantsQuery,
  GetTreatyBrokersParticipantsQueryVariables
>;
export const GetTreatyReinsurerParticipantsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTreatyReinsurerParticipants" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "treatyId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTreatyReinsurerParticipants" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "treaty_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "treatyId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_participation_id" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "treaty_participation_percentage",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "layer_number" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinsurer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_company_email" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_abbrv" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_company_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_company_website" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reinsurer_id" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "treaty_participant_deductions",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "treaty_participant_deduction_id",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "treaty_accountstreaty_account_id",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "treaty_participationstreaty_participation_id",
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "uuid" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "brokerage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "brokerage_amount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "commission_amount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nic_levy_amount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "withholding_tax_amount" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "treaty_participation_share",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nic_levy" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "withholding_tax" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "commission" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTreatyReinsurerParticipantsQuery,
  GetTreatyReinsurerParticipantsQueryVariables
>;
export const GetTreatyReinsurerAssociatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTreatyReinsurerAssociates" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "treatyId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTreatyReinsurerAssociates" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "treaty_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "treatyId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_to_associate_id" },
                },
                { kind: "Field", name: { kind: "Name", value: "sent_status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "layer_number" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinsurer_representative" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "reinsurer_representative_id",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reinsurersreinsurer_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rep_first_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rep_last_name" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "rep_primary_phonenumber",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "rep_secondary_phonenumber",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rep_email" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "position" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinsurer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_company_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_company_email" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTreatyReinsurerAssociatesQuery,
  GetTreatyReinsurerAssociatesQueryVariables
>;
export const GetTreatyReinsurerParticipationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTreatyReinsurerParticipation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "participationId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTreatyReinsurerParticipation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "participation_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "participationId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_participation_id" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "treaty_participation_percentage",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "layer_number" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinsurer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_company_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reinsurer_id" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTreatyReinsurerParticipationQuery,
  GetTreatyReinsurerParticipationQueryVariables
>;
export const GetTreatyBrokerParticipationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTreatyBrokerParticipation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "reBrokerTreatiesParticipationId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTreatyBrokerParticipation" },
            arguments: [
              {
                kind: "Argument",
                name: {
                  kind: "Name",
                  value: "re_broker_treaties_participation_id",
                },
                value: {
                  kind: "Variable",
                  name: {
                    kind: "Name",
                    value: "reBrokerTreatiesParticipationId",
                  },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "re_broker_treaties_participation_id",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "share_percentage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "admin_percentage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "payment_status" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "re_broker" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_broker_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_broker_id" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTreatyBrokerParticipationQuery,
  GetTreatyBrokerParticipationQueryVariables
>;
export const GetTreatyBrokerAssociatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTreatyBrokerAssociates" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "treatyId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTreatyBrokerAssociates" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "treaty_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "treatyId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "participation_to_broker_associate_id",
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "sent_status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "message_content" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "broker_associate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_broker_associate_id" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "re_broker_assoc_first_name",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "re_broker_assoc_last_name",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "re_broker_assoc_primary_phone",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "re_broker_assoc_secondary_phone",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "re_broker_assoc_position",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "re_broker_assoc_email" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTreatyBrokerAssociatesQuery,
  GetTreatyBrokerAssociatesQueryVariables
>;
export const FetchTreatyAccountsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FetchTreatyAccounts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "insurer_id" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "treaty_program_name" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "treaty_period_from" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "treaty_period_to" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "quarter" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fetchTreatyAccounts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "insurer_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "insurer_id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "treaty_period_to" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "treaty_period_to" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "treaty_period_from" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "treaty_period_from" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "type" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "type" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "treaty_program_name" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "treaty_program_name" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "quarter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "quarter" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "treaty_id" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "quarters" } },
                { kind: "Field", name: { kind: "Name", value: "quarter" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "account_year" },
                },
                { kind: "Field", name: { kind: "Name", value: "layer_limit" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "surpluses" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gross_premium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "claim_settled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cash_loss" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchTreatyAccountsQuery,
  FetchTreatyAccountsQueryVariables
>;
export const GetTreatyClaimPaymentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTreatyClaimPayments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "treatyClaimId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "participantId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTreatyClaimPayments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "treaty_claim_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "treatyClaimId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "participant_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "participantId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_claim_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participant_id" },
                },
                { kind: "Field", name: { kind: "Name", value: "reinsurer" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "payment_uuid" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "payment_amount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "payment_detail" },
                },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participant" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "percentage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "layer_number" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "payment_id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTreatyClaimPaymentsQuery,
  GetTreatyClaimPaymentsQueryVariables
>;
export const GetTreatyClaimsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTreatyClaims" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "treatyId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "insurerId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTreatyClaimsCount" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "treaty_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "treatyId" },
                },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "getTreatyClaims" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "treaty_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "treatyId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "insurer_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "insurerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_claim_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "policy_number" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "claim_number" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "insured_name" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "date_of_loss" },
                },
                { kind: "Field", name: { kind: "Name", value: "claim_date" } },
                { kind: "Field", name: { kind: "Name", value: "claim_paid" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "layer_number" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expected_deductible" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_comment" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_claim_details" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinstatement_premium" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_reference" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "kek_reference" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_details" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currency" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "order_hereon" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_payment_status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "layer_limit" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "insurer_company_name",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_participants" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "treaty_participation_id",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "treaty_participation_percentage",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "layer_number" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reinsurer" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "re_company_email",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "re_abbrv" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "re_company_name",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_program" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "treaty_name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTreatyClaimsQuery,
  GetTreatyClaimsQueryVariables
>;
export const GetTreatyClaimDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTreatyClaim" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "treatyClaimId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTreatyClaim" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "treaty_claim_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "treatyClaimId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_claim_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "policy_number" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "claim_number" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "insured_name" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "date_of_loss" },
                },
                { kind: "Field", name: { kind: "Name", value: "claim_date" } },
                { kind: "Field", name: { kind: "Name", value: "claim_paid" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "layer_number" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expected_deductible" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_comment" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_claim_details" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reinstatement_premium" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_reference" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "kek_reference" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_details" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currency" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "order_hereon" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_payment_status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "layer_limit" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_program" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "insurer" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "insurer_company_name",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "treaty_name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "treaty_type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "treaty_details" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTreatyClaimQuery, GetTreatyClaimQueryVariables>;
export const GetTreatyClaimSharesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTreatyClaimShares" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "treatyClaimId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTreatyClaimShares" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "treaty_claim_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "treatyClaimId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_claim_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participant_id" },
                },
                { kind: "Field", name: { kind: "Name", value: "reinsurer" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "claim_paid" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "claim_payment_share" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTreatyClaimSharesQuery,
  GetTreatyClaimSharesQueryVariables
>;
export const GetTreatyClaimShareDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTreatyClaimShare" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "treatyClaimId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "participantId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTreatyClaimShare" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "treaty_claim_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "treatyClaimId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "participant_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "participantId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_claim_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participant_id" },
                },
                { kind: "Field", name: { kind: "Name", value: "reinsurer" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "claim_paid" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "claim_payment_share" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTreatyClaimShareQuery,
  GetTreatyClaimShareQueryVariables
>;
export const TreatyProgramsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "TreatyPrograms" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "args" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "TreatyProgramFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "rows" },
            name: { kind: "Name", value: "getTreatyPrograms" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "args" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "args" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_program_id" },
                },
                { kind: "Field", name: { kind: "Name", value: "treaty_name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_details" },
                },
                { kind: "Field", name: { kind: "Name", value: "treaty_type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "insurer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_abbrv" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_company_email" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_company_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_id" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_associate_deductions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "treaty_associate_deduction_id",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "commission" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "brokerage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nic_levy" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "withholding_tax" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_period_from" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_period_to" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "count" },
            name: { kind: "Name", value: "getTreatyProgramsCount" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "args" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "args" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TreatyProgramsQuery, TreatyProgramsQueryVariables>;
export const TreatyProgramDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "TreatyProgram" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "programId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "treatyProgram" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "program_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "programId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_program_id" },
                },
                { kind: "Field", name: { kind: "Name", value: "treaty_name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_details" },
                },
                { kind: "Field", name: { kind: "Name", value: "treaty_type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "insurer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_abbrv" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_company_email" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_company_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_id" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_associate_deductions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "treaty_associate_deduction_id",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "commission" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "brokerage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nic_levy" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "withholding_tax" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_period_from" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_period_to" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TreatyProgramQuery, TreatyProgramQueryVariables>;
export const GetTreatyProgramDeductionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTreatyProgramDeductions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "treatyProgramId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTreatyProgramDeductions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "treaty_program_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "treatyProgramId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "treaty_associate_deduction_id",
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "commission" } },
                { kind: "Field", name: { kind: "Name", value: "brokerage" } },
                { kind: "Field", name: { kind: "Name", value: "nic_levy" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "withholding_tax" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_period_from" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_period_to" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTreatyProgramDeductionsQuery,
  GetTreatyProgramDeductionsQueryVariables
>;
export const GetTreatyProgramDeductionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTreatyProgramDeduction" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "treatyAssociateDeductionId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTreatyProgramDeduction" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "treaty_associate_deduction_id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "treatyAssociateDeductionId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "treaty_associate_deduction_id",
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "commission" } },
                { kind: "Field", name: { kind: "Name", value: "brokerage" } },
                { kind: "Field", name: { kind: "Name", value: "nic_levy" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "withholding_tax" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_period_from" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_period_to" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treaty_program" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_program_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_details" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treaty_type" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTreatyProgramDeductionQuery,
  GetTreatyProgramDeductionQueryVariables
>;
export const GetUnReadNotificationMessagesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUnReadNotificationMessages" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUnReadNotificationMessages" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_detail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "policy_number" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insured_by" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "period_of_insurance_from",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "period_of_insurance_to" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "thread_notification" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "insurer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_company_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer_id" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer_status" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "payment_status" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classofbusiness" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "business_name" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUnReadNotificationMessagesQuery,
  GetUnReadNotificationMessagesQueryVariables
>;
export const FetchUnreadTransactionThreadMessagesForBrokerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "FetchUnreadTransactionThreadMessagesForBroker",
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "fetchUnreadTransactionThreadMessagesForBroker",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "receiver_type" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_id" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "rate" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "commission" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "commission_amount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "brokerage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "facultative_offer" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sum_insured" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fac_sum_insured" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "premium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fac_premium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "payment_status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "claim_status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "expiry_status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "created_at" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updated_at" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_from" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "place_it_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offer_detail" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "offer_detail_id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "offersoffer_id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "policy_number" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "insured_by" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "period_of_insurance_from",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "period_of_insurance_to",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "currency" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "offer_comment" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "offer_details" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "updated_at" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "thread_notification" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "classofbusiness" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "class_of_business_id",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "business_name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "business_details" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "business_category",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "single_total_overview",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "single_total_offers",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "created_at" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insurer" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "insurer_id" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "insurer_company_name",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "insurer_company_email",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "insurer_company_website",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "insurer_abbrv" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchUnreadTransactionThreadMessagesForBrokerQuery,
  FetchUnreadTransactionThreadMessagesForBrokerQueryVariables
>;
